import React, { useState, useEffect, useContext, useMemo, useRef, useCallback } from 'react';

import {

  Box,

  Drawer,

  AppBar,

  Toolbar,

  List,

  Typography,

  Divider,

  IconButton,

  ListItem,

  ListItemButton,

  ListItemIcon,

  ListItemText,

  Avatar,

  Menu,

  MenuItem,

  useTheme,

  useMediaQuery,

  Badge,

  Tooltip,

  Chip,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  Button,

  TextField,

  Grid,

  LinearProgress,
  Stack,

  FormControlLabel,

  Switch,

  Collapse,

  Popover,

  Snackbar,

  Alert

} from '@mui/material';

import {

  Menu as MenuIcon,
  Visibility,

  Dashboard,

  People,

  Settings as SettingsIcon,

  Assessment,

  AccountCircle,

  Logout,

  ChevronLeft,

  Notifications,

  CloudUpload,

  PhoneEnabled,

  PhoneDisabled,

  Phone,

  Dialpad,

  CallEnd,

  Mic,

  MicOff,

  Backspace,

  Clear,

  CallReceived,

  Person,

  PushPin,

  PushPinOutlined,

  ExpandLess,

  ExpandMore,
  ImageSearch,
  Brush,
  DeleteForever,
  CheckCircle,
  DoNotDisturb,
  Pause,
  EventBusy,
  Coffee,
  Wc,
  Restaurant,
  Hotel,
  MenuBook,
  PowerSettingsNew,
  PhonePaused,
  CallMade,
  Edit,
  SwapHoriz,
  CallMerge,
  PlayArrow,
  Groups

} from '@mui/icons-material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';

import LanIcon from '@mui/icons-material/Lan';

import AccountTreeIcon from '@mui/icons-material/AccountTree';

import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

import { useSoftphone } from '../../contexts/SoftphoneContext';

import { useAgent } from '../../contexts/AgentContext';

import { ApiContext } from '../../contexts/ApiContext';

import { useNotification } from '../../contexts/NotificationContext';

import { DialerProvider } from '../../contexts/DialerContext';

import Softphone from '../softphone/SoftphoneSfu';
import SupervisorMonitorSfu from '../softphone/SupervisorMonitorSfu';

import CallTypificationPanel from '../call/CallTypificationPanel';

import ClientDataPanel from '../softphone/ClientDataPanel';

import AvatarSelector from '../common/AvatarSelector';

import AvatarCreator from '../common/AvatarCreator';
import AnimatedLogo from '../common/AnimatedLogo';
import {
  getAgentStatusLabel,
  getAgentStatusColor
} from '../../constants/agentStatus';

import Inventory2Icon from '@mui/icons-material/Inventory2';

import CampaignIcon from '@mui/icons-material/Campaign';

import SettingsEthernetIcon from '@mui/icons-material/AltRoute';

import GraphicEqIcon from '@mui/icons-material/GraphicEq';

import SourceIcon from '@mui/icons-material/Source';

import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import InsightsIcon from '@mui/icons-material/Insights';

import SmartToyIcon from '@mui/icons-material/SmartToy';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SecurityIcon from '@mui/icons-material/Security';
import { usePermissions } from '../../hooks/usePermissions';

import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

import BarChartIcon from '@mui/icons-material/BarChart';

import ListAltIcon from '@mui/icons-material/ListAlt';

import HistoryIcon from '@mui/icons-material/History';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import MonitorIcon from '@mui/icons-material/Monitor';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import StopScreenShareIcon from '@mui/icons-material/StopScreenShare';

import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WebhookIcon from '@mui/icons-material/Webhook';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import logger from '../../utils/logger';
import { ChatProvider, useChat } from '../../contexts/ChatContext';
import ChatBubbles from '../chat/ChatBubbles';

// Standalone component to wrap chat icon with unread badge
const ChatBadgeIcon = ({ children }) => {
  const chatCtx = useChat();
  const totalUnread = chatCtx?.totalUnread || 0;
  if (totalUnread > 0) {
    return (
      <Badge badgeContent={totalUnread} color="error" sx={{ '& .MuiBadge-badge': { fontSize: 10, minWidth: 16, height: 16, right: -3, top: -3 } }}>
        {children}
      </Badge>
    );
  }
  return <>{children}</>;
};



const drawerWidth = 280;
const drawerMiniWidth = 72;

// Helpers to persist interaction context in sessionStorage
const INTERACTION_KEY = 'ctiInteractionContext';
const SKILL_CONFIG_CACHE_KEY = 'ctiSkillConfigCache';
const ENDS_CACHE_KEY = 'ctiEndsCache';
const loadInteractionCache = () => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(INTERACTION_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    logger.warn('[INTERACTION] Failed to load from sessionStorage:', err);
    return {};
  }
};
const saveInteractionCache = (payload) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(INTERACTION_KEY, JSON.stringify(payload));
  } catch (err) {
    logger.warn('[INTERACTION] Failed to save to sessionStorage:', err);
  }
};
const clearInteractionCache = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(INTERACTION_KEY);
  } catch (err) {
    logger.warn('[INTERACTION] Failed to clear sessionStorage:', err);
  }
};

const loadSkillConfigCache = () => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(SKILL_CONFIG_CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    logger.warn('[SKILL-CACHE] Failed to load from sessionStorage:', err);
    return {};
  }
};

const saveSkillConfigCache = (payload) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(SKILL_CONFIG_CACHE_KEY, JSON.stringify(payload));
  } catch (err) {
    logger.warn('[SKILL-CACHE] Failed to save to sessionStorage:', err);
  }
};
const loadEndsCache = () => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(ENDS_CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    logger.warn('[ENDS-CACHE] Failed to load from sessionStorage:', err);
    return {};
  }
};
const saveEndsCache = (payload) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(ENDS_CACHE_KEY, JSON.stringify(payload));
  } catch (err) {
    logger.warn('[ENDS-CACHE] Failed to save to sessionStorage:', err);
  }
};

// Ya no necesario - todos los estados se envían al backend para que el supervisor los vea

// const FRONTEND_ONLY_STATUSES = ['PRECALL', 'INCALL', 'ACW'];



const allMenuItems = [
  // Items universales (visibles para todos los autenticados)
  { text: 'Mi Escritorio', icon: <Dashboard />, path: '/dashboard', module: 'dashboard' },
  { text: 'Mis Llamadas', icon: <BookmarkIcon />, path: '/agent-calls', module: 'agent-calls' },
  { text: 'Muro', icon: <DynamicFeedIcon />, path: '/wall', module: 'wall' },
  { text: 'Chat', icon: <ForumOutlinedIcon />, path: '/chat', module: 'chat' },

  // Administración
  { text: 'Extensiones', icon: <LanIcon />, path: '/extensions', module: 'extensions' },
  { text: 'Troncales', icon: <SettingsEthernetIcon />, path: '/trunks', module: 'trunks' },
  { text: 'AMD', icon: <GraphicEqIcon />, path: '/amd', module: 'amd' },
  { text: 'Campañas', icon: <CampaignIcon />, path: '/campaigns', module: 'campaigns' },
  { text: 'Estructura de datos', icon: <Inventory2Icon />, path: '/datastructures', module: 'datastructures' },
  { text: 'Agentes', icon: <People />, path: '/agents', module: 'agents' },
  { text: 'Asignación de Skills', icon: <AssignmentInd />, path: '/skill-assignment', module: 'skill-assignment' },
  { text: 'Dialplans', icon: <SourceIcon/>, path: '/dialplans', module: 'dialplans' },
  { text: 'Skills', icon: <SettingsIcon />, path: '/skills', module: 'skills' },
  { text: 'Estado del Motor', icon: <MonitorHeartIcon />, path: '/engine-status', module: 'engine-status' },

  // Supervisión
  { text: 'Supervisor de Agentes', icon: <SupervisorAccountIcon />, path: '/supervision/agents', module: 'supervisor' },
  { text: 'Centro de Monitoreo', icon: <MonitorIcon />, path: '/supervision/monitoring-center', module: 'monitoring-center' },
  { text: 'Supervisión de Skills', icon: <BarChartIcon />, path: '/supervision/skills', module: 'skill-supervisor' },
  { text: 'Monitor de Skills', icon: <InsightsIcon />, path: '/supervision/skills-monitor', module: 'skill-monitor' },
  { text: 'Supervisión de Colas', icon: <ListAltIcon />, path: '/supervision/queues', module: 'queue-supervisor' },
  { text: 'Supervisión de Llamadas', icon: <HistoryIcon />, path: '/supervision/call-logs', module: 'call-logs' },

  // Herramientas
  { text: 'Simulador', icon: <SmartToyIcon />, path: '/simulator', module: 'simulator' },
  { text: 'Finales', icon: <AccountTreeIcon />, path: '/ends', module: 'ends' },
  { text: 'Workflows', icon: <AccountTreeOutlinedIcon />, path: '/workflows', module: 'workflows' },
  { text: 'Cargas', icon: <CloudUpload />, path: '/loads', module: 'loads' },
  { text: 'API Tokens', icon: <VpnKeyIcon />, path: '/api-tokens', module: 'api-tokens' },
  { text: 'Webhooks', icon: <WebhookIcon />, path: '/webhooks', module: 'webhooks' },
  { text: 'Multimedia', icon: <LibraryMusicIcon />, path: '/multimedia', module: 'multimedia' },
  { text: 'Reportes', icon: <Assessment />, path: '/reports', module: 'reports' },

  // Configuración
  { text: 'Roles y Permisos', icon: <SecurityIcon />, path: '/roles', module: 'roles' },
  { text: 'Configuración', icon: <AdminPanelSettingsIcon />, path: '/settings', module: 'settings' },
];



// Función para filtrar menú por permisos del usuario
const getMenuItemsForPermissions = (permissions, roleName) => {
  const isSuperAdmin = roleName === 'SuperAdmin';

  return allMenuItems.filter(item => {
    if (!item.module) return true; // Items sin module siempre visibles
    if (isSuperAdmin) return true; // SuperAdmin ve todo

    // Verificar si tiene can_view en algún permiso del módulo
    const mod = permissions[item.module];
    if (!mod) return false;
    return Object.values(mod).some(p => p.can_view === true);
  });
};

// Compatibilidad: mantener función antigua por si se usa en otro lugar
const getMenuItemsForRole = (userRole) => {
  return allMenuItems; // Fallback: mostrar todo si se llama sin permisos
};



const DashboardLayout = ({ children }) => {

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [drawerOpen, setDrawerOpen] = useState(!isMobile);

  const [immersiveMode, setImmersiveMode] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const [dialerOpen, setDialerOpen] = useState(false);

  const [callStartTime, setCallStartTime] = useState(null);

  const [callDuration, setCallDuration] = useState('00:00');
  const [screenShareActive, setScreenShareActive] = useState(false);
  const [cameraShareActive, setCameraShareActive] = useState(false);

  // Use context muted state

  const [dialNumber, setDialNumber] = useState('');
  const [agentSkills, setAgentSkills] = useState([]);
  const [selectedDialerSkill, setSelectedDialerSkill] = useState('');
  const [skillsLoading, setSkillsLoading] = useState(false);
  const [dialerCalling, setDialerCalling] = useState(false);
  const [addToConference, setAddToConference] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileSaving, setProfileSaving] = useState(false);
  const [avatarMenuAnchorEl, setAvatarMenuAnchorEl] = useState(null);
  const [avatarPreviewOpen, setAvatarPreviewOpen] = useState(false);
  const [avatarSelectorOpen, setAvatarSelectorOpen] = useState(false);
  const [avatarCreatorOpen, setAvatarCreatorOpen] = useState(false);
  const [profileForm, setProfileForm] = useState({
    name: '',
    agentId: '',
    documentNumber: '',
    message: '',
    avatarUrl: '',
    newPassword: '',
    confirmPassword: '',
    removeAvatar: false
  });
  const [profileAvatarFile, setProfileAvatarFile] = useState(null);
  const [avatarPressed, setAvatarPressed] = useState(false);

  const [configOpen, setConfigOpen] = useState(false);

  const [typificationPanelOpen, setTypificationPanelOpen] = useState(false);

  const [clientDataPanelOpen, setClientDataPanelOpen] = useState(false);
  const [clientDataSnapshot, setClientDataSnapshot] = useState(null);
  const [skillConfigCache, setSkillConfigCache] = useState(() => loadSkillConfigCache());
  const [endsCache, setEndsCache] = useState(() => loadEndsCache());
  const [clientDataManuallyClosed, setClientDataManuallyClosed] = useState(false);
  const skillConfigCacheRef = useRef(skillConfigCache);
  const endsCacheRef = useRef(endsCache);
  const skillsLoadedRef = useRef(false);
  const lastClientDataSnapshotRef = useRef(null); // Para rastrear el último snapshot y evitar actualizaciones innecesarias

  const [lastCallInfo, setLastCallInfo] = useState(null);

  const [pendingTypification, setPendingTypification] = useState(false); // Track if typification is pending
  const autoTypificationTimerRef = useRef(null);
  const latestTypificationContextRef = useRef(null);
  const autoTypificationLogKeyRef = useRef(null);
  const [autoTypificationTimeLeft, setAutoTypificationTimeLeft] = useState(null); // Tiempo restante en segundos
  const autoTypificationCountdownRef = useRef(null);
  const autoTypificationStartRef = useRef(null);
  const autoTypificationParamsRef = useRef(null);
  const handleAutoTypificationRef = useRef(null); // Ref para que el timer siempre llame la versión más reciente
  const [isInGracePeriod, setIsInGracePeriod] = useState(false); // Flag para período de gracia de 3 seg
  const [pendingManualStatus, setPendingManualStatus] = useState(null);
  const isApplyingPendingStatusRef = useRef(false); // Evitar doble aplicación del pendingManualStatus
  const acwWatchdogRef = useRef(null); // Timer para verificar estado ACW sin tipificación
  const lastCallIdentityRef = useRef(null); // Para detectar una llamada nueva y limpiar el estado previo
  const typificationQueueProcessingRef = useRef(false);
  const typificationQueueIntervalRef = useRef(null);
  // Rastrear estado original antes de una llamada manual para poder restaurarlo al colgar
  const manualReturnRef = useRef({
    originStatus: null,
    callStartTime: null,
    actionId: null
  });
  const resetManualReturnRef = useCallback(() => {
    manualReturnRef.current = {
      originStatus: null,
      callStartTime: null,
      actionId: null
    };
    logger.log('[MANUAL CALL][RESET] manualReturnRef cleared');
  }, []);

  // Debug: rastrear cambios en pendingManualStatus
  useEffect(() => {
    logger.log(`[PENDING MANUAL STATUS] Changed to: ${pendingManualStatus}`);
  }, [pendingManualStatus]);

  // Debug: rastrear cambios en autoTypificationTimeLeft
  useEffect(() => {
    logger.log(`[AUTO TYPIFICATION TIME] Changed to: ${autoTypificationTimeLeft}`);
  }, [autoTypificationTimeLeft]);

  const [activeDialingMode, setActiveDialingMode] = useState(null);
  const [micPermissionGranted, setMicPermissionGranted] = useState(false);
  const [canHangup, setCanHangup] = useState(true); // Control para deshabilitar colgar por 5 segundos

  // Interaction cache persisted across calls
  const [interactionCache, setInteractionCache] = useState(() => loadInteractionCache());

  const [agentStatusStartTime, setAgentStatusStartTime] = useState(() => {
    try {
      const cached = sessionStorage.getItem('cti_agent_status_start');
      if (cached) return Number(cached);
    } catch (e) { /* ignore */ }
    return null;
  });
  const [agentStatusDuration, setAgentStatusDuration] = useState('00:00');

  const lastStatusChangeRef = useRef(null);

  const lastCallWasMonitoringRef = useRef(false);
  const screenShareWsRef = useRef(null);
  const screenSharePcsRef = useRef(new Map());
  const screenShareStreamRef = useRef(null);
  const screenShareSendersRef = useRef(new Map());
  const screenShareQualityRef = useRef('low');
  const screenShareStartedByRequestRef = useRef(false);

  const cameraShareWsRef = useRef(null);
  const cameraSharePcsRef = useRef(new Map());
  const cameraShareStreamRef = useRef(null);
  const cameraShareSendersRef = useRef(new Map());
  const cameraShareQualityRef = useRef('low');
  const cameraShareStartedByRequestRef = useRef(false);
  const controlWsRef = useRef(null);
  const controlReconnectRef = useRef(null);
  const controlClosingRef = useRef(false);
  const profileAvatarInputRef = useRef(null);
  const profileCameraInputRef = useRef(null);



  const location = useLocation();

  const navigate = useNavigate();

  const { user, logout, updateStoredUser } = useAuth();
  const { canAction } = usePermissions();
  const resolveAvatarUrl = useCallback((raw) => {
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;
    const apiBase = process.env.REACT_APP_API_BASE_URL || '/api/admin';
    const baseRoot = apiBase.replace(/\/api\/admin\/?$/, '') || (typeof window !== 'undefined' ? window.location.origin : '');
    return `${baseRoot}${raw.startsWith('/') ? raw : '/' + raw}`;
  }, []);
  const userAvatarUrl = useMemo(() => resolveAvatarUrl(
    user?.avatar_path ||
    user?.extra_config?.avatar_path ||
    user?.extra_config?.avatar_url ||
    ''
  ), [user?.avatar_path, user?.extra_config, resolveAvatarUrl]);

  const { showSuccess, showInfo, showError } = useNotification();

  const [drawerPinned, setDrawerPinned] = useState(() => {

    if (typeof window === 'undefined') return false;

    try {

      return window.localStorage.getItem('ctiDrawerPinned') === '1';

    } catch (err) {

      return false;

    }

  });

  const [adminMenuOpen, setAdminMenuOpen] = useState(true);

  const [supervisionMenuOpen, setSupervisionMenuOpen] = useState(true);

  const [configMenuOpen, setConfigMenuOpen] = useState(false);

  // Wall notifications
  const [wallNotifCount, setWallNotifCount] = useState(0);
  const [wallNotifAnchor, setWallNotifAnchor] = useState(null);
  const [wallNotifs, setWallNotifs] = useState([]);



  useEffect(() => {

    try {

      window.localStorage.setItem('ctiDrawerPinned', drawerPinned ? '1' : '0');

    } catch (err) {

      /* ignore storage issues */

    }

  }, [drawerPinned]);



  useEffect(() => {

    const handleCollapseEvent = () => {

      if (!drawerPinned && location.pathname === '/dashboard') {

        setDrawerOpen(false);

      }

    };

    window.addEventListener('cti-close-drawer', handleCollapseEvent);

    return () => window.removeEventListener('cti-close-drawer', handleCollapseEvent);

  }, [drawerPinned, location.pathname]);



  useEffect(() => {

    const handleImmersiveToggle = (event) => {

      setImmersiveMode(Boolean(event?.detail?.active));

    };

    window.addEventListener('immersive-mode-change', handleImmersiveToggle);

    return () => window.removeEventListener('immersive-mode-change', handleImmersiveToggle);

  }, []);



  useEffect(() => {

    if (immersiveMode) {

      setDrawerOpen(false);

    }

  }, [immersiveMode]);



  // Obtener menú filtrado por rol real del usuario usando useMemo

  const currentRole = user?.role?.role_name || user?.role || 'admin';

  const menuItems = React.useMemo(() => {
    const permissions = user?.permissions || {};
    const roleName = user?.role?.role_name || '';
    return getMenuItemsForPermissions(permissions, roleName);
  }, [user?.permissions, user?.role?.role_name]);



  // Debug: mostrar información del usuario y rol (temporal) - solo una vez

  React.useEffect(() => {

    logger.log('=== DEBUG ROLES ===');

    logger.log('Usuario completo:', user);

    logger.log('Rol detectado:', currentRole);

    logger.log('Items de menú filtrados:', menuItems.length);

    logger.log('Nombres de menú:', menuItems.map(item => item.text));

    logger.log('==================');

  }, [currentRole]); // Solo depende del rol, no del array menuItems

  const softphoneContext = useSoftphone();
  const { status, registered, inCall, connected, monitoringSession, hasActiveRtp, makeCall: contextMakeCall, hangup: contextHangup, toggleMute: contextToggleMute, muted: contextMuted, config, audioLevels, setConfig, connect: contextConnect, disconnect: contextDisconnect, answer: contextAnswer, reject: contextReject, callData, lastSkillConfig, typificationData, setLastSkillConfig, clearLastSkillConfig, clearCallData, setMonitoringSession, clearMonitoringSession, setCallData, setTypificationData, clearTypificationData, setInCall, holdCall: contextHoldCall, resumeCall: contextResumeCall, switchCall: contextSwitchCall, mergeCall: contextMergeCall, calls: contextCalls, currentCallId, heldCallIds, conferenceParticipants, hangupConferenceParticipant: contextHangupConfParticipant } = softphoneContext;

  const {

    resetPreviewState,

    currentAgent,
    loading: agentLoading,

    logoutAgent,

    preSessionConflict,
    preSessionInfo,
    forcePreSessionLogin,
    cancelPreSessionLogin,

    sessionConflict,

    sessionTimeout,

    conflictInfo,

    resolveSessionConflict,

    resolveSessionTimeout,

    forceSessionReset,

    agentStatus: agentStatusContext,

    changeAgentStatus

  } = useAgent();



  // Usar useMemo para estabilizar valores derivados y evitar re-renders innecesarios
  const callClientData = useMemo(() => callData?.skillData || null, [callData?.skillData]);
  const isManualCall = useMemo(() =>
    callData?.source === 'manual' || callData?.dialingModeNormalized === 'manual',
    [callData?.source, callData?.dialingModeNormalized]
  );
  const hasClientData = useMemo(() =>
    Boolean((callClientData?.skillData || clientDataSnapshot?.skillData) && !isManualCall),
    [callClientData?.skillData, clientDataSnapshot?.skillData, isManualCall]
  );
  const interactionActive = useMemo(() => inCall || pendingTypification, [inCall, pendingTypification]);

  const getCallIdentity = useCallback((data) => {
    if (!data) return null;
    return (
      data.actionId ||
      data.manualCallId ||
      data.previewId ||
      data.call_id ||
      data.timestamp ||
      data.startTime ||
      `${data.skill || ''}:${data.data_id || data.dataId || ''}`
    );
  }, []);

  const doesTypificationMatchCall = useCallback((typData, data) => {
    if (!typData || !data) return false;
    if (typData.actionId && data.actionId) {
      return String(typData.actionId) === String(data.actionId);
    }
    const callDataId = data.data_id ?? data.dataId ?? null;
    if (typData.dataId && callDataId) {
      const sameData = String(typData.dataId) === String(callDataId);
      if (!sameData) return false;
      if (typData.skillName && data.skill) {
        return String(typData.skillName) === String(data.skill);
      }
      return true;
    }
    return false;
  }, []);

  // Mostrar botón de panel de datos si hay clientDataSnapshot, incluso en llamadas manuales
  const shouldShowClientDataButton = useMemo(() =>
    Boolean(callClientData?.skillData || clientDataSnapshot?.skillData),
    [callClientData?.skillData, clientDataSnapshot?.skillData]
  );

  const isPreviewClientData = useMemo(() =>
    callData?.source === 'preview' && hasClientData,
    [callData?.source, hasClientData]
  );

  const isMonitoringCall = Boolean(monitoringSession) || Boolean(callData?.isMonitoringCall);

  const monitoringMode = monitoringSession?.mode || 'listen';

  const monitoringAgentLabel = monitoringSession

    ? `${monitoringSession.agentId || ''}${monitoringSession.agentName ? ` - ${monitoringSession.agentName}` : ''}`.trim()

    : '';

  const marqueeShouldScroll = monitoringAgentLabel.length > 24;

  const manualPauseStatuses = useMemo(() => new Set([
    'PAUSE',
    'ABSENT',
    'BREAK',
    'BATHROOM',
    'LUNCH',
    'REST',
    'TRAINING'
  ]), []);

  const screenShareAgentId = useMemo(() => {
    const candidate = currentAgent?.agent || user?.agent || user?.username || user?.id || '';
    return String(candidate || '').trim();
  }, [currentAgent?.agent, user?.agent, user?.username, user?.id]);

  const screenShareSignalUrl = useMemo(() => {
    if (typeof window === 'undefined') return '';
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${protocol}://${window.location.host}/signal`;
  }, []);

  const stopScreenShare = useCallback(() => {
    screenShareQualityRef.current = 'low';
    screenShareStartedByRequestRef.current = false;
    // Close ALL peer connections
    for (const [, pc] of screenSharePcsRef.current) {
      try { pc.close(); } catch {}
    }
    screenSharePcsRef.current.clear();
    screenShareSendersRef.current.clear();
    if (screenShareStreamRef.current) {
      try {
        screenShareStreamRef.current.getTracks().forEach((track) => track.stop());
      } catch {}
      screenShareStreamRef.current = null;
    }
    if (screenShareWsRef.current) {
      try { screenShareWsRef.current.close(); } catch {}
      screenShareWsRef.current = null;
    }
    setScreenShareActive(false);
  }, []);

  const createScreenSharePcForViewer = useCallback(async (viewerId) => {
    const ws = screenShareWsRef.current;
    const stream = screenShareStreamRef.current;
    if (!ws || ws.readyState !== WebSocket.OPEN || !stream || !viewerId) return;
    // Close existing PC for this viewer if any
    const existingPc = screenSharePcsRef.current.get(viewerId);
    if (existingPc) {
      try { existingPc.close(); } catch {}
      screenSharePcsRef.current.delete(viewerId);
      screenShareSendersRef.current.delete(viewerId);
    }
    const pc = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' },
        { urls: 'stun:stun1.l.google.com:19302' }
      ]
    });
    screenSharePcsRef.current.set(viewerId, pc);
    pc.onicecandidate = (e) => {
      if (e.candidate && screenShareWsRef.current?.readyState === WebSocket.OPEN) {
        screenShareWsRef.current.send(JSON.stringify({ type: 'ice', candidate: e.candidate, viewerId }));
      }
    };
    stream.getTracks().forEach((track) => {
      const sender = pc.addTrack(track, stream);
      if (track.kind === 'video') {
        screenShareSendersRef.current.set(viewerId, sender);
      }
    });
    const offer = await pc.createOffer();
    await pc.setLocalDescription(offer);
    ws.send(JSON.stringify({ type: 'offer', offer, viewerId }));
  }, []);

  const removeScreenSharePcForViewer = useCallback((viewerId) => {
    if (!viewerId) return;
    const pc = screenSharePcsRef.current.get(viewerId);
    if (pc) {
      try { pc.close(); } catch {}
      screenSharePcsRef.current.delete(viewerId);
    }
    screenShareSendersRef.current.delete(viewerId);
  }, []);

  const applyScreenShareQuality = useCallback(async (level) => {
    const normalized = level === 'high' ? 'high' : 'low';
    if (screenShareQualityRef.current === normalized) return;
    screenShareQualityRef.current = normalized;
    for (const [, sender] of screenShareSendersRef.current) {
      try {
        const params = sender.getParameters();
        if (!params.encodings) params.encodings = [{}];
        params.encodings[0].maxBitrate = normalized === 'high' ? 2500000 : 600000;
        params.encodings[0].maxFramerate = normalized === 'high' ? 30 : 12;
        await sender.setParameters(params);
      } catch {}
    }
  }, []);

  const startScreenShare = useCallback(async () => {
    if (!screenShareAgentId || !screenShareSignalUrl || screenShareActive) return;

    // Capture MediaStream FIRST
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: { frameRate: screenShareQualityRef.current === 'high' ? 30 : 12 },
      audio: false
    });
    screenShareStreamRef.current = stream;
    stream.getVideoTracks()[0].onended = () => {
      stopScreenShare();
    };

    const ws = new WebSocket(screenShareSignalUrl);
    screenShareWsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ type: 'role', role: 'sender', id: screenShareAgentId, stream: 'screen' }));
    };

    ws.onmessage = async (evt) => {
      let msg;
      try { msg = JSON.parse(evt.data); } catch { return; }
      if (msg.type === 'ready-for-offer') {
        await createScreenSharePcForViewer(msg.viewerId);
      } else if (msg.type === 'answer') {
        const pc = screenSharePcsRef.current.get(msg.viewerId);
        if (pc) {
          await pc.setRemoteDescription(new RTCSessionDescription(msg.answer));
        }
      } else if (msg.type === 'ice') {
        const pc = screenSharePcsRef.current.get(msg.viewerId);
        if (pc && msg.candidate) {
          try { await pc.addIceCandidate(msg.candidate); } catch {}
        }
      } else if (msg.type === 'quality') {
        await applyScreenShareQuality(msg.level);
      } else if (msg.type === 'viewer-left') {
        removeScreenSharePcForViewer(msg.viewerId);
      }
    };

    ws.onclose = () => {
      if (screenShareActive) stopScreenShare();
    };

    setScreenShareActive(true);
  }, [screenShareAgentId, screenShareSignalUrl, screenShareActive, createScreenSharePcForViewer, removeScreenSharePcForViewer, applyScreenShareQuality, stopScreenShare]);

  useEffect(() => () => {
    stopScreenShare();
  }, [stopScreenShare]);

  const stopCameraShare = useCallback(() => {
    cameraShareQualityRef.current = 'low';
    cameraShareStartedByRequestRef.current = false;
    // Close ALL peer connections
    for (const [, pc] of cameraSharePcsRef.current) {
      try { pc.close(); } catch {}
    }
    cameraSharePcsRef.current.clear();
    cameraShareSendersRef.current.clear();
    if (cameraShareStreamRef.current) {
      try {
        cameraShareStreamRef.current.getTracks().forEach((track) => track.stop());
      } catch {}
      cameraShareStreamRef.current = null;
    }
    if (cameraShareWsRef.current) {
      try { cameraShareWsRef.current.close(); } catch {}
      cameraShareWsRef.current = null;
    }
    setCameraShareActive(false);
  }, []);

  const createCameraSharePcForViewer = useCallback(async (viewerId) => {
    const ws = cameraShareWsRef.current;
    const stream = cameraShareStreamRef.current;
    if (!ws || ws.readyState !== WebSocket.OPEN || !stream || !viewerId) return;
    // Close existing PC for this viewer if any
    const existingPc = cameraSharePcsRef.current.get(viewerId);
    if (existingPc) {
      try { existingPc.close(); } catch {}
      cameraSharePcsRef.current.delete(viewerId);
      cameraShareSendersRef.current.delete(viewerId);
    }
    const pc = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' },
        { urls: 'stun:stun1.l.google.com:19302' }
      ]
    });
    cameraSharePcsRef.current.set(viewerId, pc);
    pc.onicecandidate = (e) => {
      if (e.candidate && cameraShareWsRef.current?.readyState === WebSocket.OPEN) {
        cameraShareWsRef.current.send(JSON.stringify({ type: 'ice', candidate: e.candidate, viewerId }));
      }
    };
    stream.getTracks().forEach((track) => {
      const sender = pc.addTrack(track, stream);
      if (track.kind === 'video') {
        cameraShareSendersRef.current.set(viewerId, sender);
      }
    });
    const offer = await pc.createOffer();
    await pc.setLocalDescription(offer);
    ws.send(JSON.stringify({ type: 'offer', offer, viewerId }));
  }, []);

  const removeCameraSharePcForViewer = useCallback((viewerId) => {
    if (!viewerId) return;
    const pc = cameraSharePcsRef.current.get(viewerId);
    if (pc) {
      try { pc.close(); } catch {}
      cameraSharePcsRef.current.delete(viewerId);
    }
    cameraShareSendersRef.current.delete(viewerId);
  }, []);

  const applyCameraShareQuality = useCallback(async (level) => {
    const normalized = level === 'high' ? 'high' : 'low';
    if (cameraShareQualityRef.current === normalized) return;
    cameraShareQualityRef.current = normalized;
    for (const [, sender] of cameraShareSendersRef.current) {
      try {
        const params = sender.getParameters();
        if (!params.encodings) params.encodings = [{}];
        params.encodings[0].maxBitrate = normalized === 'high' ? 2500000 : 600000;
        params.encodings[0].maxFramerate = normalized === 'high' ? 30 : 12;
        await sender.setParameters(params);
      } catch {}
    }
  }, []);

  const startCameraShare = useCallback(async () => {
    if (!screenShareAgentId || !screenShareSignalUrl || cameraShareActive) return;

    // Capture MediaStream FIRST
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: { frameRate: cameraShareQualityRef.current === 'high' ? 30 : 12 },
        audio: false
      });
    } catch (err) {
      return;
    }
    cameraShareStreamRef.current = stream;
    stream.getVideoTracks()[0].onended = () => {
      stopCameraShare();
    };

    const ws = new WebSocket(screenShareSignalUrl);
    cameraShareWsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ type: 'role', role: 'sender', id: screenShareAgentId, stream: 'cam' }));
    };

    ws.onmessage = async (evt) => {
      let msg;
      try { msg = JSON.parse(evt.data); } catch { return; }
      if (msg.type === 'ready-for-offer') {
        await createCameraSharePcForViewer(msg.viewerId);
      } else if (msg.type === 'answer') {
        const pc = cameraSharePcsRef.current.get(msg.viewerId);
        if (pc) {
          await pc.setRemoteDescription(new RTCSessionDescription(msg.answer));
        }
      } else if (msg.type === 'ice') {
        const pc = cameraSharePcsRef.current.get(msg.viewerId);
        if (pc && msg.candidate) {
          try { await pc.addIceCandidate(msg.candidate); } catch {}
        }
      } else if (msg.type === 'quality') {
        await applyCameraShareQuality(msg.level);
      } else if (msg.type === 'viewer-left') {
        removeCameraSharePcForViewer(msg.viewerId);
      }
    };

    ws.onclose = () => {
      if (cameraShareActive) stopCameraShare();
    };

    setCameraShareActive(true);
  }, [
    screenShareAgentId,
    screenShareSignalUrl,
    cameraShareActive,
    createCameraSharePcForViewer,
    removeCameraSharePcForViewer,
    applyCameraShareQuality,
    stopCameraShare
  ]);

  useEffect(() => () => {
    stopCameraShare();
  }, [stopCameraShare]);

  const connectControlChannel = useCallback(() => {
    if (!screenShareAgentId || !screenShareSignalUrl) return;
    if (
      controlWsRef.current &&
      [WebSocket.OPEN, WebSocket.CONNECTING].includes(controlWsRef.current.readyState)
    ) {
      return;
    }
    controlClosingRef.current = false;
    const ws = new WebSocket(screenShareSignalUrl);
    controlWsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ type: 'role', role: 'control', id: screenShareAgentId }));
    };

    ws.onmessage = (evt) => {
      let msg;
      try { msg = JSON.parse(evt.data); } catch { return; }
      if (!msg || msg.type !== 'request') return;
      const req = String(msg.request || msg.stream || '').toLowerCase();
      if (req === 'cam' || req === 'camera') {
        cameraShareStartedByRequestRef.current = true;
        startCameraShare();
      } else if (req === 'stop-cam' || req === 'stop-camera' || req === 'stopcam') {
        stopCameraShare();
      } else if (req === 'screen' || req === 'display') {
        screenShareStartedByRequestRef.current = true;
        startScreenShare();
      } else if (req === 'stop-screen' || req === 'stop-display' || req === 'stopscreen') {
        stopScreenShare();
      } else if (req === 'refresh' || req === 'reload') {
        try {
          window.location.reload();
        } catch {}
      }
    };

    ws.onclose = () => {
      if (controlClosingRef.current) return;
      if (controlReconnectRef.current) clearTimeout(controlReconnectRef.current);
      controlReconnectRef.current = setTimeout(() => {
        connectControlChannel();
      }, 2000);
    };
  }, [screenShareAgentId, screenShareSignalUrl, startCameraShare, startScreenShare]);

  useEffect(() => {
    connectControlChannel();
    return () => {
      controlClosingRef.current = true;
      if (controlReconnectRef.current) clearTimeout(controlReconnectRef.current);
      if (controlWsRef.current) {
        try { controlWsRef.current.close(); } catch {}
        controlWsRef.current = null;
      }
    };
  }, [connectControlChannel]);

  const getPauseStorageKey = useCallback(() => {
    const agentKey = currentAgent?.agent || user?.agent || user?.username || user?.id || null;
    if (!agentKey) return null;
    return `cti_agent_pause_status_${agentKey}`;
  }, [currentAgent?.agent, user?.agent, user?.username, user?.id]);

  const persistManualPauseStatus = useCallback((statusValue) => {
    if (typeof window === 'undefined') return;
    const key = getPauseStorageKey();
    if (!key) return;
    const normalized = statusValue ? String(statusValue).toUpperCase() : '';
    try {
      if (normalized && manualPauseStatuses.has(normalized)) {
        window.localStorage.setItem(key, normalized);
      } else {
        window.localStorage.removeItem(key);
      }
    } catch (err) {
      logger.warn('[PAUSE PERSIST] Failed to persist pause status', err);
    }
  }, [getPauseStorageKey, manualPauseStatuses]);
  // Para llamadas manuales, priorizar el número que se está marcando (callData.phone)
  // y NO usar los datos de la interacción/cliente
  const clientPhoneNumber = isManualCall
    ? (callData?.phone || callData?.callNumber || '')
    : (
      callData?.callNumber ||
      callData?.phone ||
      callData?.skillData?.skillData?.phone?.number ||
      callData?.skillData?.skillData?.phones?.number1 ||
      callData?.skillData?.skillData?.Telefono1 ||
      callData?.skillData?.skillData?.telefono ||
      clientDataSnapshot?.skillData?.skillData?.phone?.number ||
      clientDataSnapshot?.skillData?.skillData?.phones?.number1 ||
      clientDataSnapshot?.skillData?.skillData?.Telefono1 ||
      clientDataSnapshot?.skillData?.skillData?.telefono ||
      typificationData?.callNumber ||
      ''
    );
  const isOutgoingCall = isManualCall;
  const clientPhoneLabel = clientPhoneNumber
    ? `${isOutgoingCall ? 'Llamada saliente' : 'Llamada entrante'}: ${clientPhoneNumber}`
    : '';
  const clientPhoneMarquee = clientPhoneLabel.length > 24;



  useEffect(() => {
    // NO limpiar clientDataSnapshot para llamadas manuales
    // Esto permite mantener acceso a datos del cliente en llamadas manuales desde PRECALL

    // Para llamadas manuales, mantener el clientDataSnapshot anterior (no actualizar)
    if (isManualCall) {
      return;
    }

    if (callClientData?.skillData) {
      // Verificar si el snapshot realmente cambió para evitar actualizaciones innecesarias
      const lastSnapshot = lastClientDataSnapshotRef.current;
      const hasSnapshotChanged = !lastSnapshot ||
        JSON.stringify(lastSnapshot.skillData) !== JSON.stringify(callClientData.skillData);

      if (!hasSnapshotChanged) {
        return; // No actualizar si el snapshot no cambió
      }

      const cachePayload = {
        skill: callData?.skill || interactionCache?.skill || typificationData?.skillName || null,
        skillConfig: callData?.skillData?.skillConfig || interactionCache?.skillConfig || null,
        dataId: callData?.data_id || callData?.dataId || interactionCache?.dataId || null,
        actionId: callData?.actionId || interactionCache?.actionId || null,
        callNumber: callData?.callNumber || interactionCache?.callNumber || null,
        scriptAutoFinalCode:
          callData?.skillData?.skillConfig?.script_auto_final_code ||
          interactionCache?.scriptAutoFinalCode ||
          null,
        scriptMaxTimeSec:
          callData?.skillData?.skillConfig?.script_maxtime_sec ||
          interactionCache?.scriptMaxTimeSec ||
          null,
        scriptMaxTimeEnable:
          callData?.skillData?.skillConfig?.script_maxtime_enable ??
          interactionCache?.scriptMaxTimeEnable ??
          Boolean(callData?.skillData?.skillConfig?.script_maxtime_sec)
      };

      // Solo actualizar interactionCache si realmente cambió el skill
      const currentSkill = interactionCache?.skill;
      const newSkill = cachePayload.skill;
      if (currentSkill !== newSkill) {
        setInteractionCache(cachePayload);
        saveInteractionCache(cachePayload);
      }

      // Actualizar snapshot y ref
      lastClientDataSnapshotRef.current = callClientData;
      setClientDataSnapshot(callClientData);
      if (!clientDataManuallyClosed) {
        setClientDataPanelOpen(true);
      }
    }
  }, [callClientData, clientDataManuallyClosed, isManualCall, callData, typificationData, interactionCache]);

  // Limpiar datos de cliente obsoletos al recargar la página
  useEffect(() => {
    // Solo ejecutar una vez al montar el componente
    const hasActiveCall = inCall || pendingTypification;

    if (!hasActiveCall && clientDataSnapshot) {
      logger.log('[CLIENT DATA] Limpiando datos obsoletos al recargar página - no hay llamada activa');
      setClientDataSnapshot(null);
      setClientDataPanelOpen(false);
      setClientDataManuallyClosed(true);
      setInteractionCache(null);
      clearInteractionCache();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Solo al montar

  // Debug log for lastSkillConfig changes and open typification panel for preview calls

  React.useEffect(() => {

    logger.log('[DEBUG] lastSkillConfig changed in DashboardLayout:', lastSkillConfig);



    if (monitoringSession) {

      return;

    }



    // Si tenemos lastSkillConfig y no estamos en llamada, y es una sesión preview

    // abrir el panel de tipificación

    if (lastSkillConfig && !inCall && callData?.source === 'preview') {

      logger.log('[PREVIEW] Opening typification panel for preview call');

      setTypificationPanelOpen(true);

      setPendingTypification(true); // Mark typification as pending



      // Guardar información de la llamada para el panel de tipificación

      const callInfo = {

        duration: callDuration || '00:00',

        startTime: callStartTime || Date.now(),

        endTime: Date.now(),

        callId: callData?.actionId || null,

        phoneNumber: callData?.callNumber || callData?.skillData?.Telefono1 || null

      };

      setLastCallInfo(callInfo);

    }

  }, [lastSkillConfig, inCall, callData, callDuration, callStartTime, monitoringSession]);

  // Persist lastSkillConfig into interaction cache so finales/script auto settings stay available
  React.useEffect(() => {
    if (!lastSkillConfig) return;

    const cachePayload = {
      ...interactionCache,
      skill: lastSkillConfig.skilldef || lastSkillConfig.call_skill || interactionCache?.skill || null,
      skillConfig: lastSkillConfig,
      dataId: interactionCache?.dataId || lastSkillConfig.call_data_id || null,
      actionId: interactionCache?.actionId || lastSkillConfig.call_action_id || null,
      callNumber: interactionCache?.callNumber || callData?.callNumber || null,
      scriptAutoFinalCode:
        lastSkillConfig.script_auto_final_code ?? interactionCache?.scriptAutoFinalCode ?? null,
      scriptMaxTimeSec:
        lastSkillConfig.script_maxtime_sec ?? interactionCache?.scriptMaxTimeSec ?? null,
      scriptMaxTimeEnable:
        lastSkillConfig.script_maxtime_enable ??
        interactionCache?.scriptMaxTimeEnable ??
        Boolean(lastSkillConfig.script_maxtime_sec)
    };

    const changed =
      cachePayload.skill !== interactionCache?.skill ||
      cachePayload.dataId !== interactionCache?.dataId ||
      cachePayload.actionId !== interactionCache?.actionId ||
      cachePayload.callNumber !== interactionCache?.callNumber ||
      cachePayload.scriptAutoFinalCode !== interactionCache?.scriptAutoFinalCode ||
      cachePayload.scriptMaxTimeSec !== interactionCache?.scriptMaxTimeSec ||
      cachePayload.scriptMaxTimeEnable !== interactionCache?.scriptMaxTimeEnable ||
      cachePayload.skillConfig !== interactionCache?.skillConfig;

    if (changed) {
      setInteractionCache(cachePayload);
      saveInteractionCache(cachePayload);
    }
  }, [lastSkillConfig, interactionCache, callData]);



  React.useEffect(() => {
    if (monitoringSession) {
      if (typificationPanelOpen) {
        setTypificationPanelOpen(false);
      }
      if (clientDataPanelOpen) {
        setClientDataPanelOpen(false);
      }
    }
  }, [monitoringSession, typificationPanelOpen, clientDataPanelOpen]);
  const api = useContext(ApiContext);
  const { ends, agentTracking } = api;
  const TYPIFICATION_QUEUE_KEY = 'cti_typification_queue_v1';
  const TYPIFICATION_QUEUE_MAX_ATTEMPTS = 8;
  const TYPIFICATION_QUEUE_INTERVAL_MS = 15000;

  const readTypificationQueue = useCallback(() => {
    if (typeof window === 'undefined') return [];
    try {
      const raw = window.localStorage.getItem(TYPIFICATION_QUEUE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      logger.warn('[TYPIFICATION][QUEUE] Error leyendo cola:', error);
      return [];
    }
  }, []);

  const writeTypificationQueue = useCallback((queue) => {
    if (typeof window === 'undefined') return false;
    try {
      window.localStorage.setItem(TYPIFICATION_QUEUE_KEY, JSON.stringify(queue));
      return true;
    } catch (error) {
      logger.warn('[TYPIFICATION][QUEUE] Error guardando cola:', error);
      return false;
    }
  }, []);

  const enqueueTypification = useCallback((payload) => {
    const queue = readTypificationQueue();
    const item = {
      id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      payload,
      attempts: 0,
      nextAttemptAt: Date.now(),
      createdAt: new Date().toISOString()
    };
    queue.push(item);
    const ok = writeTypificationQueue(queue);
    if (ok) {
      logger.log('[TYPIFICATION][QUEUE] Encolada tipificación', { id: item.id });
    }
    return ok;
  }, [readTypificationQueue, writeTypificationQueue]);

  const processTypificationQueue = useCallback(async () => {
    if (typificationQueueProcessingRef.current) return;
    typificationQueueProcessingRef.current = true;
    try {
      const queue = readTypificationQueue();
      if (!queue.length) return;

      const now = Date.now();
      const index = queue.findIndex(item => !item.nextAttemptAt || item.nextAttemptAt <= now);
      if (index === -1) return;

      const item = queue[index];
      logger.log('[TYPIFICATION][QUEUE] Procesando', { id: item.id, attempts: item.attempts });

      try {
        const response = await ends.saveTypification(item.payload);
        if (response?.success) {
          queue.splice(index, 1);
          writeTypificationQueue(queue);
          logger.log('[TYPIFICATION][QUEUE] Procesada OK', { id: item.id });
        } else {
          throw new Error(response?.error || 'Error al guardar tipificación');
        }
      } catch (error) {
        const attempts = (item.attempts || 0) + 1;
        const backoffMs = Math.min(60000, attempts * 5000);
        const nextAttemptAt = Date.now() + backoffMs;
        const updated = {
          ...item,
          attempts,
          nextAttemptAt,
          lastError: error?.message || 'Error desconocido'
        };

        if (attempts >= TYPIFICATION_QUEUE_MAX_ATTEMPTS) {
          logger.warn('[TYPIFICATION][QUEUE] Máximo de intentos, descartando', updated);
          queue.splice(index, 1);
        } else {
          queue[index] = updated;
          logger.warn('[TYPIFICATION][QUEUE] Reintento programado', updated);
        }
        writeTypificationQueue(queue);
      }
    } finally {
      typificationQueueProcessingRef.current = false;
    }
  }, [ends, readTypificationQueue, writeTypificationQueue]);

  useEffect(() => {
    processTypificationQueue();
    if (typeof window !== 'undefined') {
      typificationQueueIntervalRef.current = setInterval(
        processTypificationQueue,
        TYPIFICATION_QUEUE_INTERVAL_MS
      );
      const handleOnline = () => processTypificationQueue();
      window.addEventListener('online', handleOnline);
      window.addEventListener('focus', handleOnline);
      return () => {
        if (typificationQueueIntervalRef.current) {
          clearInterval(typificationQueueIntervalRef.current);
        }
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('focus', handleOnline);
      };
    }
    return undefined;
  }, [processTypificationQueue]);
  const loadAgentSkills = useCallback(async () => {
    if (!currentAgent?.agent || !api?.agents?.getSkills) {
      logger.log('[SKILL-CACHE] No se puede cargar skills, falta agente o API');
      return;
    }

    // Si ya se cargaron skills exitosamente Y hay datos en cache, no recargar
    if (skillsLoadedRef.current && Object.keys(skillConfigCacheRef.current || {}).length > 0) {
      logger.log('[SKILL-CACHE] Skills ya cargados y cache con datos, saltando recarga');
      return;
    }

    const forceRefreshSkillsConfig = false;

    if (forceRefreshSkillsConfig) {
      logger.log('[SKILL-CACHE] forceRefresh activo, limpiando caché de skills y finales');
      skillConfigCacheRef.current = {};
      endsCacheRef.current = {};
      setSkillConfigCache({});
      setEndsCache({});
      try {
        if (typeof window !== 'undefined') {
          window.sessionStorage.removeItem(SKILL_CONFIG_CACHE_KEY);
          window.sessionStorage.removeItem(ENDS_CACHE_KEY);
        }
      } catch (clearErr) {
        logger.warn('[SKILL-CACHE] No se pudo limpiar sessionStorage antes de recargar skills', clearErr);
      }
    }

    setSkillsLoading(true);
    logger.log('[SKILL-CACHE] Iniciando carga de skills del agente:', currentAgent.agent);

    try {
      const response = await api.agents.getSkills(currentAgent.agent);
      const allSkills = response?.data?.skills || [];

      logger.log('[SKILL-CACHE] Skills obtenidos del servidor:', {
        agente: currentAgent.agent,
        totalSkills: allSkills.length,
        skills: allSkills.map(s => ({ skilldef: s.skilldef, id: s.id_skill }))
      });

      const filteredSkills = allSkills.filter((skill) => {
        const mode = String(skill?.dialing_mode || skill?.dialingMode || '').toLowerCase();
        if (mode) {
          return mode.includes('manual') || mode.includes('preview');
        }
        const type = String(skill?.skilltype || '').toLowerCase();
        return type.includes('manual') || type.includes('preview');
      });

      logger.log('[SKILL-CACHE] Skills filtrados (manual/preview):', {
        filteredCount: filteredSkills.length,
        skills: filteredSkills.map(s => s.skilldef)
      });

      setAgentSkills(filteredSkills);

      // Cache full skill configs (finales y tiempo de script) en sessionStorage para TODOS los skills del agente
      const cacheSnapshot = forceRefreshSkillsConfig ? {} : skillConfigCacheRef.current || {};
      const missingConfigs =
        forceRefreshSkillsConfig || Object.keys(cacheSnapshot || {}).length === 0
          ? allSkills
          : allSkills.filter((skill) => !cacheSnapshot?.[skill.skilldef]);

      logger.log('[SKILL-CACHE] Verificando configuraciones faltantes:', {
        enCache: Object.keys(cacheSnapshot).length,
        faltantes: missingConfigs.length,
        skillsFaltantes: missingConfigs.map(s => s.skilldef)
      });

      if (missingConfigs.length && api.skills?.getOne) {
        const updatedCache = { ...cacheSnapshot };
        logger.log('[SKILL-CACHE] Obteniendo configuraciones completas...');

        for (const skill of missingConfigs) {
          if (!skill?.id_skill) {
            logger.warn('[SKILL-CACHE] id_skill faltante para', skill);
            continue;
          }
          try {
            logger.log('[SKILL-CACHE] Consultando servidor para skill:', {
              id: skill.id_skill,
              skilldef: skill.skilldef
            });

            const res = await api.skills.getOne(skill.id_skill);
            const cfg = res?.data?.skill || res?.data || res?.skill || null;

            if (cfg) {
              updatedCache[skill.skilldef] = {
                ...cfg,
                skilldef: cfg.skilldef || skill.skilldef,
                finales_name: cfg.finales_name ?? cfg.finalesName ?? null,
                script_maxtime_sec: cfg.script_maxtime_sec ?? null,
                script_maxtime_enable: cfg.script_maxtime_enable ?? null,
                script_auto_final_code: cfg.script_auto_final_code ?? null
              };

              logger.log('[SKILL-CACHE] Configuración obtenida para:', {
                skilldef: skill.skilldef,
                finales_name: cfg.finales_name ?? cfg.finalesName,
                script_maxtime_sec: cfg.script_maxtime_sec
              });
            }
          } catch (cacheErr) {
            logger.warn('[SKILL-CACHE] Error obteniendo config para', skill.skilldef, cacheErr);
          }
        }

        skillConfigCacheRef.current = updatedCache;
        setSkillConfigCache(updatedCache);
        saveSkillConfigCache(updatedCache);

        logger.log('[SKILL-CACHE] Configuraciones guardadas en sessionStorage:', {
          totalConfigs: Object.keys(updatedCache).length,
          skills: Object.keys(updatedCache)
        });
      }

      // Cachear arboles de finales por grupo en sessionStorage usando el cache real de skills
      const endsSnapshot = forceRefreshSkillsConfig ? {} : endsCacheRef.current || {};
      const cacheSource = skillConfigCacheRef.current || cacheSnapshot || {};

      // Sólo considerar los skills asignados al agente; tomar finales_name desde cache si el skill lo tiene
      const endsGroupIds = Array.from(
        new Set(
          allSkills
            .map((skill) => {
              const cfg = cacheSource[skill.skilldef] || {};
              const val =
                cfg?.finales_name ||
                cfg?.finalesName ||
                skill?.finales_name ||
                skill?.finalesName;
              const num = parseInt(val, 10);
              return Number.isFinite(num) && num > 0 ? num : null;
            })
            .filter(Boolean)
        )
      );

      logger.log('[ENDS-CACHE] Grupos de finales detectados:', {
        totalGrupos: endsGroupIds.length,
        grupos: endsGroupIds,
        enCache: Object.keys(endsSnapshot).length
      });

      const missingEnds = forceRefreshSkillsConfig
        ? endsGroupIds
        : endsGroupIds.filter((gid) => !endsSnapshot[gid]);

      if (missingEnds.length) {
        logger.log('[ENDS-CACHE] Obteniendo finales faltantes del servidor:', {
          gruposFaltantes: missingEnds
        });

        const updatedEnds = { ...endsSnapshot };
        for (const gid of missingEnds) {
          try {
            logger.log('[ENDS-CACHE] Consultando servidor para grupo:', gid);

            const tree = await ends.getTree(gid, {
              cache: true,
              include_inactive: true,
              forceRefresh: false
            });

            updatedEnds[gid] = tree;

            logger.log('[ENDS-CACHE] Finales obtenidos para grupo:', {
              groupId: gid,
              itemsCount: tree?.data?.length || 0,
              fromCache: tree?.fromCache
            });
          } catch (prefetchErr) {
            logger.warn('[ENDS-CACHE] Error obteniendo finales para grupo', gid, prefetchErr);
          }
        }

        endsCacheRef.current = updatedEnds;
        setEndsCache(updatedEnds);
        saveEndsCache(updatedEnds);

        logger.log('[ENDS-CACHE] Finales guardados en sessionStorage:', {
          totalGrupos: Object.keys(updatedEnds).length,
          grupos: Object.keys(updatedEnds)
        });
      } else {
        logger.log('[ENDS-CACHE] Todos los finales ya están en caché');
      }

      if (filteredSkills.length) {
        setSelectedDialerSkill((prev) => {
          if (prev && filteredSkills.some((skill) => skill.skilldef === prev)) {
            return prev;
          }
          return filteredSkills[0].skilldef;
        });
      } else {
        setSelectedDialerSkill('');
      }

      skillsLoadedRef.current = true;
      logger.log('[SKILL-CACHE] Proceso de carga completado exitosamente, skillsLoadedRef=true');
    } catch (error) {
      console.error('[SKILL-CACHE] Error loading agent skills:', error);
      showError('No se pudieron cargar los skills del agente');
    } finally {
      setSkillsLoading(false);
    }
  }, [api?.agents, api?.skills, currentAgent?.agent, showError, ends]);

  useEffect(() => {
    loadAgentSkills();
  }, [loadAgentSkills]);

  // Actualizar skills cuando llegan eventos SSE de asignación/desasignación
  useEffect(() => {
    if (!api?.sse) return;

    const handleAgentSkillUpdate = (event) => {
      try {
        const data = JSON.parse(event.data || '{}');
        const targetAgent = data?.agentId || data?.agent || null;

        // Solo recargar si aplica al agente actual (o si no viene agentId)
        if (currentAgent?.agent && targetAgent && targetAgent !== currentAgent.agent) {
          return;
        }

        logger.log('[SKILL-CACHE] SSE agent-skill-update recibido, recargando skills', {
          targetAgent,
          currentAgent: currentAgent?.agent,
          type: data?.type
        });

        skillsLoadedRef.current = false;
        loadAgentSkills();
      } catch (err) {
        logger.warn('[SKILL-CACHE] No se pudo procesar agent-skill-update SSE:', err?.message || err);
      }
    };

    api.sse.addEventListener('agent-skill-update', handleAgentSkillUpdate);
    return () => {
      api.sse.removeEventListener('agent-skill-update');
    };
  }, [api?.sse, currentAgent?.agent, loadAgentSkills]);

  // Load unread wall post count on mount
  useEffect(() => {
    if (!api?.wall?.getUnreadCount) return;
    api.wall.getUnreadCount().then(resp => {
      if (resp?.success) {
        setWallNotifCount(resp.data.count || 0);
        setWallNotifs((resp.data.posts || []).map(p => ({ ...p, id: p.id })));
      }
    }).catch(() => {});
  }, [api?.wall]);

  // Listen for wall new-post SSE events for bell notifications (real-time, exclude own posts)
  useEffect(() => {
    if (!api?.sse?.addEventListener) return;
    const myId = currentAgent?.agent || user?.agent || user?.username || user?.id || '';
    const handleWallPost = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.post?.author_id === myId) return; // skip own posts
        setWallNotifCount(prev => prev + 1);
        setWallNotifs(prev => [{ id: Date.now(), ...data.post, timestamp: data.timestamp }, ...prev].slice(0, 20));
      } catch { /* ignore */ }
    };
    api.sse.addEventListener('wall-new-post', handleWallPost);
    return () => api.sse.removeEventListener('wall-new-post');
  }, [api?.sse, currentAgent?.agent, user?.agent, user?.username, user?.id]);

  // Mantener referencia del cache para lecturas en callbacks sin disparar re-render
  useEffect(() => {
    skillConfigCacheRef.current = skillConfigCache;
  }, [skillConfigCache]);
  useEffect(() => {
    endsCacheRef.current = endsCache;
  }, [endsCache]);

  // Si ya tenemos cache de skills y no hay interactionCache, inicializarlo para tener finales/script en memoria
  useEffect(() => {
    const skillCandidate =
      typificationData?.skillName ||
      selectedDialerSkill ||
      agentSkills[0]?.skilldef ||
      Object.keys(skillConfigCache || {})[0];

    if (!skillCandidate) return;
    const cfg = skillConfigCache[skillCandidate];
    if (!cfg) return;

    const needsInit =
      !interactionCache?.skillConfig ||
      interactionCache?.skillConfig?.skilldef !== skillCandidate ||
      !interactionCache?.skill;

    if (needsInit) {
      const payload = {
        ...interactionCache,
        skill: skillCandidate,
        skillConfig: cfg,
        dataId: interactionCache?.dataId || null,
        actionId: interactionCache?.actionId || null,
        callNumber: interactionCache?.callNumber || null,
        scriptAutoFinalCode: cfg.script_auto_final_code ?? interactionCache?.scriptAutoFinalCode ?? null,
        scriptMaxTimeSec: cfg.script_maxtime_sec ?? interactionCache?.scriptMaxTimeSec ?? null,
        scriptMaxTimeEnable:
          cfg.script_auto_final_code ??
          interactionCache?.scriptMaxTimeEnable ??
          Boolean(cfg.script_maxtime_sec)
      };
      setInteractionCache(payload);
      saveInteractionCache(payload);
      logger.log('[SKILL-CACHE] Interaction cache inicializado con skill', skillCandidate);
    }
  }, [selectedDialerSkill, agentSkills, skillConfigCache, typificationData?.skillName]);

  // Mantener interactionCache alineado con el skill de typificationData (cuando llega una llamada con otro skill)
  useEffect(() => {
    const skillFromTypification = typificationData?.skillName;
    if (!skillFromTypification) return;
    const cfg = skillConfigCache[skillFromTypification];
    if (!cfg) return;

    const needsUpdate =
      interactionCache?.skill !== skillFromTypification ||
      interactionCache?.skillConfig?.skilldef !== skillFromTypification;

    if (needsUpdate) {
      const payload = {
        ...interactionCache,
        skill: skillFromTypification,
        skillConfig: cfg,
        scriptAutoFinalCode: cfg.script_auto_final_code ?? interactionCache?.scriptAutoFinalCode ?? null,
        scriptMaxTimeSec: cfg.script_maxtime_sec ?? interactionCache?.scriptMaxTimeSec ?? null,
        scriptMaxTimeEnable:
          cfg.script_maxtime_enable ??
          interactionCache?.scriptMaxTimeEnable ??
          Boolean(cfg.script_maxtime_sec)
      };
      setInteractionCache(payload);
      saveInteractionCache(payload);
      logger.log('[SKILL-CACHE] Interaction cache actualizado desde typificationData', skillFromTypification);
    }
  }, [typificationData?.skillName, skillConfigCache]);

  // Mantener interactionCache alineado con el skill de callData (por si typificationData aún no está listo)
  useEffect(() => {
    const skillFromCall = callData?.skill;
    if (!skillFromCall) return;
    const cfg = skillConfigCache[skillFromCall];
    if (!cfg) return;

    const needsUpdate =
      interactionCache?.skill !== skillFromCall ||
      interactionCache?.skillConfig?.skilldef !== skillFromCall;

    if (needsUpdate) {
      const payload = {
        ...interactionCache,
        skill: skillFromCall,
        skillConfig: cfg,
        scriptAutoFinalCode: cfg.script_auto_final_code ?? interactionCache?.scriptAutoFinalCode ?? null,
        scriptMaxTimeSec: cfg.script_maxtime_sec ?? interactionCache?.scriptMaxTimeSec ?? null,
        scriptMaxTimeEnable:
          cfg.script_maxtime_enable ??
          interactionCache?.scriptMaxTimeEnable ??
          Boolean(cfg.script_maxtime_sec)
      };
      setInteractionCache(payload);
      saveInteractionCache(payload);
      logger.log('[SKILL-CACHE] Interaction cache actualizado desde callData', skillFromCall);
    }
  }, [callData?.skill, skillConfigCache]);
  const handleMonitoringMicrophoneToggle = useCallback(() => {
    if (!monitoringSession) {
      showInfo('No hay una sesión de monitoreo activa.');
      return;
    }

    if (!contextToggleMute) {
      showError('No se pudo controlar el micrófono del supervisor.');
      return;
    }

    if (!inCall) {
      showInfo('La llamada de monitoreo aún no está activa.');
      return;
    }

    contextToggleMute();
  }, [monitoringSession, contextToggleMute, inCall, showError, showInfo]);

  // Agent status management
  const [agentStatusOverride, setAgentStatusOverride] = useState(null);
  const wasConnectedRef = useRef(false);
  const statusBeforeDisconnectRef = useRef(null);

  const [statusLoading, setStatusLoading] = useState(false);

  const baseAgentStatus = agentStatusContext || 'NOTREADY';

  const agentStatus = agentStatusOverride || baseAgentStatus;

  const previousAgentStatusRef = useRef(null);



  // Agent status definitions

  const agentStatuses = [

    // Manual statuses (agent can select)

    { key: 'AVAILABLE', label: getAgentStatusLabel('AVAILABLE'), color: getAgentStatusColor('AVAILABLE'), icon: CheckCircle, selectable: true },

    { key: 'NOTREADY', label: getAgentStatusLabel('NOTREADY'), color: getAgentStatusColor('NOTREADY'), icon: DoNotDisturb, selectable: false },

    { key: 'PAUSE', label: getAgentStatusLabel('PAUSE'), color: getAgentStatusColor('PAUSE'), icon: Pause, selectable: true },

    { key: 'ABSENT', label: getAgentStatusLabel('ABSENT'), color: getAgentStatusColor('ABSENT'), icon: EventBusy, selectable: true },

    { key: 'BREAK', label: getAgentStatusLabel('BREAK'), color: getAgentStatusColor('BREAK'), icon: Coffee, selectable: true },

    { key: 'BATHROOM', label: getAgentStatusLabel('BATHROOM'), color: getAgentStatusColor('BATHROOM'), icon: Wc, selectable: true },

    { key: 'LUNCH', label: getAgentStatusLabel('LUNCH'), color: getAgentStatusColor('LUNCH'), icon: Restaurant, selectable: true },

    { key: 'REST', label: getAgentStatusLabel('REST'), color: getAgentStatusColor('REST'), icon: Hotel, selectable: true },

    { key: 'TRAINING', label: getAgentStatusLabel('TRAINING'), color: getAgentStatusColor('TRAINING'), icon: MenuBook, selectable: true },

    { key: 'OFFLINE', label: getAgentStatusLabel('OFFLINE'), color: getAgentStatusColor('OFFLINE'), icon: PowerSettingsNew, selectable: true },



    // Automatic statuses (system controlled)

    { key: 'PRECALL', label: getAgentStatusLabel('PRECALL'), color: getAgentStatusColor('PRECALL'), icon: PhonePaused, selectable: false },

    { key: 'INCALL', label: getAgentStatusLabel('INCALL'), color: getAgentStatusColor('INCALL'), icon: null, selectable: false },

    { key: 'ACW', label: getAgentStatusLabel('ACW'), color: getAgentStatusColor('ACW'), icon: Edit, selectable: false }

  ];



  // Get current status info

  const getCurrentStatusInfo = () => {

    return agentStatuses.find(s => s.key === agentStatus) || agentStatuses.find(s => s.key === 'NOTREADY');

  };



  // Get selectable statuses (for agent menu)

  const getSelectableStatuses = () => {

    return agentStatuses.filter(s => s.selectable);

  };



  // Format agent status duration

  const formatAgentStatusDuration = (seconds) => {

    const hours = Math.floor(seconds / 3600);

    const minutes = Math.floor((seconds % 3600) / 60);

    const secs = seconds % 60;



    if (hours > 0) {

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;

    } else {

      return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;

    }

  };

  // Microphone permission handling
  const requestMicPermission = useCallback(async () => {
    if (micPermissionGranted) return true;
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicPermissionGranted(true);
      return true;
    } catch (err) {
      console.error('[MIC] No se pudo obtener permiso de micrófono:', err);
      showError('Se requiere permiso de micrófono para estar Disponible.');
      setMicPermissionGranted(false);
      return false;
    }
  }, [micPermissionGranted, showError]);

  useEffect(() => {
    requestMicPermission();
  }, [requestMicPermission]);



  // Change agent status automatically (for system use)

  const changeAgentStatusAutomatic = useCallback(async (newStatus, reason = '', options = {}) => {

    if (!newStatus) return false;

    const { expectedStatuses = null, metadata = {} } = options;

    let success = false;

    if (String(newStatus).toUpperCase() === 'AVAILABLE' && !micPermissionGranted) {
      const ok = await requestMicPermission();
      if (!ok) return false;
    }



    try {

      logger.log(`[AGENT STATUS] Automatic change: ${agentStatus} -> ${newStatus} (${reason})`);

      setAgentStatusOverride(newStatus);



      const normalizedExpected = (() => {

        if (!expectedStatuses) return null;

        if (Array.isArray(expectedStatuses)) {

          return expectedStatuses.filter(Boolean).map(value => typeof value === 'string' ? value.toUpperCase() : value);

        }

        return [String(expectedStatuses).toUpperCase()];

      })();



      success = await changeAgentStatus(newStatus, '', {

        silent: true,

        expectedStatuses: normalizedExpected,

        reason,

        metadata: {

          ...metadata,

          trigger: 'auto',

          requestedAt: new Date().toISOString()

        }

      });



      if (!success) {

        console.error(`[AGENT STATUS] Failed to change automatic status to ${newStatus}`);

      }



      return success;

    } catch (error) {

      console.error('[AGENT STATUS] Error changing automatic status:', error);

      return false;

    } finally {

      if (!success) {

        setAgentStatusOverride(null);

      } else {

        setTimeout(() => setAgentStatusOverride(null), 0);

      }

    }

  }, [agentStatus, changeAgentStatus, micPermissionGranted, requestMicPermission]);



  const handleDrawerToggle = () => {

    setDrawerOpen(!drawerOpen);

  };



  useEffect(() => {
    if (!agentStatus) return;

    if (previousAgentStatusRef.current !== agentStatus) {
      previousAgentStatusRef.current = agentStatus;
      const now = Date.now();
      setAgentStatusStartTime(now);
      setAgentStatusDuration('00:00');
      try { sessionStorage.setItem('cti_agent_status_start', String(now)); } catch (e) { /* ignore */ }
    }
  }, [agentStatus]);





// Effect for call timer and call end detection

useEffect(() => {

  let interval;

  if (inCall && !callStartTime) {

    setCallStartTime(Date.now());

    lastCallWasMonitoringRef.current = Boolean(monitoringSession);

    if (!monitoringSession) {
      // Show client data panel on call start (even if skillData is missing)
      setClientDataPanelOpen(true);
      if (callData && callData.skillData && callData.skillData.skillData) {
        logger.log('[CLIENT DATA][DBG] Opening client panel on call start', {
          actionId: callData.actionId,
          dataId: callData.data_id || callData.dataId,
          skill: callData.skill,
          source: callData.source,
          hasSkillData: true,
          hasSkillConfig: !!callData.skillData?.skillConfig
        });
        setClientDataPanelOpen(true);
      } else {
        logger.warn('[CLIENT DATA][DBG] Call started without skillData', {
          hasCallData: !!callData,
          actionId: callData?.actionId,
          dataId: callData?.data_id || callData?.dataId,
          skill: callData?.skill,
          source: callData?.source,
          hasSkillData: false,
          callDataKeys: callData ? Object.keys(callData) : []
        });
      }
    }

  } else if (!inCall && callStartTime) {

    const wasMonitoringCall = lastCallWasMonitoringRef.current;

    if (!wasMonitoringCall) {
      lastCallWasMonitoringRef.current = false;

      // Call ended - capture skillConfig before it gets cleared

      logger.log('[DEBUG] Call ended, capturing skillConfig from callData:', callData);

      if (callData && callData.skillData && callData.skillData.skillConfig) {

        logger.log('[DEBUG] Saving skillConfig in DashboardLayout:', callData.skillData.skillConfig);

        setLastSkillConfig(callData.skillData.skillConfig);

      } else {

        logger.log('[DEBUG] No skillConfig to save in DashboardLayout');

      }



      // Call ended - show typification panel

      const callInfo = {

        duration: callDuration,

        startTime: callStartTime,

        endTime: Date.now(),

        callId: callData?.actionId || null,

        phoneNumber: callData?.callNumber || callData?.skillData?.Telefono1 || null

      };

      setLastCallInfo(callInfo);

      logger.log('[DEBUG] Call ended, lastCallInfo saved:', callInfo);

      logger.log('[DEBUG] Call ended, lastSkillConfig after saving:', lastSkillConfig);

      setTypificationPanelOpen(true);

      setPendingTypification(true); // Mark typification as pending

    } else {

      setPendingTypification(false);

      setTypificationPanelOpen(false);

    }



    setCallStartTime(null);

    setCallDuration('00:00');

  }



  if (inCall && callStartTime) {

    interval = setInterval(() => {

      const elapsed = Math.floor((Date.now() - callStartTime) / 1000);

      const minutes = Math.floor(elapsed / 60).toString().padStart(2, '0');

      const seconds = (elapsed % 60).toString().padStart(2, '0');

      setCallDuration(`${minutes}:${seconds}`);
    }, 1000);

  }



  return () => {

    if (interval) clearInterval(interval);

  };

}, [inCall, callStartTime, callDuration, callData, monitoringSession]);

  // Debug: track client data availability while inCall
  useEffect(() => {
    if (!inCall) return;
    if (!callData) {
      logger.warn('[CLIENT DATA][DBG] inCall without callData', {
        agentStatus,
        callStartTime
      });
      return;
    }

    const hasSkillData = !!(callData.skillData && callData.skillData.skillData);
    logger.log('[CLIENT DATA][DBG] callData snapshot', {
      actionId: callData.actionId,
      dataId: callData.data_id || callData.dataId,
      skill: callData.skill,
      source: callData.source,
      hasSkillData,
      hasSkillConfig: !!callData.skillData?.skillConfig,
      phoneNumber: callData.phone_number || callData.callNumber || callData.skillData?.Telefono1,
      callId: callData.callId || callData.ari_call_id || callData.uniqueId
    });

    if (!hasSkillData) {
      logger.warn('[CLIENT DATA][DBG] skillData missing while inCall', {
        actionId: callData.actionId,
        dataId: callData.data_id || callData.dataId,
        skill: callData.skill,
        source: callData.source,
        callDataKeys: Object.keys(callData || {})
      });
    }
  }, [inCall, callData, agentStatus, callStartTime]);



  // Track active dialing mode even if callData is cleared after the call

  useEffect(() => {

    if (!callData) return;



    const normalized = (

      callData.dialingModeNormalized ||

      callData.source ||

      (callData.actionId ? 'predictive' : '') ||

      ''

    ).toLowerCase();



    if (normalized && normalized !== activeDialingMode) {

      logger.log(`[AUTO STATUS] Tracking dialing mode: ${normalized}`);

      setActiveDialingMode(normalized);

    }

  }, [callData, activeDialingMode]);



  // Automatic status transitions for any active call

  useEffect(() => {

    if (isMonitoringCall || lastCallWasMonitoringRef.current) {
      return;
    }

    if (inCall) {

      if (agentStatus !== 'INCALL') {

        logger.log(`[AUTO STATUS] Call started, changing to INCALL from ${agentStatus}`);

        // NO usar expectedStatuses para que siempre tenga prioridad sobre cualquier estado
        changeAgentStatusAutomatic('INCALL', 'call-start', {});

      }

    } else if (!inCall && callStartTime) {

      if (agentStatus !== 'ACW') {

        logger.log(`[AUTO STATUS] Call ended, changing to ACW from ${agentStatus}`);

        // NO usar expectedStatuses para que siempre tenga prioridad
        changeAgentStatusAutomatic('ACW', 'call-ended', {});

      }

    }

  }, [inCall, agentStatus, callStartTime, changeAgentStatusAutomatic, statusLoading, isMonitoringCall]);

  // Deshabilitar botón de colgar por 5 segundos al iniciar llamada
  useEffect(() => {
    if (inCall) {
      setCanHangup(false);
      const timer = setTimeout(() => {
        setCanHangup(true);
      }, 5000);
      return () => clearTimeout(timer);
    } else {
      setCanHangup(true);
    }
  }, [inCall]);

  // Restaurar estado previo cuando finaliza una llamada manual
  useEffect(() => {
    logger.log('[MANUAL CALL][RESTORE] useEffect disparado', {
      inCall,
      currentCallDataSource: callData?.source,
      dialingModeNormalized: callData?.dialingModeNormalized,
      pendingManualStatus,
      manualReturnRef: manualReturnRef.current
    });

    const isManualCall = callData?.dialingModeNormalized === 'manual' || callData?.source === 'manual';
    if (inCall) return;
    if (!isManualCall) {
      logger.log('[MANUAL CALL][RESTORE] No es llamada manual, no se aplican cambios');
      return;
    }
    if (pendingManualStatus) {
      logger.log('[MANUAL CALL][RESTORE] Ya existe pendingManualStatus, se respeta', pendingManualStatus);
      return;
    }

    const { originStatus, callStartTime: trackedStart, actionId: trackedActionId } = manualReturnRef.current || {};
    if (!originStatus) return;

    const matchesAction = trackedActionId && callData?.actionId ? trackedActionId === callData.actionId : true;
    const matchesStart = trackedStart && callData?.startTime ? trackedStart === callData.startTime : true;

    if (!matchesAction && !matchesStart) {
      logger.log('[MANUAL CALL][RESTORE] No coincide actionId ni startTime, se ignora retorno', {
        trackedActionId,
        callActionId: callData?.actionId,
        trackedStart,
        callStart: callData?.startTime
      });
      return;
    }

    logger.log(`[MANUAL CALL] Aplicando estado original tras llamada manual: ${originStatus}`);
    setPendingManualStatus(originStatus);
    resetManualReturnRef();
  }, [inCall, callData, pendingManualStatus, resetManualReturnRef]);

  useEffect(() => {
    if (!inCall && agentStatus === 'AVAILABLE' && !pendingTypification && activeDialingMode) {
      const hasCallData = Boolean(
        callData?.dialingModeNormalized ||
        callData?.source ||
        callData?.actionId
      );

      if (hasCallData) {
        // Si aún hay metadata de llamada, no resetear para evitar bucles de tracking
        return;
      }

      logger.log('[AUTO STATUS] Resetting active dialing mode tracking');
      setActiveDialingMode(null);
    }
  }, [agentStatus, inCall, pendingTypification, activeDialingMode, callData]);

  // Helpers para tipificación automática
  const clearAutoTypificationTimer = useCallback(() => {
    if (autoTypificationTimerRef.current) {
      clearTimeout(autoTypificationTimerRef.current);
      autoTypificationTimerRef.current = null;
    }
    if (autoTypificationCountdownRef.current) {
      clearInterval(autoTypificationCountdownRef.current);
      autoTypificationCountdownRef.current = null;
    }
    autoTypificationStartRef.current = null;
    setAutoTypificationTimeLeft(null);
  }, []);

  useEffect(() => {
    const identity = getCallIdentity(callData);
    if (!identity) return;
    const prevIdentity = lastCallIdentityRef.current;
    if (prevIdentity && prevIdentity !== identity) {
      logger.log('[CALL RESET] Nueva llamada detectada, limpiando estado previo', {
        prevIdentity,
        identity
      });

      clearAutoTypificationTimer();
      setPendingTypification(false);
      setTypificationPanelOpen(false);
      setClientDataPanelOpen(false);
      setClientDataSnapshot(null);
      lastClientDataSnapshotRef.current = null;
      setClientDataManuallyClosed(false);
      setInteractionCache(null);
      clearInteractionCache();
      setLastCallInfo(null);
      clearLastSkillConfig();

      if (typificationData && !doesTypificationMatchCall(typificationData, callData)) {
        clearTypificationData();
      }
    }
    lastCallIdentityRef.current = identity;
  }, [
    callData,
    clearAutoTypificationTimer,
    clearLastSkillConfig,
    clearTypificationData,
    doesTypificationMatchCall,
    getCallIdentity,
    typificationData
  ]);

  const resolveSkillConfigForTypification = useCallback(() => {
    const ctx = latestTypificationContextRef.current || {};

    const skillCandidate =
      ctx?.callData?.skill ||
      ctx?.interactionCache?.skill ||
      ctx?.lastSkillConfig?.skilldef ||
      ctx?.typificationData?.skillName ||
      ctx?.selectedDialerSkill ||
      null;

    if (skillCandidate && skillConfigCache?.[skillCandidate]) {
      return skillConfigCache[skillCandidate];
    }

    if (ctx?.interactionCache?.skillConfig) {
      return ctx.interactionCache.skillConfig;
    }
    if (ctx?.callData?.skillData?.skillConfig) {
      return ctx.callData.skillData.skillConfig;
    }
    if (ctx?.lastSkillConfig) {
      return ctx.lastSkillConfig;
    }
    const fallback =
      ctx?.callData?.skillData ||
      (ctx?.interactionCache?.scriptAutoFinalCode || ctx?.interactionCache?.scriptMaxTimeSec
        ? {
            script_auto_final_code: ctx.interactionCache.scriptAutoFinalCode || null,
            script_maxtime_sec: ctx.interactionCache.scriptMaxTimeSec || null,
            script_maxtime_enable: ctx.interactionCache.scriptMaxTimeEnable
          }
        : null);
    return fallback;
  }, [skillConfigCache]);

  const resolveTypificationIdentifiers = useCallback(() => {
    const ctx = latestTypificationContextRef.current || {};
    const { typificationData, lastSkillConfig, callData } = ctx;
    let skillName;
    let dataId;
    let actionId;

    if (typificationData && typeof typificationData === 'object') {
      skillName = typificationData.skillName;
      dataId = typificationData.dataId;
      actionId = typificationData.actionId;
    }

    if (!skillName && !dataId && !actionId && lastSkillConfig) {
      skillName = lastSkillConfig.call_skill || lastSkillConfig.skilldef;
      dataId = lastSkillConfig.call_data_id;
      actionId = lastSkillConfig.call_action_id;
    }

    if (lastSkillConfig && (!skillName || !dataId || !actionId)) {
      if (!skillName) {
        skillName = lastSkillConfig.skill || lastSkillConfig.skillName;
      }
      if (!dataId) {
        dataId = lastSkillConfig.dataId || lastSkillConfig.data_id || lastSkillConfig.id;
      }
      if (!actionId) {
        actionId = lastSkillConfig.actionId || lastSkillConfig.action_id;
      }
    }

    if (!skillName && callData && callData.skill) {
      skillName = callData.skill;
    }
    if (!dataId && callData) {
      dataId = callData.data_id || callData.dataId;
    }
    if (!actionId && callData && callData.actionId) {
      actionId = callData.actionId;
    }

    return { skillName, dataId, actionId };
  }, []);

  const findTypificationByCode = useCallback((nodes = [], code, path = []) => {
    for (const node of nodes) {
      const nextPath = [...path, node.name || node.code || `#${node.id}`];
      // Buscar solo por id
      if (node.is_final && String(node.id) === String(code)) {
        return { node, path: nextPath };
      }
      if (node.children && node.children.length) {
        const found = findTypificationByCode(node.children, code, nextPath);
        if (found) return found;
      }
    }
    return null;
  }, []);

  // Return to AVAILABLE after typification completion
  const handleReturnToAvailable = () => {
    if (agentStatus === 'ACW') {
      if (pendingManualStatus) {
        logger.log(`[AUTO STATUS] Typification completed, applying pending manual status ${pendingManualStatus} (skip AVAILABLE)`);
        changeAgentStatus(pendingManualStatus, '', { silent: false });
        setPendingManualStatus(null);
        return;
      }
      logger.log(`[AUTO STATUS] Typification completed, returning to AVAILABLE (no pending manual status)`);
      changeAgentStatusAutomatic('AVAILABLE', 'typification-complete', { expectedStatuses: ['ACW'] });
    }
    if (activeDialingMode) {
      setActiveDialingMode(null);
    }
  };

  // Safety checks to avoid stuck INCALL/ACW states
  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();

      if (inCall && !monitoringSession) {
        const elapsedMs = callStartTime ? now - callStartTime : 0;
        if (!hasActiveRtp && callStartTime && elapsedMs > 8000) {
          logger.warn('[CALL SAFETY] inCall without RTP, resetting state', {
            elapsedMs,
            callStartTime,
            hasActiveRtp,
            callData
          });

          setInCall(false);
          clearMonitoringSession();
          setPendingTypification(false);
          setTypificationPanelOpen(false);
          setClientDataPanelOpen(false);
          setClientDataSnapshot(null);
          setClientDataManuallyClosed(true);
          setInteractionCache(null);
          clearInteractionCache();
          setLastCallInfo(null);
          clearLastSkillConfig();
          clearTypificationData();
          clearCallData();
          resetPreviewState();
          setCallStartTime(null);
          setCallDuration('00:00');
          handleReturnToAvailable();
        }
      }

      if (!inCall && agentStatus === 'ACW' && !pendingTypification && !typificationPanelOpen) {
        logger.warn('[ACW SAFETY] ACW without typification panel, resetting state');

        clearMonitoringSession();
        setPendingTypification(false);
        setTypificationPanelOpen(false);
        setClientDataPanelOpen(false);
        setClientDataSnapshot(null);
        setClientDataManuallyClosed(true);
        setInteractionCache(null);
        clearInteractionCache();
        setLastCallInfo(null);
        clearLastSkillConfig();
        clearTypificationData();
        clearCallData();
        resetPreviewState();
        setCallStartTime(null);
        setCallDuration('00:00');
        changeAgentStatusAutomatic('AVAILABLE', 'acw-without-typification', { expectedStatuses: ['ACW'] });
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [
    inCall,
    monitoringSession,
    hasActiveRtp,
    callStartTime,
    callData,
    agentStatus,
    pendingTypification,
    typificationPanelOpen,
    changeAgentStatusAutomatic,
    handleReturnToAvailable,
    clearMonitoringSession,
    clearInteractionCache,
    clearLastSkillConfig,
    clearTypificationData,
    clearCallData,
    resetPreviewState,
    setCallStartTime,
    setCallDuration,
    setClientDataManuallyClosed,
    setClientDataPanelOpen,
    setClientDataSnapshot,
    setInteractionCache,
    setInCall,
    setLastCallInfo,
    setPendingTypification,
    setTypificationPanelOpen
  ]);

  const handleAutoTypification = useCallback(async () => {
    try {
      const ctx = latestTypificationContextRef.current || {};

      // Solo validar que haya tipificación pendiente y no esté en llamada
      if (!ctx.pendingTypification || ctx.inCall) {
        logger.warn('[AUTO TIP] Abortado: pendingTypification=', ctx.pendingTypification, 'inCall=', ctx.inCall);
        clearAutoTypificationTimer();
        return;
      }

      const skillConfig = resolveSkillConfigForTypification();
      const autoCode = skillConfig?.script_auto_final_code;
      const maxTimeSec = Number(skillConfig?.script_maxtime_sec) || 0;
      if (!autoCode || maxTimeSec <= 0) {
        logger.warn('[AUTO TIP] Abortado: sin configuración válida. autoCode=', autoCode, 'maxTimeSec=', maxTimeSec);
        clearAutoTypificationTimer();
        return;
      }

      const groupsResp = await ends.getGroups({ include_inactive: true, cache: true });
      const groups = groupsResp?.data || [];
      let match = null;

      for (const group of groups) {
        const treeResp = await ends.getTree(group.id, { cache: true, include_inactive: true });
        if (!treeResp?.success) continue;
        const found = findTypificationByCode(treeResp.data || [], autoCode);
        if (found?.node) {
          match = found;
          break;
        }
      }

      if (!match?.node) {
        logger.warn('[AUTO TIP] No se encontró el final automático', autoCode);
        clearAutoTypificationTimer();
        setTypificationPanelOpen(false);
        setIsInGracePeriod(false);
        setPendingTypification(false);
        setCallStartTime(null);
        setCallDuration('00:00');
        changeAgentStatusAutomatic('AVAILABLE', 'autotip-code-not-found', { expectedStatuses: ['ACW'] });
        return;
      }

      const { skillName, dataId, actionId } = resolveTypificationIdentifiers();
      const hasActionId = !!actionId;
      if (!skillName || (!dataId && !hasActionId)) {
        logger.warn('[AUTO TIP] Faltan datos requeridos. skillName=', skillName, 'dataId=', dataId, 'actionId=', actionId);
        clearAutoTypificationTimer();
        setTypificationPanelOpen(false);
        setIsInGracePeriod(false);
        setPendingTypification(false);
        setCallStartTime(null);
        setCallDuration('00:00');
        changeAgentStatusAutomatic('AVAILABLE', 'autotip-missing-data', { expectedStatuses: ['ACW'] });
        return;
      }

      let timeAcw = 0;
      if (ctx.agentStatusStartTime) {
        timeAcw = Math.floor((Date.now() - ctx.agentStatusStartTime) / 1000);
      }

      // Calcular timecall desde frontend como backup
      let timecallFrontend = 0;
      if (lastCallInfo?.startTime && lastCallInfo?.endTime) {
        timecallFrontend = Math.max(0, Math.floor((lastCallInfo.endTime - lastCallInfo.startTime) / 1000));
      }

      const typificationPayload = {
        skillName,
        dataId: dataId || null,
        typificationId: match.node.id,
        typificationName: match.node.name,
        typificationPath: (match.path || [])[0] || '',
        actionId: actionId || null,
        timeAcw,
        timecallFrontend
      };

      const queued = enqueueTypification(typificationPayload);
      if (!queued) {
        throw new Error('No se pudo encolar la tipificación automática');
      }
      processTypificationQueue();

      clearAutoTypificationTimer();
      setTypificationPanelOpen(false);
      setIsInGracePeriod(false); // Resetear período de gracia después de auto-tipificación
      // NO limpiar setPendingTypification(false) todavía - hacerlo DESPUÉS de cambiar estado
      setClientDataPanelOpen(false);
      setClientDataSnapshot(null);
      setClientDataManuallyClosed(true);
      setInteractionCache(null);
      clearInteractionCache();
      setLastCallInfo(null);
      clearLastSkillConfig();
      clearCallData();
      resetPreviewState();
      // Limpiar callStartTime para evitar que el effect de auto-status re-dispare ACW
      setCallStartTime(null);
      setCallDuration('00:00');

      // Aplicar estado manual pendiente primero; si no hay, volver a AVAILABLE
      isApplyingPendingStatusRef.current = true;
      try {
        // Usar el valor más reciente de pendingManualStatus desde el contexto
        const currentPendingStatus = ctx.pendingManualStatus;
        if (currentPendingStatus) {
          logger.log('[AUTO TIP] Aplicando estado pendiente:', currentPendingStatus);
          const targetStatus = currentPendingStatus;
          setPendingManualStatus(null);

          const ok = await changeAgentStatusAutomatic(targetStatus, 'pending-manual-after-autotip', {
            expectedStatuses: ['ACW']
          });
          if (!ok) {
            changeAgentStatusAutomatic('AVAILABLE', 'autotip-fallback', { expectedStatuses: ['ACW'] });
          }
        } else {
          changeAgentStatusAutomatic('AVAILABLE', 'autotip-complete', { expectedStatuses: ['ACW'] });
        }
      } finally {
        setPendingTypification(false);
        isApplyingPendingStatusRef.current = false;
      }

      showSuccess('Tipificación automática aplicada por tiempo máximo de script', { duration: 4000 });
    } catch (err) {
      console.error('[AUTO TYPIFICATION] Error:', err);
      showError(err?.message || 'Error al aplicar tipificación automática');
      // Limpiar estado para desbloquear al agente en caso de error
      clearAutoTypificationTimer();
      setTypificationPanelOpen(false);
      setIsInGracePeriod(false);
      setPendingTypification(false);
      setCallStartTime(null);
      setCallDuration('00:00');
      changeAgentStatusAutomatic('AVAILABLE', 'autotip-error-recovery', { expectedStatuses: ['ACW'] });
    }
  }, [
    clearAutoTypificationTimer,
    clearCallData,
    clearInteractionCache,
    clearLastSkillConfig,
    changeAgentStatus,
    changeAgentStatusAutomatic,
    ends,
    enqueueTypification,
    findTypificationByCode,
    handleReturnToAvailable,
    processTypificationQueue,
    resetPreviewState,
    resolveSkillConfigForTypification,
    resolveTypificationIdentifiers,
    showError,
    showSuccess
  ]);

  // Mantener ref actualizado para que el timer siempre llame la versión más reciente
  handleAutoTypificationRef.current = handleAutoTypification;

  // Auto-tipificación por tiempo máximo de script
  useEffect(() => {
    const ctx = latestTypificationContextRef.current || {};
    const skillConfig = resolveSkillConfigForTypification();
    let maxTimeSec = Number(skillConfig?.script_maxtime_sec) || 0;
    let autoCode = skillConfig?.script_auto_final_code;

    // Si ya hay timer activo y la config se perdió por un refresh, conserva últimos valores para no reiniciar
    if (autoTypificationTimerRef.current && autoTypificationParamsRef.current) {
      maxTimeSec = maxTimeSec || autoTypificationParamsRef.current.maxTimeSec || 0;
      autoCode = autoCode || autoTypificationParamsRef.current.autoCode || null;
    }

    // Si no hay tipificación pendiente, limpiar timer
    if (!pendingTypification) {
      clearAutoTypificationTimer();
      return;
    }

    // Si inició otra llamada, significa que ya tipificó, limpiar timer
    if (inCall) {
      clearAutoTypificationTimer();
      return;
    }

    // PROTECCIÓN PRINCIPAL: Si ya hay un timer activo, NO reprogramar
    // Esto previene que cambios de estado (como setPendingManualStatus) causen re-renders
    // que limpien y reprogramen el timer, haciendo que la barra de progreso parpadee
    if (autoTypificationTimerRef.current) {
      logger.log('[AUTO TIP] Timer ya activo, evitando reprogramación');
      return;
    }

    // Si no hay configuración de tiempo/código, no programar timer
    if (!maxTimeSec || !autoCode) {
      clearAutoTypificationTimer();
      return;
    }

    // Programar timer de auto-tipificación
    const delayMs = Math.max(1, Math.round(maxTimeSec)) * 1000;
    const scheduleKey = `${pendingTypification}_${autoCode}_${maxTimeSec}`;

    // Si ya existe un timer con la misma clave, no reprogramar; solo actualizar el countdown restante
    if (autoTypificationTimerRef.current && autoTypificationLogKeyRef.current === scheduleKey) {
      if (autoTypificationStartRef.current) {
        const elapsedSec = Math.floor((Date.now() - autoTypificationStartRef.current) / 1000);
        const remaining = Math.max(0, maxTimeSec - elapsedSec);
        setAutoTypificationTimeLeft(remaining);
      }
      return; // IMPORTANTE: No reprogramar, mantener el timer existente
    }

    // Reprogramar timer cuando cambien los parámetros clave
    autoTypificationLogKeyRef.current = scheduleKey;
    autoTypificationParamsRef.current = { autoCode, maxTimeSec };
    logger.log('[AUTO TIP] Programando timer:', maxTimeSec, 'seg');
    clearAutoTypificationTimer();

    autoTypificationStartRef.current = Date.now();

    // Iniciar countdown visual
    setAutoTypificationTimeLeft(maxTimeSec);
    setIsInGracePeriod(false);

    autoTypificationCountdownRef.current = setInterval(() => {
      setAutoTypificationTimeLeft(prev => {
        // Activar período de gracia cuando quedan 3 segundos o menos
        if (prev <= 3 && !isInGracePeriod) {
          setIsInGracePeriod(true);
          logger.log('[AUTO TIP] Entrando en período de gracia (3 seg restantes)');
        }

        if (prev <= 1) {
          clearInterval(autoTypificationCountdownRef.current);
          autoTypificationCountdownRef.current = null;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Timer principal - se ejecuta exactamente al mismo tiempo que termina el countdown
    // El período de gracia ya está incluido en el delayMs original
    // IMPORTANTE: Usar ref para llamar siempre la versión más reciente de handleAutoTypification
    // El setTimeout captura una closure obsoleta si se usa handleAutoTypification directamente
    autoTypificationTimerRef.current = setTimeout(() => {
      logger.log('[AUTO TIP] Ejecutando auto-tipificación');
      // NO resetear isInGracePeriod para mantener botones deshabilitados
      if (handleAutoTypificationRef.current) {
        handleAutoTypificationRef.current();
      } else {
        console.error('[AUTO TIP] handleAutoTypificationRef.current es null - no se pudo ejecutar');
        clearAutoTypificationTimer();
      }
    }, delayMs);

  }, [
    pendingTypification,
    inCall,
    skillConfigCache,
    lastSkillConfig,
    selectedDialerSkill,
    resolveSkillConfigForTypification,
    clearAutoTypificationTimer
  ]);

  // ACW Watchdog desactivado: NO cambiar a AVAILABLE automáticamente sin tipificación
  useEffect(() => {
    if (acwWatchdogRef.current) {
      clearInterval(acwWatchdogRef.current);
      acwWatchdogRef.current = null;
    }
  }, []);

  // Limpiar timers al desmontar
  useEffect(() => {
    return () => clearAutoTypificationTimer();
  }, [clearAutoTypificationTimer]);



  // Preview mode specific transitions

  useEffect(() => {

    if (!callData || callData.source !== 'preview') return;

    // In preview mode, always show customer data panel when client data is present.
    // If it was manually closed in a previous interaction, re-open it for the new preview.
    if (hasClientData && !inCall) {
      setClientDataManuallyClosed(false);
      setClientDataPanelOpen(true);
    }


    // When preview data arrives but not in call yet -> PRECALL

    // Only change if currently AVAILABLE and not recently changed (prevent loops)

    const previewId = callData?.previewId || callData?.previewData?.previewId || 'no-preview-id';
    const statusKey = `preview:${previewId}:to-precall`;

    if (callData && hasClientData && !inCall && agentStatus === 'AVAILABLE') {
      if (lastStatusChangeRef.current === statusKey || lastStatusChangeRef.current === `pending:${statusKey}`) {
        return;
      }

      logger.log(`[AUTO STATUS] Preview data received, changing to PRECALL from ${agentStatus}`, {
        previewId
      });

      lastStatusChangeRef.current = `pending:${statusKey}`;

      (async () => {
        const changed = await changeAgentStatusAutomatic('PRECALL', 'preview-data', { expectedStatuses: ['AVAILABLE'] });
        if (changed) {
          lastStatusChangeRef.current = statusKey;
        } else {
          // Allow retry on next render/tick if the automatic transition failed.
          lastStatusChangeRef.current = null;
          logger.warn('[AUTO STATUS] Preview PRECALL transition failed, will retry if conditions still apply', {
            previewId,
            currentStatus: agentStatus
          });
        }
      })();
    }

  }, [callData, hasClientData, inCall, agentStatus, changeAgentStatusAutomatic]);



  // Agent status timer (local only, no HTTP)

  useEffect(() => {
    if (!agentStatusStartTime) return;

    const interval = setInterval(() => {
      const elapsed = Math.max(0, Math.floor((Date.now() - agentStatusStartTime) / 1000));
      setAgentStatusDuration(formatAgentStatusDuration(elapsed));
    }, 1000);

    return () => clearInterval(interval);
  }, [agentStatusStartTime]);

  // Initialize timer when status is loaded (recover from sessionStorage on reload)
  useEffect(() => {
    if (agentStatus && !agentStatusStartTime) {
      const now = Date.now();
      logger.log(`[AGENT STATUS TIMER] Initializing timer for status: ${agentStatus}`);
      setAgentStatusStartTime(now);
      try { sessionStorage.setItem('cti_agent_status_start', String(now)); } catch (e) { /* ignore */ }
    }
  }, [agentStatus, agentStatusStartTime]);



  const handleMenuClick = (event) => {

    setAnchorEl(event.currentTarget);

  };

  const handleAvatarIconClick = (event) => {
    const target = event.currentTarget;
    // Abrir menú conservando el target
    setTimeout(() => setAnchorEl(target), 50);
  };



  const handleMenuClose = () => {

    setAnchorEl(null);

  };

  // Calculate groupId for typification using useMemo to avoid infinite renders
  const typificationGroupId = useMemo(() => {
    const parseGroupId = (val) => {
      if (typeof val === 'number') return val;
      const parsed = parseInt(val, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    };

    const skillCandidate =
      lastSkillConfig?.skilldef ||
      lastSkillConfig?.call_skill ||
      callData?.skill ||
      typificationData?.skillName ||
      interactionCache?.skill ||
      null;

    if (skillCandidate && skillConfigCache?.[skillCandidate]) {
      const fromCache = parseGroupId(skillConfigCache[skillCandidate]?.finales_name);
      if (fromCache) return fromCache;
    }

    const fromLast = parseGroupId(lastSkillConfig?.finales_name);
    if (fromLast) return fromLast;

    const fromCurrent = parseGroupId(callData?.skillData?.skillConfig?.finales_name);
    if (fromCurrent) return fromCurrent;

    const fromPersistent = parseGroupId(callData?.skillData?.finales_name) ||
      parseGroupId(callData?.finales_name) ||
      parseGroupId(typificationData?.finales_name) ||
      parseGroupId(interactionCache?.skillConfig?.finales_name);
    if (fromPersistent) return fromPersistent;

    logger.log('[TYPIFICATION][DEBUG] No finales_name found, defaulting groupId to 1', {
      lastSkillConfig,
      callDataSkillConfig: callData?.skillData?.skillConfig,
      callDataRaw: callData,
      typificationData,
      interactionCache,
      skillConfigCache
    });
    return 1;

  }, [lastSkillConfig, callData, typificationData, interactionCache, skillConfigCache]);

  // Calculate current skillDef for typification logging
  const currentSkillDef = useMemo(() => {
    return (
      lastSkillConfig?.skilldef ||
      lastSkillConfig?.call_skill ||
      callData?.skill ||
      typificationData?.skillName ||
      interactionCache?.skill ||
      null
    );
  }, [lastSkillConfig, callData, typificationData, interactionCache]);

  // Keep latest context for async auto-tipificación callbacks
  useEffect(() => {
    latestTypificationContextRef.current = {
      pendingTypification,
      inCall,
      agentStatus,
      agentStatusStartTime,
      lastSkillConfig,
      callData,
      interactionCache,
      typificationData: softphoneContext?.typificationData || typificationData,
      typificationGroupId,
      selectedDialerSkill,
      pendingManualStatus
    };
  }, [pendingTypification, inCall, agentStatus, agentStatusStartTime, lastSkillConfig, callData, interactionCache, typificationData, softphoneContext?.typificationData, typificationGroupId, selectedDialerSkill, pendingManualStatus]);



  const handleLogout = async () => {

    handleMenuClose();

    logger.log('[LOGOUT]  Iniciando logout inmediato...');



    try {

      // 1. PRIMERO: Destruir token inmediatamente para cortar autenticación

      logger.log('[LOGOUT] 1 Destruyendo token de autenticación...');

      localStorage.removeItem('cti_admin_token');

      localStorage.removeItem('cti_admin_user');

      sessionStorage.clear();



      // Limpiar cookies inmediatamente

      document.cookie.split(';').forEach((c) => {

        document.cookie = c

          .replace(/^ +/, '')

          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);

      });



      // 2. Intentar logout del agente en background (sin esperar)

      logger.log('[LOGOUT] 2 Iniciando logout de agente en background...');

      logoutAgent().catch(error => {

        logger.warn('[LOGOUT] Warning en logout de agente:', error);

      });



      // 3. Desconectar softphone en background (sin esperar)

      logger.log('[LOGOUT] 3 Desconectando softphone en background...');

      if (contextDisconnect) {

        contextDisconnect().catch(error => {

          logger.warn('[LOGOUT] Warning al desconectar softphone:', error);

        });

      }



      // 4. Llamar al logout de auth (sin esperar respuesta)

      logger.log('[LOGOUT] 4 Llamando logout de auth en background...');

      logout().catch(error => {

        logger.warn('[LOGOUT] Warning en logout de auth:', error);

      });



      // 5. INMEDIATAMENTE: Forzar recarga de la página para ir al login

      logger.log('[LOGOUT] 5 Forzando recarga de página...');



      // Usar un timeout muy pequeño para permitir que los logs se vean

      setTimeout(() => {

        window.location.href = '/login';

      }, 100);



    } catch (error) {

      console.error('[LOGOUT] ❌ Error durante logout:', error);



      // Si algo falla, aún destruir token y redirigir

      try {

        localStorage.clear();

        sessionStorage.clear();

      } catch (e) {

        console.error('[LOGOUT] Error en fallback cleanup:', e);

      }



      window.location.href = '/login';

    }

  };



  const handlePreSessionCancel = () => {
    cancelPreSessionLogin();
    // Refuerzo extra de navegación en la vista (por si el logout tarda)
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
      setTimeout(() => window.location.reload(), 300);
    }
  };

  const handlePreSessionForce = async () => {
    await forcePreSessionLogin();
  };



  const handleGoToLogin = async () => {

    resolveSessionConflict();

    await handleLogout();

  };



  const handleRecoverFromTimeout = async () => {

    try {

      logger.log('[TIMEOUT RECOVERY] Starting timeout recovery...');



      // Resolver el timeout primero

      resolveSessionTimeout();



      // Forzar reset de sesión

      await forceSessionReset();



      logger.log('[TIMEOUT RECOVERY] Session reset completed, reloading page...');



      // Recargar la página después de un breve delay

      setTimeout(() => {

        window.location.reload();

      }, 500);



    } catch (error) {

      console.error('[TIMEOUT RECOVERY] Error during timeout recovery:', error);

      // Fallback: solo recargar

      window.location.reload();

    }

  };



  const handleLogoutFromTimeout = async () => {

    resolveSessionTimeout();

    await handleLogout();

  };

  const conflictSoftphoneClosedRef = useRef(false);
  const timeoutSoftphoneClosedRef = useRef(false);
  const sessionConflictHandledRef = useRef(false);
  const handleLogoutRef = useRef(handleLogout);
  useEffect(() => {
    handleLogoutRef.current = handleLogout;
  }, [handleLogout]);



  useEffect(() => {
    const allowedLogoutReasons = new Set(['duplicate_session', 'session_replaced', 'supervisor_force', 'logout']);

    if (sessionConflict && !conflictSoftphoneClosedRef.current) {

      contextDisconnect?.();

      conflictSoftphoneClosedRef.current = true;

      if (!preSessionConflict && !sessionConflictHandledRef.current) {
        sessionConflictHandledRef.current = true;

        const conflictReason = conflictInfo?.reason || 'unknown';
        if (allowedLogoutReasons.has(conflictReason)) {
          handleLogoutRef.current?.();
        } else {
          logger.warn('[SESSION CONFLICT] Conflicto sin logout automático (reason no permitido):', conflictReason);
        }
      }

    } else if (!sessionConflict && conflictSoftphoneClosedRef.current) {

      conflictSoftphoneClosedRef.current = false;
      sessionConflictHandledRef.current = false;

    }

  }, [sessionConflict, preSessionConflict, contextDisconnect, conflictInfo]);



  useEffect(() => {

    if (sessionTimeout && !timeoutSoftphoneClosedRef.current) {

      contextDisconnect?.();

      timeoutSoftphoneClosedRef.current = true;

    } else if (!sessionTimeout && timeoutSoftphoneClosedRef.current) {

      timeoutSoftphoneClosedRef.current = false;

    }

  }, [sessionTimeout, contextDisconnect]);



  const handleProfileClick = async () => {
    handleMenuClose();

    const agentId = currentAgent?.agent || user?.agent || user?.username || user?.id;
    if (!agentId) {
      showError('No se pudo determinar el ID del agente');
      return;
    }

    setProfileOpen(true);
    setProfileLoading(true);
    setProfileAvatarFile(null);

    try {
      const response = await api.agents.getById(agentId);
      const agentData = response?.data?.agent || {};
      const extra = parseAgentExtraConfig(agentData.extra_config);

      setProfileForm({
        name: agentData.name || '',
        agentId: agentData.agent || agentId,
        documentNumber: agentData.document_number || '',
        message: extra.welcome_message || extra.custom_message || '',
        avatarUrl: resolveAvatarUrl(extra.avatar_path || extra.avatar_url || ''),
        newPassword: '',
        confirmPassword: '',
        removeAvatar: false
      });
    } catch (error) {
      console.error('[PROFILE] Error loading profile:', error);
      showError('No se pudo cargar el perfil del agente');
      setProfileOpen(false);
    } finally {
      setProfileLoading(false);
    }
  };

  const handleOpenAvatarMenu = (event) => {
    setAvatarMenuAnchorEl(event.currentTarget);
  };

  const handleCloseAvatarMenu = () => {
    setAvatarMenuAnchorEl(null);
  };

  const handleOpenAvatarSelector = () => {
    setAvatarSelectorOpen(true);
    setAvatarMenuAnchorEl(null);
  };

  const handleCloseAvatarSelector = () => {
    setAvatarSelectorOpen(false);
  };

  const handleOpenAvatarCreator = () => {
    setAvatarCreatorOpen(true);
    setAvatarMenuAnchorEl(null);
  };

  const handleCloseAvatarCreator = () => {
    setAvatarCreatorOpen(false);
  };

  const handleAvatarSelect = async (avatarUrl) => {
    if (!avatarUrl) return;

    try {
      // Para avatares locales, convertir la URL al archivo local
      const localAvatarPath = avatarUrl;

      // Si es un avatar local (comienza con /uploads/avatars/), fetch desde el servidor local
      if (localAvatarPath.startsWith('/uploads/avatars/')) {
        const response = await fetch(localAvatarPath);
        if (response.ok) {
          const blob = await response.blob();
          const file = new File([blob], 'local-avatar.png', { type: blob.type || 'image/png' });
          setProfileAvatarFile(file);
          setProfileForm((prev) => ({
            ...prev,
            avatarUrl: URL.createObjectURL(file),
            removeAvatar: false
          }));
        } else {
          // Si no se puede cargar, usar la URL directamente
          setProfileForm((prev) => ({
            ...prev,
            avatarUrl: localAvatarPath,
            removeAvatar: false
          }));
          setProfileAvatarFile(null);
        }
      } else {
        // Para URLs externas (mantener compatibilidad)
        setProfileForm((prev) => ({
          ...prev,
          avatarUrl: avatarUrl,
          removeAvatar: false
        }));
        setProfileAvatarFile(null);
      }

      setAvatarSelectorOpen(false);
    } catch (error) {
      console.error('[PROFILE] Error selecting avatar:', error);
      showError('No se pudo cargar el avatar seleccionado');
    }
  };



  const handleProfileFieldChange = (field, value) => {
    setProfileForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleAvatarSelected = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    setProfileAvatarFile(file);
    setProfileForm((prev) => ({
      ...prev,
      avatarUrl: URL.createObjectURL(file),
      removeAvatar: false
    }));
    setAvatarMenuAnchorEl(null);
  };

  const handleCameraCapture = (event) => {
    handleAvatarSelected(event);
  };

  const handleRemoveAvatar = () => {
    setProfileAvatarFile(null);
    setProfileForm((prev) => ({
      ...prev,
      avatarUrl: '',
      removeAvatar: true
    }));
    setAvatarMenuAnchorEl(null);
  };

  const handleProfileClose = () => {
    if (profileSaving) return;
    setProfileOpen(false);
    setAvatarMenuAnchorEl(null);
    setAvatarSelectorOpen(false);
  };

  const handleProfileSave = async () => {
    if (profileSaving) return;
    const agentId = profileForm.agentId || currentAgent?.agent || user?.agent || user?.username || user?.id;

    if (!agentId) {
      showError('No se pudo determinar el ID del agente');
      return;
    }

    if (profileForm.newPassword && profileForm.newPassword !== profileForm.confirmPassword) {
      showError('Las contraseñas no coinciden');
      return;
    }

    const formData = new FormData();
    formData.append('name', profileForm.name || '');
    formData.append('message', profileForm.message || '');
    if (profileForm.newPassword) {
      formData.append('password', profileForm.newPassword);
    }
    if (profileAvatarFile) {
      formData.append('avatar', profileAvatarFile);
    }
    if (profileForm.removeAvatar) {
      formData.append('removeAvatar', '1');
    }

    setProfileSaving(true);
    try {
      const response = await api.agents.updateProfile(agentId, formData);
      const avatarPath = response?.data?.avatar_path || '';

      updateStoredUser({
        name: profileForm.name,
        avatar_path: avatarPath,
        welcome_message: profileForm.message,
        extra_config: {
          ...(user?.extra_config || {}),
          avatar_path: avatarPath,
          welcome_message: profileForm.message
        }
      });
      const agentKey = profileForm.agentId || currentAgent?.agent || user?.agent || user?.username || 'default';
      localStorage.removeItem(`cti_welcome_shown_${agentKey}`);

      showSuccess('Perfil actualizado');
      setProfileOpen(false);
    } catch (error) {
      console.error('[PROFILE] Error saving profile:', error);
      showError(error?.message || 'No se pudo guardar el perfil');
    } finally {
      setProfileSaving(false);
    }
  };

  // Mostrar mensaje personalizado al inicio si existe
  useEffect(() => {
    const message = user?.welcome_message || user?.extra_config?.welcome_message || user?.extra_config?.custom_message;
    if (!message) return;
    const agentKey = user?.agent || user?.username || 'default';
    const key = `cti_welcome_shown_${agentKey}`;
    const alreadyShown = localStorage.getItem(key);
    if (alreadyShown === '1') return;
    showInfo(message);
    localStorage.setItem(key, '1');
  }, [user, showInfo]);


  const handleConfigClick = () => {

    handleMenuClose();

    setConfigOpen(true);

  };

  const handleStatusChange = useCallback(

    async (newStatus) => {

      logger.log(`[HANDLE STATUS CHANGE] Called with newStatus=${newStatus}, statusLoading=${statusLoading}, agentStatus=${agentStatus}`);

      if (statusLoading || !newStatus || newStatus === agentStatus) {
        logger.log(`[HANDLE STATUS CHANGE] Blocked: statusLoading=${statusLoading}, !newStatus=${!newStatus}, same=${newStatus === agentStatus}`);
        return;
      }

      const interactionBlocking = inCall || pendingTypification || ['PRECALL', 'INCALL', 'ACW'].includes(agentStatus);
      if (interactionBlocking) {
        logger.log(`[HANDLE STATUS CHANGE] Interaction blocking detected, setting pendingManualStatus to ${newStatus}`);
        setPendingManualStatus(newStatus);
        persistManualPauseStatus(newStatus);
        showInfo('El cambio de estado se aplicará al terminar la interacción.');
        return;
      }

      if (String(newStatus).toUpperCase() === 'AVAILABLE' && !micPermissionGranted) {
        const ok = await requestMicPermission();
        if (!ok) return;
      }

      setStatusLoading(true);

      try {

        logger.log(`[HANDLE STATUS CHANGE] Iniciando cambio a ${newStatus}, inCall=${inCall}`);

        const success = await changeAgentStatus(newStatus, '', { silent: false });
        logger.log(`[HANDLE STATUS CHANGE] Cambio completado, success=${success}`);

        if (success) {

          setAgentStatusOverride(null);

          setAgentStatusStartTime(Date.now());

          setPendingManualStatus(null);
          persistManualPauseStatus(newStatus);

        }

      } catch (error) {

        console.error('Error updating agent status:', error);

      } finally {

        setStatusLoading(false);

      }

    },

    [changeAgentStatus, statusLoading, agentStatus, micPermissionGranted, requestMicPermission, inCall, pendingTypification, showInfo, persistManualPauseStatus]

  );

  /**
   * Manejar re-llamar desde "Mis Llamadas"
   *
   * @param {string} phoneNumber - Número de teléfono a marcar
   * @param {object|null} clientData - Datos del cliente (solo para llamadas desde seguimiento)
   *
   * Funcionalidad:
   * - Historial: Solo número en dialer, agente selecciona skill
   * - Seguimiento: Número + datos del cliente, agente selecciona skill
   * - Al presionar "Llamar": El flujo normal cambia el agente a PRECALL
   */
  const handleRedialFromAgentCalls = useCallback(
    async (phoneNumber, clientData = null) => {
      logger.log('[REDIAL] Iniciando re-llamar:', { phoneNumber, hasClientData: !!clientData });

      // VALIDACIÓN: Evitar abrir dialer si ya hay una llamada activa
      if (inCall) {
        showError('Ya hay una llamada activa. Finaliza la llamada actual antes de realizar otra.');
        return;
      }

      // Validar que el softphone esté conectado
      // En modo transición no bloqueamos el dialer por conexión del softphone

      // Validar número de teléfono
      const sanitizedNumber = (phoneNumber || '').replace(/[^0-9*#]/g, '').trim();
      if (!sanitizedNumber) {
        showError('Número de teléfono inválido.');
        return;
      }

      try {
        // 1. Pre-llenar el número en el dialer
        setDialNumber(sanitizedNumber);

        // 2. Si hay datos del cliente (desde seguimiento), actualizarlos
        if (clientData) {
          logger.log('[REDIAL] Mostrando datos del cliente desde seguimiento:', clientData);
          // Actualizar callData con los datos del cliente del seguimiento
          setCallData(prev => ({
            ...(prev || {}),
            source: 'redial_tracking',
            skillData: clientData,
            phone: sanitizedNumber
          }));
        } else {
          logger.log('[REDIAL] Re-llamar desde historial (sin datos de cliente)');
          // Limpiar datos de cliente previos
          setCallData(prev => ({
            ...(prev || {}),
            source: 'redial_history',
            skillData: null,
            phone: sanitizedNumber
          }));
        }

        // 3. Abrir el dialer (el cambio a PRECALL ocurrirá cuando presione "Llamar")
        setDialerOpen(true);

        showInfo(clientData
          ? `Discador abierto con datos del cliente. Selecciona el skill y presiona llamar.`
          : `Discador abierto. Selecciona el skill y presiona llamar.`
        );

      } catch (error) {
        console.error('[REDIAL] Error en re-llamar:', error);
        showError('Error al preparar la llamada: ' + error.message);
      }
    },
    [inCall, registered, showError, showInfo]
  );

  // DESHABILITADO: Este useEffect causa intermitencia porque se dispara múltiples veces
  // El cambio pendiente ahora se aplica SOLO en handleAutoTypification y handleReturnToAvailable
  // useEffect(() => {
  //   if (!pendingManualStatus) return;
  //   if (statusLoading) return;
  //   if (inCall || pendingTypification || ['PRECALL', 'INCALL', 'ACW'].includes(agentStatus)) {
  //     return;
  //   }
  //
  //   if (isApplyingPendingStatusRef.current) {
  //     logger.log('[PENDING STATUS] Skipping useEffect application - handleAutoTypification is handling it');
  //     return;
  //   }
  //
  //   const applyPending = async () => {
  //     if (String(pendingManualStatus).toUpperCase() === 'AVAILABLE' && !micPermissionGranted) {
  //       const ok = await requestMicPermission();
  //       if (!ok) return;
  //     }
  //     setStatusLoading(true);
  //     try {
  //       const success = await changeAgentStatus(pendingManualStatus, '', { silent: false });
  //       if (success) {
  //         setAgentStatusOverride(null);
  //         setAgentStatusStartTime(Date.now());
  //         setPendingManualStatus(null);
  //       }
  //     } catch (err) {
  //       console.error('Error applying pending manual status:', err);
  //     } finally {
  //       setStatusLoading(false);
  //     }
  //   };
  //
  //   applyPending();
  // }, [pendingManualStatus, inCall, pendingTypification, agentStatus, statusLoading, micPermissionGranted, requestMicPermission, changeAgentStatus]);



  // Handle softphone connection status changes

  useEffect(() => {

    if (!user?.username) return;



    const isFullyConnected = connected && registered;



    if (isFullyConnected) {
      // Limpiar override visual de desconexión
      if (statusBeforeDisconnectRef.current) {
        statusBeforeDisconnectRef.current = null;
        setAgentStatusOverride(null);
        logger.log('[SOFTPHONE CONNECT] Reconectado — limpiando override NO_NETWORK');
      }
      if (!wasConnectedRef.current && (agentStatus === 'OFFLINE' || agentStatus === 'NOTREADY')) {
        logger.log('[SOFTPHONE CONNECT] Primer registro detectado, solicitando mic y cambiando a AVAILABLE');
        // Asegurar permiso de mic antes de cambiar a AVAILABLE
        // Reintentar hasta 3 veces con delay si el mic no está listo aún
        const trySetAvailable = async (attempt = 1) => {
          try {
            const micOk = await requestMicPermission();
            if (micOk) {
              logger.log(`[SOFTPHONE CONNECT] Mic OK (intento ${attempt}), cambiando a AVAILABLE`);
              handleStatusChange('AVAILABLE');
            } else if (attempt < 3) {
              logger.log(`[SOFTPHONE CONNECT] Mic no listo (intento ${attempt}), reintentando en 2s...`);
              setTimeout(() => trySetAvailable(attempt + 1), 2000);
            } else {
              logger.log('[SOFTPHONE CONNECT] Mic no disponible después de 3 intentos, quedando en NOTREADY');
            }
          } catch (e) {
            if (attempt < 3) {
              setTimeout(() => trySetAvailable(attempt + 1), 2000);
            }
          }
        };
        trySetAvailable();
      }
      wasConnectedRef.current = true;
      return;
    }

    // Al desconectar: mostrar NO_NETWORK visualmente (sin llamar al backend)
    if (wasConnectedRef.current && !isFullyConnected) {
      wasConnectedRef.current = false;
      if (agentStatus && agentStatus !== 'NO_NETWORK' && agentStatus !== 'OFFLINE') {
        statusBeforeDisconnectRef.current = agentStatus;
        logger.log(`[SOFTPHONE DISCONNECT] Guardando estado ${agentStatus}, mostrando NO_NETWORK`);
        setAgentStatusOverride('NO_NETWORK');
      }
    }

  }, [connected, registered, agentStatus, user?.username, handleStatusChange]);



  useEffect(() => {

    wasConnectedRef.current = false;

  }, [currentAgent?.agent]);



  const parseAgentExtraConfig = (raw) => {
    if (!raw) return {};
    if (typeof raw === 'object') return raw;
    try {
      return JSON.parse(raw);
    } catch (err) {
      logger.warn('[PROFILE] No se pudo parsear extra_config:', err);
      return {};
    }
  };

  // Dialer functions
  const handleDialerOpen = () => {
    if (!agentSkills.length && !skillsLoading) {
      loadAgentSkills();
    }
    setDialerOpen(true);
  };

  const onDialDigit = (digit) => {

    setDialNumber(prev => prev + digit);

  };



  const handleBackspace = () => {

    setDialNumber(prev => prev.slice(0, -1));

  };



  const handleClearDial = () => {

    setDialNumber('');

  };

  const handleDialInputChange = (event) => {

    const rawValue = event.target.value || '';

    const sanitizedValue = rawValue.replace(/[^0-9*#]/g, '');

    setDialNumber(sanitizedValue);

  };

  /**
   * Valida un número de teléfono contra las reglas de números permitidos del skill
   * @param {string} phoneNumber - Número a validar
   * @param {object} allowedNumbersConfig - Configuración { default_action, rules: [{ condition, value, action }] }
   * @returns {object} { allowed: boolean, reason: string }
   */
  const validateAllowedNumber = (phoneNumber, allowedNumbersConfig) => {
    logger.log('[DIALER VALIDATION] ========== INICIO VALIDACIÓN ==========');
    logger.log('[DIALER VALIDATION] Número a validar:', phoneNumber);
    logger.log('[DIALER VALIDATION] Config recibida:', JSON.stringify(allowedNumbersConfig, null, 2));

    // Si no hay configuración, permitir por defecto (para compatibilidad)
    if (!allowedNumbersConfig) {
      logger.log('[DIALER VALIDATION]  No hay configuración - PERMITIENDO por defecto');
      return { allowed: true, reason: 'Sin configuración de números permitidos' };
    }

    const { default_action = 'Accept', rules = [] } = allowedNumbersConfig;

    // Si no hay reglas, aplicar directamente la acción por defecto
    if (!rules || rules.length === 0) {
      logger.log('[DIALER VALIDATION]  No hay reglas configuradas');
      logger.log(`[DIALER VALIDATION] Aplicando default_action directamente: "${default_action}"`);

      if (default_action === 'Deny') {
        logger.log('[DIALER VALIDATION]  NÚMERO RECHAZADO por default_action (sin reglas)');
        return {
          allowed: false,
          reason: 'Número rechazado por acción por defecto (sin reglas configuradas)'
        };
      } else {
        logger.log('[DIALER VALIDATION]  NÚMERO PERMITIDO por default_action (sin reglas)');
        return {
          allowed: true,
          reason: 'Número permitido por acción por defecto (sin reglas configuradas)'
        };
      }
    }
    const phoneLength = phoneNumber.length;

    logger.log('[DIALER VALIDATION] Longitud del número:', phoneLength);
    logger.log('[DIALER VALIDATION] Total de reglas a evaluar:', rules.length);
    logger.log('[DIALER VALIDATION] Acción por defecto:', default_action);

    // Evaluar cada regla en orden
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      const { condition, value, action } = rule;
      let ruleMatches = false;

      logger.log(`[DIALER VALIDATION] --- Evaluando Regla ${i + 1}/${rules.length} ---`);
      logger.log(`[DIALER VALIDATION] Condición: "${condition}", Valor: "${value}", Acción: "${action}"`);

      switch (condition) {
        case 'Longitud <':
          ruleMatches = phoneLength < parseInt(value, 10);
          logger.log(`[DIALER VALIDATION] ${phoneLength} < ${value} = ${ruleMatches}`);
          break;
        case 'Longitud >':
          ruleMatches = phoneLength > parseInt(value, 10);
          logger.log(`[DIALER VALIDATION] ${phoneLength} > ${value} = ${ruleMatches}`);
          break;
        case 'Comienza con':
          ruleMatches = phoneNumber.startsWith(value);
          logger.log(`[DIALER VALIDATION] "${phoneNumber}".startsWith("${value}") = ${ruleMatches}`);
          break;
        case 'Termina con':
          ruleMatches = phoneNumber.endsWith(value);
          logger.log(`[DIALER VALIDATION] "${phoneNumber}".endsWith("${value}") = ${ruleMatches}`);
          break;
        case 'Contiene':
          ruleMatches = phoneNumber.includes(value);
          logger.log(`[DIALER VALIDATION] "${phoneNumber}".includes("${value}") = ${ruleMatches}`);
          break;
        default:
          logger.warn(`[DIALER VALIDATION] ❌ Condición DESCONOCIDA: "${condition}"`);
      }

      if (ruleMatches) {
        logger.log(`[DIALER VALIDATION]  REGLA COINCIDE - Aplicando acción: "${action}"`);
        if (action === 'Deny') {
          logger.log(`[DIALER VALIDATION]  NÚMERO RECHAZADO por regla ${i + 1}`);
          logger.log('[DIALER VALIDATION] ========== FIN VALIDACIÓN (DENY) ==========');
          return {
            allowed: false,
            reason: `Número rechazado por regla: ${condition} ${value}`
          };
        } else if (action === 'Accept') {
          logger.log(`[DIALER VALIDATION]  NÚMERO ACEPTADO por regla ${i + 1}`);
          logger.log('[DIALER VALIDATION] ========== FIN VALIDACIÓN (ACCEPT) ==========');
          return {
            allowed: true,
            reason: `Número aceptado por regla: ${condition} ${value}`
          };
        } else {
          logger.warn(`[DIALER VALIDATION] ⚠️ Acción DESCONOCIDA: "${action}" - ignorando regla`);
        }
      } else {
        logger.log(`[DIALER VALIDATION]  Regla NO coincide - continuando...`);
      }
    }

    // Si ninguna regla coincidió, aplicar acción por defecto
    logger.log('[DIALER VALIDATION]  NINGUNA REGLA COINCIDIÓ');
    logger.log(`[DIALER VALIDATION] Aplicando acción por defecto: "${default_action}"`);
    if (default_action === 'Deny') {
      logger.log('[DIALER VALIDATION]  NÚMERO RECHAZADO por default action');
      logger.log('[DIALER VALIDATION] ========== FIN VALIDACIÓN (DEFAULT DENY) ==========');
      return {
        allowed: false,
        reason: 'Número rechazado por acción por defecto'
      };
    }

    logger.log('[DIALER VALIDATION]  NÚMERO PERMITIDO por default action');
    logger.log('[DIALER VALIDATION] ========== FIN VALIDACIÓN (DEFAULT ACCEPT) ==========');
    return { allowed: true, reason: 'Número permitido por acción por defecto' };
  };


  const handleMakeCall = async () => {
    // 🚨🚨🚨 LOG ULTRA PROMINENTE PARA DEBUG 🚨🚨🚨
    console.error('🔥🔥🔥 HANDLECALL EJECUTADO - VERSIÓN ACTUALIZADA 🔥🔥🔥');
    logger.log('======================================================');
    logger.log('[DIALER handleMakeCall] ========== FUNCIÓN EJECUTADA ==========');
    logger.log('[DIALER handleMakeCall] dialNumber:', dialNumber);
    logger.log('[DIALER handleMakeCall] Estado inCall:', inCall);
    logger.log('[DIALER handleMakeCall] agentStatus:', agentStatus);
    logger.log('[DIALER handleMakeCall] selectedDialerSkill:', selectedDialerSkill);
    logger.log('======================================================');

    // VALIDACIÓN: Máximo 2 llamadas simultáneas
    const activeCallCount = Object.keys(contextCalls || {}).length;
    if (activeCallCount >= 10) {
      logger.log('[DIALER handleMakeCall] BLOQUEANDO - máximo 10 llamadas simultáneas');
      showError('Máximo 10 llamadas simultáneas. Finaliza una llamada antes de realizar otra.');
      return;
    }
    // Si hay una llamada activa y NO es conferencia directa, ponerla en hold antes de la nueva
    if (inCall && currentCallId && contextHoldCall && !addToConference) {
      logger.log('[DIALER handleMakeCall] Poniendo llamada actual en hold:', currentCallId);
      contextHoldCall(currentCallId);
    }
    if (addToConference && currentCallId) {
      logger.log('[DIALER handleMakeCall] Modo conferencia directa - no hold, mergeInto:', currentCallId);
    }

    const sanitizedNumber = (dialNumber || '').replace(/[^0-9*#]/g, '').trim();

    if (!sanitizedNumber) {
      showError('Ingresa un nÇ§mero vÇ­lido para marcar.');
      return;
    }

    // Si está en PRECALL, usar el skill de la interacción actual
    const skillToUse = agentStatus === 'PRECALL'
      ? (interactionCache?.skill || lastSkillConfig?.skilldef)
      : selectedDialerSkill;

    if (!skillToUse) {
      showError('Selecciona un skill para la llamada manual.');
      return;
    }

    // En modo transición no bloqueamos el dialer por conexión del softphone

    // 🔍 VALIDACIÓN: Obtener configuración del skill y validar número según reglas
    logger.log('[DIALER]  Iniciando validación de número permitido...');
    logger.log('[DIALER] Skill a validar:', skillToUse);
    logger.log('[DIALER] Número a validar:', sanitizedNumber);

    const token = typeof window !== 'undefined' ? (localStorage.getItem('cti_admin_token') || '') : '';
    let skillConfig = null;
    try {
      logger.log('[DIALER] Obteniendo configuración del skill...');
      const configResponse = await fetch(`/api/admin/softphone/skill-config/${encodeURIComponent(skillToUse)}`, {
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      });

      logger.log('[DIALER] Response status:', configResponse.status);

      if (configResponse.ok) {
        const configResult = await configResponse.json();
        skillConfig = configResult?.data ?? configResult;
        logger.log('[DIALER]  Configuración del skill obtenida');
        logger.log('[DIALER] skillConfig.allowed_numbers_config:', skillConfig?.allowed_numbers_config);

        // Validar número contra reglas de números permitidos
        if (skillConfig && skillConfig.allowed_numbers_config) {
          logger.log('[DIALER]  Iniciando validación con reglas de números permitidos');

          const allowedConfig = typeof skillConfig.allowed_numbers_config === 'string'
            ? JSON.parse(skillConfig.allowed_numbers_config)
            : skillConfig.allowed_numbers_config;

          logger.log('[DIALER] Config parseada:', allowedConfig);

          const validation = validateAllowedNumber(sanitizedNumber, allowedConfig);
          logger.log('[DIALER] ========================================');
          logger.log('[DIALER] RESULTADO FINAL DE VALIDACIÓN:', validation);
          logger.log('[DIALER] ========================================');

          if (!validation.allowed) {
            logger.log('[DIALER]  BLOQUEANDO LLAMADA - Número no permitido');
            showError(validation.reason || 'Número no permitido por las reglas del skill.');
            return;
          } else {
            logger.log('[DIALER]  VALIDACIÓN EXITOSA - Número permitido');
          }
        } else {
          logger.log('[DIALER]  No hay allowed_numbers_config - permitiendo por defecto');
        }
      } else {
        logger.warn('[DIALER] ⚠️ Error al obtener skill config - status:', configResponse.status);
      }
    } catch (configError) {
      console.error('[DIALER] ❌ Error al obtener configuración del skill:', configError);
      console.error('[DIALER] Stack:', configError.stack);
      // Continuar sin validación si falla la obtención del config
      logger.warn('[DIALER] ⚠️ Continuando sin validación debido al error');
    }

    // Conference mode: agent is already INCALL, skip PRECALL transition and manualReturnRef
    if (!addToConference) {
      // Guardar el estado actual para restaurarlo al terminar la llamada manual
      const manualOriginStatus = ['INCALL', 'ACW', 'PRECALL'].includes(agentStatus) ? null : agentStatus;
      logger.log('[MANUAL CALL][STORE] Capturando estado previo antes de marcar', {
        agentStatus,
        manualOriginStatus,
        pendingManualStatus
      });
      manualReturnRef.current = {
        originStatus: manualOriginStatus,
        callStartTime: null,
        actionId: null
      };

      // Si NO está en PRECALL, cambiar a PRECALL antes de hacer la llamada
      if (agentStatus !== 'PRECALL') {
        logger.log('[DIALER] Cambiando a PRECALL antes de llamar');
        const success = await changeAgentStatus('PRECALL', 'Iniciando llamada manual', { silent: false });

        if (!success) {
          showError('No se pudo cambiar el estado a PRECALL.');
          return;
        }

        setAgentStatusOverride(null);
        setAgentStatusStartTime(Date.now());
      }
    }

    // token ya fue declarado arriba en la línea 3134
    const timePreviousReady = agentStatus === 'PRECALL' && agentStatusStartTime
      ? Math.floor((Date.now() - agentStatusStartTime) / 1000)
      : 0;

    const payload = {
      phone: sanitizedNumber,
      skillDef: skillToUse,
      agent: currentAgent?.agent || currentAgent?.username || user?.username || '',
      timePreviousReady,
      ...(interactionCache?.dataId ? { dataId: interactionCache.dataId } : {}),
      ...(addToConference && currentCallId ? { mergeIntoCallId: currentCallId } : {})
    };

    // 🚨 ESTABLECER ESTADO EN LLAMADA INMEDIATAMENTE para prevenir llamadas duplicadas
    if (!addToConference) {
      logger.log('[DIALER]  Estableciendo inCall=true ANTES del fetch');
      setInCall(true);
    }
    setDialerCalling(true);
    try {
      const response = await fetch('/api/admin/dialer/manual', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (!response.ok || !result?.success) {
        throw new Error(result?.message || 'No se pudo iniciar la llamada');
      }

      const actionId = result.actionId || result.data?.actionId || result.data?.actionid || null;

      if (addToConference) {
        // Conference mode: do NOT set callData (would trigger manual call useEffect + ringing)
        // The existing call stays active, backend merges SIP into existing bridge
        logger.log('[DIALER handleMakeCall] Conference add initiated, actionId:', actionId, 'mergeInto:', currentCallId);
        showSuccess(`Agregando a conferencia por ${skillToUse}-PREVIEW`);
      } else {
        const callStartTime = Date.now();
        logger.log('[MANUAL CALL][STORE] Persistiendo actionId y callStartTime para retorno', {
          actionId,
          callStartTime
        });
        manualReturnRef.current = {
          ...manualReturnRef.current,
          callStartTime,
          actionId: actionId || null
        };
        const baseCallData = {
          source: 'manual',
          dialingMode: 'Manual',
          dialingModeNormalized: 'manual',
          actionId,
          phone: sanitizedNumber,
          skill: skillToUse,
          startTime: callStartTime
        };

        // Para llamadas manuales, NO mantener skillData de interacciones previas
        setCallData(baseCallData);
        setTypificationData({
          skillName: skillToUse,
          dataId: null,
          actionId,
          phone: sanitizedNumber,
          timestamp: new Date().toISOString(),
          source: 'manual'
        });

        // Usar el skillConfig que ya obtuvimos antes (para validación)
        if (skillConfig) {
          // Para llamadas manuales, NO agregar skillData con datos de cliente
          // Solo actualizar lastSkillConfig para la tipificación
          setLastSkillConfig({
            ...skillConfig,
            call_data_id: null,
            call_skill: skillToUse,
            call_action_id: actionId
          });
        }

        showSuccess(`Llamada iniciada por ${skillToUse}-PREVIEW`);
      }
      setDialerOpen(false);
      setDialNumber('');
      setAddToConference(false);
    } catch (error) {
      console.error('[DIALER] Error initiating manual call:', error);
      showError(error.message || 'Error al iniciar la llamada');
      // 🚨 REVERTIR estado inCall si falla la llamada
      logger.log('[DIALER]  Error en llamada - revirtiendo inCall a false');
      setInCall(false);
      resetManualReturnRef();
    } finally {
      setDialerCalling(false);
    }
  };



  const handleDialerClose = () => {

    setDialerOpen(false);

    setDialNumber('');
    setDialerCalling(false);
    setAddToConference(false);

  };

  const canMakeDialerCall = Boolean((dialNumber || '').trim())
    && (agentStatus === 'PRECALL' ? Boolean(interactionCache?.skill || lastSkillConfig?.skilldef) : Boolean(selectedDialerSkill))
    && !dialerCalling
    && !skillsLoading;



  // Typification panel handlers

  const handleTypificationSubmit = async (selectedTypification, trackingData = null) => {

    try {

      if (inCall) {
        showError('No puedes tipificar mientras la llamada está activa. Finaliza primero.');
        return;
      }

      logger.log('Typification submitted:', selectedTypification);
      logger.log('Tracking data:', trackingData);

      logger.log('Call info:', lastCallInfo);

      logger.log('Last skill config:', lastSkillConfig);

      // Get agent ID for tracking
      const agentId = currentAgent?.agent || user?.agent || user?.username || user?.id;

      // Get the skill, data and action information

      let skillName, dataId, actionId;

      // 🚨 PRIORITY 0: From PERSISTENT typificationData (NEVER auto-cleared)
      const typificationData = softphoneContext.typificationData;
      logger.log('[TYPIFICATION]  Checking typificationData availability:', typificationData);
      if (typificationData && typeof typificationData === 'object') {
        skillName = typificationData.skillName;
        dataId = typificationData.dataId;
        actionId = typificationData.actionId;
        logger.log('[TYPIFICATION]  Using PERSISTENT data:', { skillName, dataId, actionId });
      } else {
        logger.log('[TYPIFICATION]  No typificationData available, using fallback methods');
      }

      // Priority 1: From lastSkillConfig (when call ended) - only if persistent data not available

      if (!skillName && !dataId && !actionId && lastSkillConfig) {

        skillName = lastSkillConfig.call_skill || lastSkillConfig.skilldef;

        dataId = lastSkillConfig.call_data_id;

        actionId = lastSkillConfig.call_action_id;

        logger.log('[TYPIFICATION] Using lastSkillConfig as fallback:', { skillName, dataId, actionId });

      }

      // Fallback: try to extract from any other fields in lastSkillConfig
      if (lastSkillConfig && (!skillName || !dataId || !actionId)) {
        logger.log('[TYPIFICATION] Trying fallback extraction from lastSkillConfig');

        // Look for skill name in other possible fields
        if (!skillName) {
          skillName = lastSkillConfig.skill || lastSkillConfig.skillName;
        }

        // Look for dataId in other possible fields
        if (!dataId) {
          dataId = lastSkillConfig.dataId || lastSkillConfig.data_id || lastSkillConfig.id;
        }

        // Look for actionId in other possible fields
        if (!actionId) {
          actionId = lastSkillConfig.actionId || lastSkillConfig.action_id;
        }
      }



      // Priority 2: From current callData (during active call)

      if (!skillName && callData && callData.skill) {

        skillName = callData.skill;

      }

      if (!dataId && callData) {
        dataId = callData.data_id || callData.dataId;
      }

      if (!actionId && callData && callData.actionId) {

        actionId = callData.actionId;

      }



      logger.log('[TYPIFICATION] Debug data gathering:', {
        lastSkillConfig,
        callData,
        extractedData: { skillName, dataId, actionId }
      });

      const hasActionId = !!actionId;
      if (!skillName || (!dataId && !hasActionId)) {

        logger.warn('[TYPIFICATION] Missing required data, skipping save and closing panel:', {
          skillName,
          dataId,
          actionId,
          lastSkillConfig,
          callData
        });

        clearAutoTypificationTimer();
        setTypificationPanelOpen(false);
        setPendingTypification(false);
        setClientDataPanelOpen(false);
        setClientDataSnapshot(null);
        setClientDataManuallyClosed(true);
        setInteractionCache(null);
        clearInteractionCache();
        setLastCallInfo(null);
        clearLastSkillConfig();
        clearCallData();
        resetPreviewState();
        setCallStartTime(null);
        setCallDuration('00:00');
        handleReturnToAvailable();
        return;

      }



      // Calcular tiempo en ACW si aplica

      let timeAcw = 0;

      if (agentStatus === 'ACW' && agentStatusStartTime) {

        timeAcw = Math.floor((Date.now() - agentStatusStartTime) / 1000);

        logger.log(`[TYPIFICATION]  Tiempo en ACW calculado: ${timeAcw} segundos`);

      }



      // Detener auto-tipificación al enviar manualmente
      clearAutoTypificationTimer();

      // Prepare typification data

      // Calcular timecall desde frontend como backup (solo se usa si el backend no tiene datos en memoria)
      let timecallFrontend = 0;
      if (lastCallInfo?.startTime && lastCallInfo?.endTime) {
        timecallFrontend = Math.max(0, Math.floor((lastCallInfo.endTime - lastCallInfo.startTime) / 1000));
      }

      const typificationPayload = {

        skillName: skillName,

        dataId: dataId || null,

        typificationId: selectedTypification.id,

        typificationName: selectedTypification.name,

        typificationPath: selectedTypification.path,

        actionId: actionId || null, // Include actionId for cti_log_calls update

        timeAcw: timeAcw, // Include ACW time

        timecallFrontend // Backup: tiempo de conversación calculado en frontend

      };



      logger.log('Saving typification with data:', typificationPayload);



      const queued = enqueueTypification(typificationPayload);
      if (!queued) {
        throw new Error('No se pudo encolar la tipificación');
      }
      processTypificationQueue();
      logger.log('Typification queued successfully:', typificationPayload);



      // Crear tracking si fue marcado
      logger.log('[TRACKING] Verificando condiciones para crear seguimiento:', {
        trackingData,
        lastCallInfo,
        callId: lastCallInfo?.callId
      });

      if (trackingData && lastCallInfo && lastCallInfo.callId) {
        try {
          logger.log('[TRACKING] Creando seguimiento para llamada:', lastCallInfo.callId);
          logger.log('[TRACKING] lastCallInfo completo:', lastCallInfo);
          logger.log('[TRACKING] callData completo:', callData);
          logger.log('[TRACKING] clientDataSnapshot completo:', clientDataSnapshot);

          const trackingPayload = {
            call_id: lastCallInfo.callId,
            agent_id: agentId,
            phone_number: lastCallInfo.phoneNumber || callData?.phone || callData?.phoneNumber || clientDataSnapshot?.phone,
            client_data: callData?.skillData || clientDataSnapshot?.skillData || {},
            original_skill: skillName,
            tags: trackingData.tags || [],
            initial_note: trackingData.note,
            schedule: trackingData.schedule || null
          };

          logger.log('[TRACKING] Payload para createTracking:', trackingPayload);

          // Enviar tracking sin bloquear el flujo
          agentTracking.createTracking(trackingPayload)
            .then((trackingResponse) => {
              logger.log('[TRACKING] Seguimiento creado (async):', trackingResponse);
            })
            .catch((trackingError) => {
              console.error('[TRACKING] Error creando seguimiento (async):', trackingError);
              console.error('[TRACKING] Error completo:', trackingError.stack);
            });
        } catch (trackingError) {
          console.error('[TRACKING] Error creando seguimiento:', trackingError);
          console.error('[TRACKING] Error completo:', trackingError.stack);
          // No bloqueamos la tipificación si falla el tracking
        }
      } else {
        logger.log('[TRACKING] No se cumplieron las condiciones para crear seguimiento:', {
          hasTrackingData: !!trackingData,
          hasLastCallInfo: !!lastCallInfo,
          hasCallId: !!lastCallInfo?.callId
        });
      }

      // Close typification panel after successful submission

      setTypificationPanelOpen(false);

      setPendingTypification(false); // Clear pending typification

      // Hide client data after tipifying and END interaction
      setClientDataPanelOpen(false);
      setClientDataSnapshot(null);
      setClientDataManuallyClosed(true);
      setInteractionCache(null);
      clearInteractionCache();

      setLastCallInfo(null);

      clearLastSkillConfig(); // Clear the last skill config



      // IMPORTANTE: Al tipificar y finalizar, limpiar completamente la sesión preview

      clearCallData(); // Limpiar todos los datos de la llamada

      resetPreviewState(); // Limpiar la sesión preview del agente

      // IMPORTANTE: Limpiar callStartTime ANTES de cambiar a AVAILABLE
      // para evitar que el useEffect de auto-status (línea ~1852) re-dispare ACW
      setCallStartTime(null);
      setCallDuration('00:00');

      logger.log('[PREVIEW] Session completely cleared - interaction finalized');



      // Return to AVAILABLE after finalizing interaction

      handleReturnToAvailable();

    } catch (error) {

      console.error('Error submitting typification:', error);

      // You could show an error message to the user here

      alert(`Error al guardar la tipificación: ${error.message}`);

    }

  };



  // Handle typification and continue (for preview mode)

  const handleTypificationSubmitAndContinue = async (selectedTypification, trackingData = null) => {

    try {

      if (inCall) {
        showError('No puedes tipificar mientras la llamada está activa. Finaliza primero.');
        return;
      }

      logger.log('Typification submitted (continue):', selectedTypification);
      logger.log('Tracking data:', trackingData);

      logger.log('Call info:', lastCallInfo);

      logger.log('Last skill config:', lastSkillConfig);

      // Get agent ID for tracking
      const agentId = currentAgent?.agent || user?.agent || user?.username || user?.id;

      // Get the skill, data and action information

      let skillName, dataId, actionId;

      // 🚨 PRIORITY 0: From PERSISTENT typificationData (NEVER auto-cleared)
      const typificationData = softphoneContext.typificationData;
      logger.log('[TYPIFICATION]  Checking typificationData availability:', typificationData);
      if (typificationData && typeof typificationData === 'object') {
        skillName = typificationData.skillName;
        dataId = typificationData.dataId;
        actionId = typificationData.actionId;
        logger.log('[TYPIFICATION]  Using PERSISTENT data:', { skillName, dataId, actionId });
      } else {
        logger.log('[TYPIFICATION]  No typificationData available, using fallback methods');
      }

      // Priority 1: From lastSkillConfig (when call ended) - only if persistent data not available

      if (!skillName && !dataId && !actionId && lastSkillConfig) {

        skillName = lastSkillConfig.call_skill || lastSkillConfig.skilldef;

        dataId = lastSkillConfig.call_data_id;

        actionId = lastSkillConfig.call_action_id;

        logger.log('[TYPIFICATION] Using lastSkillConfig as fallback:', { skillName, dataId, actionId });

      }

      // Fallback: try to extract from any other fields in lastSkillConfig
      if (lastSkillConfig && (!skillName || !dataId || !actionId)) {
        logger.log('[TYPIFICATION] Trying fallback extraction from lastSkillConfig');

        // Look for skill name in other possible fields
        if (!skillName) {
          skillName = lastSkillConfig.skill || lastSkillConfig.skillName;
        }

        // Look for dataId in other possible fields
        if (!dataId) {
          dataId = lastSkillConfig.dataId || lastSkillConfig.data_id || lastSkillConfig.id;
        }

        // Look for actionId in other possible fields
        if (!actionId) {
          actionId = lastSkillConfig.actionId || lastSkillConfig.action_id;
        }
      }



      // Priority 2: From current callData (during active call)

      if (!skillName && callData && callData.skill) {

        skillName = callData.skill;

      }

      if (!dataId && callData) {
        dataId = callData.data_id || callData.dataId;
      }

      if (!actionId && callData && callData.actionId) {

        actionId = callData.actionId;

      }



      logger.log('[TYPIFICATION] Debug data gathering:', {
        lastSkillConfig,
        callData,
        extractedData: { skillName, dataId, actionId }
      });

      const hasActionId = !!actionId;
      if (!skillName || (!dataId && !hasActionId)) {

        logger.warn('[TYPIFICATION] Missing required data, skipping save and continuing:', {
          skillName,
          dataId,
          actionId,
          lastSkillConfig,
          callData
        });

        clearAutoTypificationTimer();
        setTypificationPanelOpen(false);
        setPendingTypification(false);
        setClientDataPanelOpen(true);
        setClientDataManuallyClosed(false);
        setLastCallInfo(null);

        if (agentStatus === 'ACW') {
          logger.log('[AUTO STATUS] Typify and continue (missing data), changing to PRECALL for next call');
          changeAgentStatusAutomatic('PRECALL', 'typification-continue-missing-data', { expectedStatuses: ['ACW'] });
        }
        return;

      }



      // Calcular tiempo en ACW si aplica

      let timeAcw = 0;

      if (agentStatus === 'ACW' && agentStatusStartTime) {

        timeAcw = Math.floor((Date.now() - agentStatusStartTime) / 1000);

        logger.log(`[TYPIFICATION]  Tiempo en ACW calculado: ${timeAcw} segundos`);

      }



      // Detener auto-tipificación al enviar manualmente
      clearAutoTypificationTimer();

      // Calcular timecall desde frontend como backup
      let timecallFrontend = 0;
      if (lastCallInfo?.startTime && lastCallInfo?.endTime) {
        timecallFrontend = Math.max(0, Math.floor((lastCallInfo.endTime - lastCallInfo.startTime) / 1000));
      }

      // Prepare typification data

      const typificationPayload = {

        skillName: skillName,

        dataId: dataId || null,

        typificationId: selectedTypification.id,

        typificationName: selectedTypification.name,

        typificationPath: selectedTypification.path,

        actionId: actionId || null, // Include actionId for cti_log_calls update

        timeAcw: timeAcw, // Include ACW time

        timecallFrontend // Backup: tiempo de conversación calculado en frontend

      };



      logger.log('Saving typification with data:', typificationPayload);



      const queued = enqueueTypification(typificationPayload);
      if (!queued) {
        throw new Error('No se pudo encolar la tipificación');
      }
      processTypificationQueue();
      logger.log('Typification queued successfully (continuar):', typificationPayload);



      // Crear tracking si fue marcado
      logger.log('[TRACKING] Verificando condiciones para crear seguimiento (continuar):', {
        trackingData,
        lastCallInfo,
        callId: lastCallInfo?.callId
      });

      if (trackingData && lastCallInfo && lastCallInfo.callId) {
        try {
          logger.log('[TRACKING] Creando seguimiento para llamada (continuar):', lastCallInfo.callId);
          logger.log('[TRACKING] lastCallInfo completo (continuar):', lastCallInfo);
          logger.log('[TRACKING] callData completo (continuar):', callData);
          logger.log('[TRACKING] clientDataSnapshot completo (continuar):', clientDataSnapshot);

          const trackingPayload = {
            call_id: lastCallInfo.callId,
            agent_id: agentId,
            phone_number: lastCallInfo.phoneNumber || callData?.phone || callData?.phoneNumber || clientDataSnapshot?.phone,
            client_data: callData?.skillData || clientDataSnapshot?.skillData || {},
            original_skill: skillName,
            tags: trackingData.tags || [],
            initial_note: trackingData.note,
            schedule: trackingData.schedule || null
          };

          logger.log('[TRACKING] Payload para createTracking (continuar):', trackingPayload);

          agentTracking.createTracking(trackingPayload)
            .then((trackingResponse) => {
              logger.log('[TRACKING] Seguimiento creado (async, continuar):', trackingResponse);
            })
            .catch((trackingError) => {
              console.error('[TRACKING] Error creando seguimiento (async):', trackingError);
              console.error('[TRACKING] Error completo:', trackingError.stack);
            });
        } catch (trackingError) {
          console.error('[TRACKING] Error creando seguimiento:', trackingError);
          console.error('[TRACKING] Error completo:', trackingError.stack);
          // No bloqueamos la tipificación si falla el tracking
        }
      } else {
        logger.log('[TRACKING] No se cumplieron las condiciones para crear seguimiento (continuar):', {
          hasTrackingData: !!trackingData,
          hasLastCallInfo: !!lastCallInfo,
          hasCallId: !!lastCallInfo?.callId
        });
      }

      // Close typification panel but keep client data panel open

      setTypificationPanelOpen(false);

      setPendingTypification(false); // Clear pending typification

      // En modo continuar, mantener los datos visibles para relanzar
      setClientDataPanelOpen(true);
      setClientDataManuallyClosed(false);
      // Mantener interacción viva (no limpiar caches ni lastSkillConfig)

      setLastCallInfo(null);

      // Change to PRECALL state when continuing in preview mode

      if (agentStatus === 'ACW') {

        logger.log('[AUTO STATUS] Typify and continue, changing to PRECALL for next call');

        changeAgentStatusAutomatic('PRECALL', 'typification-continue', { expectedStatuses: ['ACW'] });

      }

    } catch (error) {

      console.error('Error submitting typification:', error);

      alert(`Error al guardar la tipificación: ${error.message}`);

    }

  };



  const handleTypificationClose = () => {

    if (!inCall && pendingTypification) {
      logger.log('[TYPIFICATION][UI] Close blocked: pending typification without active call');
      return;
    }

    setTypificationPanelOpen(false);
    setIsInGracePeriod(false); // Resetear período de gracia al cerrar panel

    // Opcional: También cerrar panel de datos si se cierra tipificación sin guardar

    // setClientDataPanelOpen(false);

    setLastCallInfo(null);

    clearLastSkillConfig();

  };



  // Client data panel handlers

  const handleClientDataPanelToggle = () => {
    if (clientDataPanelOpen) {
      setClientDataManuallyClosed(true);
      setClientDataPanelOpen(false);
    } else {
      setClientDataManuallyClosed(false);
      setClientDataPanelOpen(true);
    }
  };



  const handleClientDataPanelClose = () => {

    logger.log('[CLIENT_DATA_PANEL] handleClientDataPanelClose called - closing panel manually');

    setClientDataPanelOpen(false);
    setClientDataManuallyClosed(true);

  };



  const handleTypificationPanelToggle = () => {

    if (!typificationPanelOpen && inCall) {
      showError('No puedes tipificar mientras la llamada está activa. Finaliza primero.');
      return;
    }

    // No permitir cerrarla si no hay llamada activa y la tipificación está pendiente
    if (typificationPanelOpen && !inCall && pendingTypification) {
      logger.log('[TYPIFICATION][UI] Toggle blocked: pending typification without active call');
      return;
    }

    setTypificationPanelOpen(!typificationPanelOpen);
    logger.log('[TYPIFICATION][UI] Toggle panel', {
      nextOpen: !typificationPanelOpen,
      lastSkillConfig,
      callData,
      typificationData,
      typificationGroupId,
      inCall,
      pendingTypification
    });

  };




  const renderMenuItem = (item, nested = false) => {

    const isSelected = location.pathname === item.path;

    if (!drawerOpen && nested) return null; // No mostrar items nested cuando está cerrado

    return (

      <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }}>

        <Tooltip title={!drawerOpen ? item.text : ''} placement="right">

          <ListItemButton

            selected={isSelected}

            onClick={() => navigate(item.path)}

            sx={{

              borderRadius: '12px',

              px: drawerOpen ? 2 : 0,

              py: 1.25,

              ml: nested ? 3 : 0,

              justifyContent: drawerOpen ? 'initial' : 'center',

              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',

              position: 'relative',

              '&.Mui-selected': {

                backgroundColor: 'rgba(255, 255, 255, 0.9)',

                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06), 0 0 20px rgba(102, 126, 234, 0.15)',

                backdropFilter: 'blur(10px)',

                '&:hover': {

                  backgroundColor: 'rgba(255, 255, 255, 0.95)',

                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06), 0 0 25px rgba(102, 126, 234, 0.2)',

                },

                '&::before': {

                  content: '""',

                  position: 'absolute',

                  left: 0,

                  top: '50%',

                  transform: 'translateY(-50%)',

                  width: '3px',

                  height: drawerOpen ? '60%' : '80%',

                  borderRadius: '0 4px 4px 0',

                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',

                  boxShadow: '0 0 10px rgba(102, 126, 234, 0.5)',

                },

                '& .MuiListItemIcon-root': {

                  color: '#667eea',

                  filter: 'drop-shadow(0 0 8px rgba(102, 126, 234, 0.4))',

                },

                '& .MuiListItemText-primary': {

                  color: '#1a1a1a',

                  fontWeight: 600,

                },

              },

              '&:hover': {

                backgroundColor: 'rgba(102, 126, 234, 0.06)',

              },

            }}

          >

            <ListItemIcon

              sx={{

                color: isSelected ? '#667eea' : '#6b7280',

                minWidth: drawerOpen ? 44 : 'auto',

                mr: drawerOpen ? undefined : 0,

                justifyContent: 'center',

                fontSize: '1.35rem',

              }}

            >

              {item.path === '/chat' ? (
                <ChatBadgeIcon>{item.icon}</ChatBadgeIcon>
              ) : item.icon}

            </ListItemIcon>

            {drawerOpen && (

              <ListItemText

                primary={item.text}

                primaryTypographyProps={{

                  fontSize: '0.9375rem',

                  fontWeight: isSelected ? 600 : 500,

                  color: isSelected ? '#1a1a1a' : '#4b5563',

                }}

              />

            )}

          </ListItemButton>

        </Tooltip>

      </ListItem>

    );

  };



  const dashboardItem = useMemo(

    () => menuItems.find(item => item.path === '/dashboard'),

    [menuItems]

  );

const supervisionPaths = useMemo(

  () => ['/supervision/agents', '/supervision/monitoring-center', '/supervision/skills', '/supervision/skills-monitor', '/supervision/queues', '/supervision/call-logs', '/engine-status', '/reports'],

  []

);

  const supervisionItems = useMemo(

    () => menuItems.filter(item => supervisionPaths.includes(item.path)),

    [menuItems, supervisionPaths]

  );

  const myCallsItem = useMemo(
    () => menuItems.find(item => item.path === '/agent-calls'),
    [menuItems]
  );

  const wallItem = useMemo(
    () => menuItems.find(item => item.path === '/wall'),
    [menuItems]
  );

  const chatItem = useMemo(
    () => menuItems.find(item => item.path === '/chat'),
    [menuItems]
  );

  const configItems = useMemo(
    () => menuItems.filter(item => ['/settings', '/roles'].includes(item.path)),
    [menuItems]
  );

  const adminItems = useMemo(

    () => menuItems.filter(item =>

      item.path !== '/dashboard' &&
      item.path !== '/agent-calls' &&
      item.path !== '/wall' &&
      item.path !== '/chat' &&
      item.path !== '/settings' &&
      item.path !== '/roles' &&
      !supervisionPaths.includes(item.path)

    ),

    [menuItems, supervisionPaths]

  );



  useEffect(() => {

    if (adminItems.some(item => item.path === location.pathname)) {

      setAdminMenuOpen(true);

    }

  }, [location.pathname, adminItems]);



  useEffect(() => {

    if (supervisionItems.some(item => item.path === location.pathname)) {

      setSupervisionMenuOpen(true);

    }

  }, [location.pathname, supervisionItems]);



  const drawer = (

    <Box sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 255, 0.98) 50%, rgba(255, 255, 255, 0.95) 100%)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderRight: '1px solid rgba(102, 126, 234, 0.15)',
      boxShadow: '0 8px 32px 0 rgba(102, 126, 234, 0.1)',
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(118, 75, 162, 0.03) 100%)',
        pointerEvents: 'none',
        zIndex: 0,
      }
    }}>

      {/* Logo y controles minimalistas */}

      <Box

        sx={{

          px: drawerOpen ? 2 : 1.25,

          py: drawerOpen ? 2 : 0.25,

          minHeight: drawerOpen ? undefined : 64,

          display: 'flex',

          alignItems: 'center',

          justifyContent: 'center',

          width: '100%',

          position: 'relative',

          transition: 'all 0.2s',

          zIndex: 1,

        }}

      >

        {drawerOpen ? (

          <AnimatedLogo fullWidth />

        ) : (

          <Tooltip title="Enigma" placement="right">

            <AnimatedLogo bare animate={false} staticLetter="E" heightOverride={96} />

          </Tooltip>

        )}

        {drawerOpen && (

          <Box

            sx={{

              position: 'absolute',

              top: 8,

              right: 10,

              display: 'flex',

              alignItems: 'center',

              gap: 0.5,

              pointerEvents: 'auto'

            }}

          >

            <Tooltip title={drawerPinned ? 'Desanclar menú' : 'Anclar menú'}>

              <IconButton

                onClick={() => setDrawerPinned(prev => !prev)}

                size="small"

                sx={{

                  color: 'text.secondary',

                  backgroundColor: 'rgba(255,255,255,0.65)',

                  boxShadow: '0 8px 16px rgba(0,0,0,0.08)',

                  '&:hover': {

                    backgroundColor: 'rgba(102, 126, 234, 0.12)',

                    color: '#667eea',

                  }

                }}

              >

                {drawerPinned ? <PushPin fontSize="small" /> : <PushPinOutlined fontSize="small" />}

              </IconButton>

            </Tooltip>

            {isMobile && (

              <IconButton

                onClick={handleDrawerToggle}

                size="small"

                sx={{

                  color: 'text.secondary',

                  backgroundColor: 'rgba(255,255,255,0.65)',

                  boxShadow: '0 8px 16px rgba(0,0,0,0.08)',

                  '&:hover': {

                    backgroundColor: 'rgba(102, 126, 234, 0.12)',

                    color: '#667eea',

                  }

                }}

              >

                <ChevronLeft fontSize="small" />

              </IconButton>

            )}

          </Box>

        )}

      </Box>


      <List sx={{ px: 2, py: 1, flex: 1, overflow: 'auto', position: 'relative', zIndex: 1 }}>

        {dashboardItem && renderMenuItem(dashboardItem)}

        {myCallsItem && renderMenuItem(myCallsItem)}

        {wallItem && renderMenuItem(wallItem)}

        {chatItem && renderMenuItem(chatItem)}

        {supervisionItems.length > 0 && (
          <>
            <ListItem disablePadding sx={{ mb: 0.5, mt: 2 }}>
              <Tooltip title={!drawerOpen ? 'Supervisión' : ''} placement="right">
                <ListItemButton
                  onClick={() => {
                    if (!drawerOpen) {
                      setDrawerOpen(true);
                      setSupervisionMenuOpen(true);
                    } else {
                      setSupervisionMenuOpen(prev => !prev);
                    }
                  }}
                  sx={{
                    borderRadius: '12px',
                    px: drawerOpen ? 2 : 0,
                    py: 1.25,
                    justifyContent: drawerOpen ? 'initial' : 'center',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      backgroundColor: 'rgba(102, 126, 234, 0.06)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: '#6b7280',
                      minWidth: drawerOpen ? 44 : 'auto',
                      mr: drawerOpen ? undefined : 0,
                      justifyContent: 'center',
                    }}
                  >
                    <SupervisorAccountIcon />
                  </ListItemIcon>
                  {drawerOpen && (
                    <>
                      <ListItemText
                        primary="Supervisión"
                        primaryTypographyProps={{
                          fontSize: '0.9375rem',
                          fontWeight: 600,
                          color: '#4b5563',
                        }}
                      />
                      {supervisionMenuOpen ? <ExpandLess sx={{ color: '#9ca3af' }} /> : <ExpandMore sx={{ color: '#9ca3af' }} />}
                    </>
                  )}
                </ListItemButton>
              </Tooltip>
            </ListItem>
            {drawerOpen && (
              <Collapse in={supervisionMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ pl: 1 }}>
                  {supervisionItems.map(item => renderMenuItem(item, true))}
                </List>
              </Collapse>
            )}
          </>
        )}

        {adminItems.length > 0 && (
          <>
            <ListItem disablePadding sx={{ mb: 0.5, mt: 2 }}>
              <Tooltip title={!drawerOpen ? 'Administración' : ''} placement="right">
                <ListItemButton
                  onClick={() => {
                    if (!drawerOpen) {
                      setDrawerOpen(true);
                      setAdminMenuOpen(true);
                    } else {
                      setAdminMenuOpen(prev => !prev);
                    }
                  }}
                  sx={{
                    borderRadius: '12px',
                    px: drawerOpen ? 2 : 0,
                    py: 1.25,
                    justifyContent: drawerOpen ? 'initial' : 'center',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      backgroundColor: 'rgba(102, 126, 234, 0.06)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: '#6b7280',
                      minWidth: drawerOpen ? 44 : 'auto',
                      mr: drawerOpen ? undefined : 0,
                      justifyContent: 'center',
                    }}
                  >
                    <AdminPanelSettingsIcon />
                  </ListItemIcon>
                  {drawerOpen && (
                    <>
                      <ListItemText
                        primary="Administración"
                        primaryTypographyProps={{
                          fontSize: '0.9375rem',
                          fontWeight: 600,
                          color: '#4b5563',
                        }}
                      />
                      {adminMenuOpen ? <ExpandLess sx={{ color: '#9ca3af' }} /> : <ExpandMore sx={{ color: '#9ca3af' }} />}
                    </>
                  )}
                </ListItemButton>
              </Tooltip>
            </ListItem>
            {drawerOpen && (
              <Collapse in={adminMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ pl: 1 }}>
                  {adminItems.map(item => renderMenuItem(item, true))}
                </List>
              </Collapse>
            )}
          </>
        )}

        {configItems.length > 0 && (
          <>
            <ListItem disablePadding sx={{ mb: 0.5, mt: 2 }}>
              <Tooltip title={!drawerOpen ? 'Configuración' : ''} placement="right">
                <ListItemButton
                  onClick={() => {
                    if (!drawerOpen) {
                      setDrawerOpen(true);
                      setConfigMenuOpen(true);
                    } else {
                      setConfigMenuOpen(prev => !prev);
                    }
                  }}
                  sx={{
                    borderRadius: '12px',
                    px: drawerOpen ? 2 : 0,
                    py: 1.25,
                    justifyContent: drawerOpen ? 'initial' : 'center',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      backgroundColor: 'rgba(102, 126, 234, 0.06)',
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: '#6b7280',
                      minWidth: drawerOpen ? 44 : 'auto',
                      mr: drawerOpen ? undefined : 0,
                      justifyContent: 'center',
                    }}
                  >
                    <AdminPanelSettingsIcon />
                  </ListItemIcon>
                  {drawerOpen && (
                    <>
                      <ListItemText
                        primary="Configuración"
                        primaryTypographyProps={{
                          fontSize: '0.9375rem',
                          fontWeight: 600,
                          color: '#4b5563',
                        }}
                      />
                      {configMenuOpen ? <ExpandLess sx={{ color: '#9ca3af' }} /> : <ExpandMore sx={{ color: '#9ca3af' }} />}
                    </>
                  )}
                </ListItemButton>
              </Tooltip>
            </ListItem>
            {drawerOpen && (
              <Collapse in={configMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ pl: 1 }}>
                  {configItems.map(item => renderMenuItem(item, true))}
                </List>
              </Collapse>
            )}
          </>
        )}

      </List>
    </Box>

  );



  return (
    <DialerProvider value={{ handleRedialFromAgentCalls }}>
    <ChatProvider>
      <Box sx={{ display: 'flex' }}>

      <AppBar

        position="fixed"

        sx={{

          width: immersiveMode ? '100%' : { md: `calc(100% - ${drawerOpen ? drawerWidth : drawerMiniWidth}px)` },

          ml: immersiveMode ? 0 : { md: `${drawerOpen ? drawerWidth : drawerMiniWidth}px` },

          transition: theme.transitions.create(['width', 'margin'], {

            easing: theme.transitions.easing.sharp,

            duration: theme.transitions.duration.leavingScreen,

          }),

          backgroundColor: 'white',

          color: 'text.primary',

          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',

        }}

      >

        <Toolbar sx={{ minHeight: 64, height: 64, alignItems: 'center' }}>

          <IconButton

            color="inherit"

            aria-label="toggle drawer"

            edge="start"

            onClick={handleDrawerToggle}

            sx={{ mr: 2 }}

          >

            {drawerOpen ? <ChevronLeft /> : <MenuIcon />}

          </IconButton>

          

          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>

            {menuItems.find(item => item.path === location.pathname)?.text || 'Enigma'}

          </Typography>



          {/* Softphone Status and Controls */}

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>

            {screenShareAgentId && (
              <Tooltip title={screenShareActive ? 'Detener compartir pantalla' : 'Compartir pantalla'}>
                <IconButton
                  size="small"
                  onClick={screenShareActive ? stopScreenShare : startScreenShare}
                  sx={{ color: screenShareActive ? 'primary.main' : 'inherit' }}
                >
                  {screenShareActive ? <StopScreenShareIcon /> : <ScreenShareIcon />}
                </IconButton>
              </Tooltip>
            )}



            {/* Client Data Panel Toggle (available when we have data) */}

            {shouldShowClientDataButton && canAction('allow_client_data_panel') && (

              <Tooltip title="Datos del Cliente">

                <IconButton

                  size="small"

                  onClick={handleClientDataPanelToggle}

                  sx={{

                    color: clientDataPanelOpen ? 'primary.main' : 'inherit',

                    '@keyframes pulse': {

                      '0%': { opacity: 1 },

                      '50%': { opacity: 0.5 },

                      '100%': { opacity: 1 }

                    },

                    animation: (inCall || isPreviewClientData) ? 'pulse 2s infinite' : 'none'

                  }}

                >

                  <Person />

                </IconButton>

              </Tooltip>

            )}



            {/* Incoming Call Controls when autoAnswer is false */}

            {status === "Llamada entrante" && !config.autoAnswer && (

              <>

                <Chip

                  label="Llamada entrante"

                  size="small"

                  color="warning"

                  variant="filled"

                  sx={{ mr: 1, fontWeight: 'bold' }}

                />

                <Tooltip title="Contestar">

                  <IconButton

                    size="small"

                    onClick={contextAnswer}

                    sx={{ color: 'success.main' }}

                  >

                    <CallReceived />

                  </IconButton>

                </Tooltip>

                <Tooltip title="Rechazar">

                  <IconButton

                    size="small"

                    onClick={contextReject}

                    sx={{ color: 'error.main' }}

                  >

                    <CallEnd />

                  </IconButton>

                </Tooltip>

              </>

            )}



            {/* Call Controls when in call */}
            {inCall && (
              <>
                <Chip
                  label={callDuration}
                  size="small"
                  color="info"
                  variant="filled"
                  sx={{ mr: 1, fontFamily: 'monospace', fontWeight: 'bold' }}
                />

                {isMonitoringCall && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      '@keyframes monitoringMarquee': {
                        '0%': { transform: 'translateX(0)' },
                        '100%': { transform: 'translateX(-100%)' }
                      }
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: 160,
                        maxWidth: 260,
                        px: 1.2,
                        py: 0.4,
                        borderRadius: 1,
                        backgroundColor: 'grey.100',
                        overflow: 'hidden'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          whiteSpace: 'nowrap',
                          display: 'inline-block',
                          fontWeight: 'bold',
                          animation: marqueeShouldScroll ? 'monitoringMarquee 10s linear infinite' : 'none',
                          pr: 2
                        }}
                      >
                        {monitoringAgentLabel
                          ? `Monitoreando ${monitoringAgentLabel}`
                          : 'Monitoreando agente'}
                      </Typography>
                    </Box>
                    <Button
                      variant={contextMuted ? 'contained' : 'outlined'}
                      color="secondary"
                      size="small"
                      onClick={handleMonitoringMicrophoneToggle}
                      startIcon={contextMuted ? <Mic fontSize="small" /> : <MicOff fontSize="small" />}
                    >
                      {contextMuted ? 'Hablar' : 'Silenciar'}
                    </Button>
                  </Box>
                )}

                {!isMonitoringCall && clientPhoneLabel && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      '@keyframes clientPhoneMarquee': {
                        '0%': { transform: 'translateX(0)' },
                        '100%': { transform: 'translateX(-100%)' }
                      }
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: 160,
                        maxWidth: 260,
                        px: 1.2,
                        py: 0.4,
                        borderRadius: 1,
                        backgroundColor: 'grey.100',
                        overflow: 'hidden'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          whiteSpace: 'nowrap',
                          display: 'inline-block',
                          fontWeight: 'bold',
                          animation: clientPhoneMarquee ? 'clientPhoneMarquee 10s linear infinite' : 'none',
                          pr: 2
                        }}
                      >
                        {clientPhoneLabel}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {!isMonitoringCall && canAction('allow_mute_call') && (
                  <Tooltip title={contextMuted ? "Desmutear" : "Mutear"}>
                    <IconButton
                      size="small"
                      onClick={contextToggleMute}
                      sx={{ color: contextMuted ? 'error.main' : 'inherit' }}
                    >
                      {contextMuted ? <MicOff /> : <Mic />}
                    </IconButton>
                  </Tooltip>
                )}
                {!isMonitoringCall && inCall && canAction('allow_hold_call') && (() => {
                  const activeCallId = currentCallId || (contextCalls ? Object.keys(contextCalls)[0] : null);
                  if (!activeCallId) return null;
                  const currentState = contextCalls?.[activeCallId]?.state;
                  const isHeld = currentState === 'held';
                  return (
                    <Tooltip title={isHeld ? "Retomar llamada" : "Poner en espera"}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          if (isHeld && contextResumeCall) {
                            contextResumeCall(activeCallId);
                          } else if (!isHeld && contextHoldCall) {
                            contextHoldCall(activeCallId);
                          }
                        }}
                        sx={{ color: isHeld ? 'warning.main' : 'inherit' }}
                      >
                        {isHeld ? <PlayArrow /> : <Pause />}
                      </IconButton>
                    </Tooltip>
                  );
                })()}
                {canAction('allow_hangup_call') && (
                <Tooltip title={canHangup ? "Colgar" : "Espera 5 segundos..."}>

                  <span>

                    <IconButton

                      size="small"

                      onClick={contextHangup}

                      disabled={!canHangup}

                      sx={{
                        color: canHangup ? 'error.main' : 'action.disabled',
                        cursor: canHangup ? 'pointer' : 'not-allowed'
                      }}

                    >

                      <CallEnd />

                    </IconButton>

                  </span>

                </Tooltip>
                )}

              </>

            )}



            {/* Conference indicator in AppBar */}
            {conferenceParticipants?.length > 0 && inCall && (
              <Chip
                size="small"
                icon={<Groups sx={{ fontSize: 14 }} />}
                label={`Conf. (${conferenceParticipants.length + 1})`}
                color="info"
                variant="filled"
                sx={{ ml: 0.5, '& .MuiChip-label': { fontSize: '0.7rem' } }}
              />
            )}

            {/* Dialpad Icon */}
            {/* Visible en pausa o durante llamada (para segunda llamada / multi-call) */}
            {(inCall ? canAction('allow_second_call') : true) && (inCall || (!inCall && agentStatus !== 'ACW' && agentStatus !== 'AVAILABLE' && agentStatus !== 'INCALL' && agentStatus !== 'OFFLINE')) && (

              <Tooltip title={inCall ? "Marcar segunda llamada" : "Abrir marcador"}>

                <IconButton

                  size="small"

                  onClick={handleDialerOpen}

                  sx={{ color: 'primary.main' }}

                >

                  <Dialpad />

                </IconButton>

              </Tooltip>

            )}



            {/* Agent Status Indicator */}

            <Tooltip title={`Estado del Agente: ${getCurrentStatusInfo()?.label || 'Desconocido'} - ${agentStatusDuration}`}>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                {getCurrentStatusInfo()?.icon && React.createElement(getCurrentStatusInfo().icon, { sx: { fontSize: '20px', color: getCurrentStatusInfo()?.color } })}

                <Chip

                  label={`${getCurrentStatusInfo()?.label || 'Desconocido'} ${agentStatusDuration}`}

                  size="small"

                  sx={{

                    backgroundColor: getCurrentStatusInfo()?.color || '#757575',

                    color: 'white',

                    fontWeight: 'bold',

                    display: { xs: 'none', sm: 'flex' }

                  }}

                />

              </Box>

            </Tooltip>


          </Box>



          <IconButton color="inherit" sx={{ mr: 1 }} onClick={(e) => { setWallNotifAnchor(e.currentTarget); }}>

            <Badge badgeContent={wallNotifCount} color="error">

              <Notifications />

            </Badge>

          </IconButton>

          <Popover
            open={Boolean(wallNotifAnchor)}
            anchorEl={wallNotifAnchor}
            onClose={() => { setWallNotifAnchor(null); setWallNotifCount(0); if (api?.wall?.markRead) api.wall.markRead().catch(() => {}); }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { borderRadius: 2, width: 340, maxHeight: 400 } }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Notificaciones</Typography>
            </Box>
            {wallNotifs.length === 0 ? (
              <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">Sin notificaciones nuevas</Typography>
              </Box>
            ) : (
              <List dense sx={{ py: 0, maxHeight: 320, overflow: 'auto' }}>
                {wallNotifs.map((n) => (
                  <ListItem key={n.id} button onClick={() => { setWallNotifAnchor(null); setWallNotifCount(0); navigate('/wall'); }}
                    sx={{ py: 1, '&:hover': { bgcolor: 'action.hover' } }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <ArticleIcon fontSize="small" color={n.priority === 'urgent' ? 'error' : n.priority === 'important' ? 'warning' : 'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={n.title || 'Nueva publicacion'}
                      secondary={`${n.author_name} - ${n.post_type === 'announcement' ? 'Comunicado' : n.post_type === 'notification' ? 'Notificacion' : 'General'}`}
                      primaryTypographyProps={{ variant: 'body2', fontWeight: 500, noWrap: true }}
                      secondaryTypographyProps={{ variant: 'caption' }}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Popover>



          <IconButton

            size="large"

            aria-label="account of current user"

            aria-controls="menu-appbar"

            aria-haspopup="true"

            onClick={handleAvatarIconClick}

            color="inherit"

            disableRipple
            disableFocusRipple

            onMouseDown={() => setAvatarPressed(true)}
            onMouseUp={() => setTimeout(() => setAvatarPressed(false), 120)}
            onMouseLeave={() => setAvatarPressed(false)}

            sx={{
              position: 'relative',
              width: 72,
              height: 72,
              overflow: 'visible',
              p: 0.5,
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.04)'
              },
              '&:hover .avatarRing': {
                transform: 'scale(1.04)',
                boxShadow: '0 4px 10px rgba(0,0,0,0.25)'
              }
            }}

          >

            <Box

              sx={{

                position: 'absolute',

                top: 14,

                right: 0,

                p: 0,

                borderRadius: '50%',

                border: `3px solid ${getCurrentStatusInfo().color}`,

                display: 'flex',

                alignItems: 'center',

                justifyContent: 'center',

                overflow: 'visible',

                transform: avatarPressed ? 'scale(1.12)' : 'scale(1)',
                transition: 'transform 120ms ease',

                '@keyframes avatarPulse': {
                  '0%': { transform: 'scale(1)', opacity: 0.4 },
                  '100%': { transform: 'scale(1.35)', opacity: 0 }
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  inset: -4,
                  borderRadius: '50%',
                  border: `3px solid ${getCurrentStatusInfo().color}`,
                  opacity: 0,
                  transform: 'scale(1)',
                  transition: 'opacity 0.3s ease',
                  pointerEvents: 'none'
                },

                '&:hover::after': {
                  opacity: 1,
                  animation: 'avatarPulse 1s ease-out'
                },

              }}
              className="avatarRing"

            >

              <Avatar
                sx={{
                  width: 65,
                  height: 65,
                  bgcolor: 'primary.main',
                  transform: avatarPressed ? 'scale(1.08)' : 'scale(1)',
                  transition: 'transform 120ms ease'
                }}
                src={userAvatarUrl || undefined}
              >
                {!userAvatarUrl && (user?.name?.charAt(0) || user?.username?.charAt(0) || 'A')}
              </Avatar>

            </Box>

          </IconButton>

          

          <Menu

            id="menu-appbar"

            anchorEl={anchorEl}

            anchorOrigin={{

              vertical: 'bottom',

              horizontal: 'right',

            }}

            keepMounted

            transformOrigin={{

              vertical: 'top',

              horizontal: 'right',

            }}

            open={Boolean(anchorEl)}

            onClose={handleMenuClose}

            slotProps={{
              paper: {
                sx: {
                  minWidth: 220,
                  maxWidth: 220
                }
              }
            }}

          >

            {/* Agent Name and Softphone Status */}
            <Box sx={{ px: 2, py: 1.5, mb: 1, textAlign: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {user?.name || user?.username || 'Agente'}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 0.5 }}>
                {inCall ? (
                  <Phone sx={{ color: 'info.main', fontSize: 16 }} />
                ) : registered ? (
                  <PhoneEnabled sx={{ color: 'success.main', fontSize: 16 }} />
                ) : connected ? (
                  <PhoneEnabled sx={{ color: 'warning.main', fontSize: 16 }} />
                ) : (
                  <PhoneDisabled sx={{ color: 'error.main', fontSize: 16 }} />
                )}
                <Typography variant="caption" color="text.secondary">
                  {inCall
                    ? monitoringMode === 'conference'
                      ? 'Conferencia'
                      : isMonitoringCall
                        ? 'Escuchando'
                        : (conferenceParticipants?.length > 0)
                          ? 'Conferencia'
                          : 'En llamada'
                    : registered
                      ? 'Registrado'
                      : connected
                        ? 'Conectado'
                        : 'Desconectado'}
                </Typography>
              </Box>
            </Box>

            <Divider />

            {/* Agent Status Section */}

            {canAction('change_status') && (<>

            <Box sx={{ px: 2, py: 1 }}>

              <Typography variant="subtitle2" color="text.secondary">

                Estado del Agente

              </Typography>

            </Box>

            {getSelectableStatuses()
              .filter(s => s.key !== 'OFFLINE' && s.key !== agentStatus)
              .map((statusInfo) => {
                // Deshabilitar si falta menos de 5 segundos para auto-tipificación
                const isNearAutoTip = agentStatus === 'ACW' && autoTypificationTimeLeft !== null && autoTypificationTimeLeft < 5;
                const isDisabled = statusLoading || isNearAutoTip;

                return (
                  <MenuItem

                    key={statusInfo.key}

                    onClick={() => handleStatusChange(statusInfo.key)}

                    selected={agentStatus === statusInfo.key}

                    disabled={isDisabled}

                    sx={{

                      pl: 3,

                      opacity: isDisabled ? 0.6 : 1,

                  '&.Mui-selected': {

                    backgroundColor: `${statusInfo.color}15`,

                    '&:hover': {

                      backgroundColor: `${statusInfo.color}25`,

                    }

                  }

                }}

              >

                <ListItemIcon sx={{ minWidth: 32, color: statusInfo.color }}>

                  {React.createElement(statusInfo.icon, { fontSize: 'small' })}

                </ListItemIcon>

                <ListItemText

                  primary={statusInfo.label}

                  primaryTypographyProps={{ variant: 'body2' }}

                />

                {agentStatus === statusInfo.key && (

                  <Typography variant="caption" color="primary" sx={{ ml: 1 }}>

                    ✓

                  </Typography>

                )}

              </MenuItem>
                );
              })}
            </>)}

            <Divider sx={{ my: 1 }} />



            {/* Regular Menu Items */}

            {canAction('access_profile') && (
            <MenuItem onClick={handleProfileClick}>

              <ListItemIcon>

                <AccountCircle fontSize="small" />

              </ListItemIcon>

              Mi Perfil

            </MenuItem>
            )}

            <Divider />

            <MenuItem onClick={handleLogout}>

              <ListItemIcon>

                <Logout fontSize="small" />

              </ListItemIcon>

              Cerrar Sesión

            </MenuItem>

          </Menu>

        </Toolbar>

      </AppBar>



      <Box

        component="nav"

        sx={{

          display: immersiveMode ? 'none' : 'block',

          width: immersiveMode ? 0 : { xs: 0, md: drawerOpen ? drawerWidth : drawerMiniWidth },

          flexShrink: immersiveMode ? 0 : { md: 0 },

          transition: theme.transitions.create('width', {

            easing: theme.transitions.easing.sharp,

            duration: theme.transitions.duration.leavingScreen,

          }),

        }}

        aria-label="mailbox folders"

      >

        {!immersiveMode && (

        <Drawer

          variant={isMobile ? "temporary" : "permanent"}

          open={isMobile ? drawerOpen : true}

          onClose={handleDrawerToggle}

          ModalProps={{

            keepMounted: true, // Better mobile performance

          }}

          sx={{

            '& .MuiDrawer-paper': {

              boxSizing: 'border-box',

              width: drawerOpen ? drawerWidth : drawerMiniWidth,

              borderRight: '1px solid rgba(0, 0, 0, 0.08)',

              overflowX: 'hidden',

              transition: theme.transitions.create('width', {

                easing: theme.transitions.easing.sharp,

                duration: theme.transitions.duration.enteringScreen,

              }),

            },

          }}

        >

          {drawer}

        </Drawer>

        )}

      </Box>



      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, mt: '64px' }}> {/* Add top margin for AppBar */}

        {/* Panel de llamadas activas - visible cuando hay 2+ llamadas */}
        {contextCalls && Object.keys(contextCalls).length > 1 && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 0.75,
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            flexShrink: 0,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            zIndex: 10
          }}>
            <Phone sx={{ fontSize: 18, color: 'primary.main' }} />
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mr: 1 }}>
              Llamadas ({Object.keys(contextCalls).length}):
            </Typography>
            {Object.entries(contextCalls).map(([cId, cInfo]) => {
              const isActive = cId === currentCallId;
              const isHeld = cInfo.state === 'held';
              const label = cInfo.callData?.callNumber || cInfo.callData?.phone_number || cInfo.callData?.phone || (() => { const parts = cId.split('_'); return parts.length >= 4 ? parts[3] : cId.substring(0, 10); })();
              const stateLabel = isActive ? 'Activa' : isHeld ? 'En espera' : cInfo.state === 'conference' ? 'Conferencia' : '';
              return (
                <Box key={cId} sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: isActive ? 'success.main' : isHeld ? 'warning.main' : 'divider',
                  bgcolor: isActive ? 'success.50' : isHeld ? 'warning.50' : 'transparent',
                  cursor: isHeld ? 'pointer' : 'default',
                  '&:hover': isHeld ? { bgcolor: 'action.hover' } : {}
                }}
                onClick={() => {
                  if (isHeld && contextSwitchCall && currentCallId) {
                    contextSwitchCall(currentCallId, cId);
                  }
                }}
                >
                  {isActive ? <Phone sx={{ fontSize: 16, color: 'success.main' }} /> : <Pause sx={{ fontSize: 16, color: 'warning.main' }} />}
                  <Box>
                    <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', lineHeight: 1.2 }}>
                      {label}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.65rem', color: isActive ? 'success.main' : 'warning.main' }}>
                      {stateLabel}
                    </Typography>
                  </Box>
                  {isHeld && (
                    <Tooltip title="Retomar llamada">
                      <IconButton size="small" sx={{ p: 0.25 }} onClick={(e) => {
                        e.stopPropagation();
                        if (contextSwitchCall && currentCallId) contextSwitchCall(currentCallId, cId);
                      }}>
                        <SwapHoriz sx={{ fontSize: 16, color: 'primary.main' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {contextMergeCall && Object.keys(contextCalls).length >= 2 && (
                    <Tooltip title="Unir a conferencia">
                      <IconButton size="small" sx={{ p: 0.25 }} onClick={(e) => {
                        e.stopPropagation();
                        const primary = currentCallId || cId;
                        const secondary = isActive
                          ? Object.keys(contextCalls).find(id => id !== cId)
                          : cId;
                        if (primary && secondary && primary !== secondary) {
                          contextMergeCall(primary, secondary);
                        }
                      }}>
                        <CallMerge sx={{ fontSize: 14, color: 'info.main' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Colgar esta llamada">
                    <IconButton size="small" sx={{ p: 0.25 }} onClick={(e) => {
                      e.stopPropagation();
                      if (contextHangup) contextHangup(cId);
                    }}>
                      <CallEnd sx={{ fontSize: 14, color: 'error.main' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              );
            })}
            {Object.keys(contextCalls).length >= 2 && contextMergeCall && (
              <Tooltip title="Unir todas las llamadas en conferencia">
                <Button
                  size="small"
                  variant="outlined"
                  color="info"
                  startIcon={<CallMerge sx={{ fontSize: 16 }} />}
                  onClick={() => {
                    const callIds = Object.keys(contextCalls);
                    const primary = currentCallId || callIds[0];
                    const others = callIds.filter(id => id !== primary);
                    // Merge all non-primary calls one by one into the primary
                    others.forEach(secId => {
                      contextMergeCall(primary, secId);
                    });
                  }}
                  sx={{ ml: 'auto', textTransform: 'none', fontSize: '0.75rem', py: 0.25 }}
                >
                  Unir todas
                </Button>
              </Tooltip>
            )}
          </Box>
        )}

        {/* Conference participants banner */}
        {conferenceParticipants?.length > 0 && inCall && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 0.75,
            bgcolor: 'info.50',
            borderBottom: '1px solid',
            borderColor: 'info.200',
            flexShrink: 0,
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            zIndex: 10
          }}>
            <Groups sx={{ fontSize: 18, color: 'info.main' }} />
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'info.main', mr: 0.5 }}>
              Conferencia:
            </Typography>
            {conferenceParticipants.map((p) => (
              <Chip
                key={p.callId}
                size="small"
                icon={<Phone sx={{ fontSize: 14 }} />}
                label={p.phoneNumber || (() => { const parts = (p.callId || '').split('_'); return parts.length >= 4 ? parts[3] : p.callId?.substring(0, 10); })()}
                color="info"
                variant="outlined"
                onDelete={() => {
                  if (contextHangupConfParticipant) {
                    contextHangupConfParticipant(p.callId);
                  }
                }}
                deleteIcon={
                  <Tooltip title="Colgar participante">
                    <CallEnd sx={{ fontSize: 14 }} />
                  </Tooltip>
                }
                sx={{
                  '& .MuiChip-label': { fontSize: '0.75rem' },
                  '& .MuiChip-deleteIcon': { color: 'error.main', '&:hover': { color: 'error.dark' } }
                }}
              />
            ))}
          </Box>
        )}

        {/* Banner de desconexión */}
        <Snackbar
          open={connected === false}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ top: '70px !important' }}
        >
          <Alert severity="warning" variant="filled" sx={{ width: '100%', fontSize: '0.9rem' }}>
            Conexión perdida — Reconectando...
          </Alert>
        </Snackbar>

        <Box sx={{ display: 'flex', flex: 1 }}>
        <Box

          component="main"

          sx={{

            flexGrow: 1,

            p: immersiveMode || location.pathname === '/chat' ? 0 : '10px',

            width: immersiveMode

              ? '100%'

              : { md: `calc(100% - ${drawerOpen ? drawerWidth : 0}px - ${clientDataPanelOpen && canAction('allow_client_data_panel') ? '320px' : '0px'} - ${typificationPanelOpen ? '320px' : '0px'})` },

            minHeight: immersiveMode ? 'calc(100vh - 64px)' : 'calc(100vh - 64px)', // Adjust for AppBar height

            backgroundColor: immersiveMode ? 'transparent' : 'background.default',

            transition: theme.transitions.create('width', {

              easing: theme.transitions.easing.sharp,

              duration: theme.transitions.duration.leavingScreen,

            }),

          }}

          onMouseDownCapture={() => {

            if (!drawerPinned && location.pathname === '/dashboard' && drawerOpen) {

              setDrawerOpen(false);

            }

          }}

        >

          {children}



          {/* Hidden Softphone component to maintain functionality */}

          <Box sx={{ display: 'none' }}>

            <Softphone />
            <SupervisorMonitorSfu />

          </Box>

        </Box>



        {/* Client Data Panel */}

        {clientDataPanelOpen && canAction('allow_client_data_panel') && (
          <ClientDataPanel
            skillData={callClientData?.skillData ? callClientData : clientDataSnapshot}
            onClose={handleClientDataPanelClose}
            pendingTypification={pendingTypification}
            agentStatusStartTime={agentStatusStartTime}
            agentStatus={agentStatus}
          />
        )}



        {/* Typification Panel */}

        {typificationPanelOpen && (

          <Box sx={{ width: 320, height: 'calc(100vh - 64px)', overflow: 'hidden' }}>

            <CallTypificationPanel

              open={typificationPanelOpen}

              onClose={handleTypificationClose}

              onSubmit={handleTypificationSubmit}

              onSubmitAndContinue={handleTypificationSubmitAndContinue}

              isPreviewMode={true}
              showToggleButton

              callInfo={lastCallInfo}

              groupId={typificationGroupId}

              skillDef={currentSkillDef}

              inline={true}

              autoTypificationTimeLeft={autoTypificationTimeLeft}
              autoTypificationMaxTime={resolveSkillConfigForTypification()?.script_maxtime_sec || null}
              isInGracePeriod={isInGracePeriod}

            />

          </Box>

        )}

      </Box>
      </Box>



      {/* Profile Dialog */}
      <Dialog
        open={profileOpen}
        onClose={handleProfileClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Mi Perfil</DialogTitle>
          <DialogContent sx={{ pb: 1 }}>
          {profileLoading ? (
            <Box sx={{ py: 2 }}>
              <LinearProgress />
            </Box>
          ) : (
            <Stack spacing={3} sx={{ mt: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative'
                }}
              >
                <Box
                  onClick={handleOpenAvatarMenu}
                sx={{
                  position: 'relative',
                  width: 118,
                  height: 118,
                  borderRadius: '50%',
                  cursor: 'pointer',
                  overflow: 'visible',
                  border: `4px solid ${getCurrentStatusInfo().color}`,
                  boxShadow: `0 0 0 4px ${getCurrentStatusInfo().color}22`,
                  '&:hover .avatarOverlay': {
                    opacity: 1
                  }
                }}
              >
                <Avatar
                  src={profileForm.avatarUrl || undefined}
                  sx={{ width: '100%', height: '100%', bgcolor: 'primary.main' }}
                >
                  {profileForm.name?.charAt(0) || user?.name?.charAt(0) || user?.username?.charAt(0) || 'A'}
                </Avatar>
                <Box
                  className="avatarOverlay"
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    bgcolor: 'rgba(0,0,0,0.45)',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                    opacity: 0,
                    transition: 'opacity 0.2s ease',
                    borderRadius: '50%'
                  }}
                >
                  <PhotoCamera fontSize="small" />
                  <span style={{ fontWeight: 600, lineHeight: 1, textAlign: 'center', background: 'transparent' }}>Cambiar Avatar</span>
                </Box>
                </Box>
                <input
                  ref={profileAvatarInputRef}
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleAvatarSelected}
                />
                <input
                  ref={profileCameraInputRef}
                  type="file"
                  accept="image/*"
                  capture="user"
                  hidden
                  onChange={handleCameraCapture}
                />
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                  gap: 1.5,
                  width: '100%',
                  '& .grid-span-2': {
                    gridColumn: { xs: '1 / -1', sm: '1 / -1' }
                  }
                }}
              >
                <TextField
                  className="grid-span-2"
                  label="Nombre"
                  value={profileForm.name}
                  onChange={(e) => handleProfileFieldChange('name', e.target.value)}
                  fullWidth
                  size="small"
                  InputProps={{ readOnly: !canAction('edit_name_profile') }}
                  disabled={!canAction('edit_name_profile')}
                />

                <TextField
                  label="Documento"
                  value={profileForm.documentNumber}
                  fullWidth
                  size="small"
                  InputProps={{ readOnly: true, disabled: true }}
                />
                <TextField
                  label="ID Agente"
                  value={profileForm.agentId}
                  fullWidth
                  size="small"
                  InputProps={{ readOnly: true, disabled: true }}
                />

                {canAction('change_password_profile') && (
                <TextField
                  label="Nueva contraseña"
                  type="password"
                  value={profileForm.newPassword}
                  onChange={(e) => handleProfileFieldChange('newPassword', e.target.value)}
                  fullWidth
                  size="small"
                  autoComplete="new-password"
                />
                )}
                {canAction('change_password_profile') && (
                <TextField
                  label="Confirmar contraseña"
                  type="password"
                  value={profileForm.confirmPassword}
                  onChange={(e) => handleProfileFieldChange('confirmPassword', e.target.value)}
                  fullWidth
                  size="small"
                  autoComplete="new-password"
                />
                )}

                {canAction('edit_message_profile') && (
                <TextField
                  className="grid-span-2"
                  label="Mensaje personalizado (se mostrará al inicio)"
                  value={profileForm.message}
                  onChange={(e) => handleProfileFieldChange('message', e.target.value)}
                  fullWidth
                  size="small"
                  multiline
                  minRows={2}
                />
                )}
              </Box>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleProfileClose} disabled={profileSaving}>Cancelar</Button>
          <Button
            onClick={handleProfileSave}
            variant="contained"
            disabled={profileSaving || profileLoading}
          >
            {profileSaving ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={avatarMenuAnchorEl}
        open={Boolean(avatarMenuAnchorEl)}
        onClose={handleCloseAvatarMenu}
      >
        <MenuItem onClick={() => { setAvatarPreviewOpen(true); handleCloseAvatarMenu(); }} disabled={!profileForm.avatarUrl}>
          <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
          <ListItemText primary="Ver avatar" />
        </MenuItem>
        {canAction('change_avatar') && (
        <MenuItem onClick={() => profileCameraInputRef.current?.click()}>
          <ListItemIcon><PhotoCamera fontSize="small" /></ListItemIcon>
          <ListItemText primary="Tomar foto" />
        </MenuItem>
        )}
        {canAction('change_avatar') && (
        <MenuItem onClick={() => profileAvatarInputRef.current?.click()}>
          <ListItemIcon><CloudUpload fontSize="small" /></ListItemIcon>
          <ListItemText primary="Subir imagen" />
        </MenuItem>
        )}
        {canAction('change_avatar') && (
        <MenuItem onClick={handleOpenAvatarSelector}>
          <ListItemIcon><ImageSearch fontSize="small" /></ListItemIcon>
          <ListItemText primary="Seleccionar avatar" />
        </MenuItem>
        )}
        {canAction('change_avatar') && (
        <MenuItem onClick={handleOpenAvatarCreator}>
          <ListItemIcon><Brush fontSize="small" /></ListItemIcon>
          <ListItemText primary="Crear avatar personalizado" />
        </MenuItem>
        )}
        {canAction('change_avatar') && (
        <MenuItem onClick={handleRemoveAvatar} disabled={!profileForm.avatarUrl && !profileAvatarFile}>
          <ListItemIcon><DeleteForever fontSize="small" /></ListItemIcon>
          <ListItemText primary="Eliminar" />
        </MenuItem>
        )}
      </Menu>

      <Dialog open={avatarPreviewOpen} onClose={() => setAvatarPreviewOpen(false)} PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}>
        <DialogTitle sx={{ display: 'none' }} />
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 0, backgroundColor: 'transparent' }}>
          <Avatar
            src={profileForm.avatarUrl || undefined}
            sx={{ width: 234, height: 234, bgcolor: 'primary.main' }}
          >
            {profileForm.name?.charAt(0) || user?.name?.charAt(0) || user?.username?.charAt(0) || 'A'}
          </Avatar>
        </DialogContent>
      </Dialog>

      <AvatarSelector
        open={avatarSelectorOpen}
        onClose={handleCloseAvatarSelector}
        onSelect={handleAvatarSelect}
        currentAvatar={profileForm.avatarUrl}
      />

      <AvatarCreator
        open={avatarCreatorOpen}
        onClose={handleCloseAvatarCreator}
        onSave={handleAvatarSelect}
      />

      {/* Dialer Dialog */}

      <Dialog

        open={dialerOpen}

        onClose={handleDialerClose}

        PaperProps={{

          sx: {

            width: '280px',

            maxWidth: '280px',

          }

        }}

      >

        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>

          Marcador

        </DialogTitle>

        <DialogContent sx={{ px: 2, py: 1 }}>

          {agentStatus !== 'PRECALL' && (
            // Cuando NO está en PRECALL, mostrar selector de skill normal
            <TextField
              fullWidth
              select
              label="Skill"
              value={selectedDialerSkill}
              onChange={(event) => setSelectedDialerSkill(event.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 2 }}
              disabled={skillsLoading || !agentSkills.length}
              helperText={
                skillsLoading
                  ? 'Cargando skills del agente...'
                  : !agentSkills.length
                    ? 'Sin skills Manual/Preview'
                    : undefined
              }
            >
              {agentSkills.map((skill) => (
                <MenuItem key={skill.id_skill || skill.skilldef} value={skill.skilldef}>
                  {skill.skillname || skill.skilldef}
                </MenuItem>
              ))}
            </TextField>
          )}

          {/* Display Number */}

          <TextField

            fullWidth

            value={dialNumber}
            onChange={handleDialInputChange}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                if (canMakeDialerCall) {
                  handleMakeCall();
                }
              }
            }}

            variant="outlined"

            size="small"

            placeholder="Número a marcar"

            sx={{ mb: 2 }}

            InputProps={{


              sx: { textAlign: 'center', fontSize: '1.2rem', fontFamily: 'monospace' }

            }}

          />



          {/* Dialpad Grid */}

          <Grid container spacing={1} sx={{ mb: 2 }}>

            {[

              ['1', '2', '3'],

              ['4', '5', '6'],

              ['7', '8', '9'],

              ['*', '0', '#']

            ].map((row, rowIndex) => (

              row.map((digit, colIndex) => (

                <Grid item xs={4} key={`${rowIndex}-${colIndex}`}>

                  <Button

                    fullWidth

                    variant="outlined"

                    onClick={() => onDialDigit(digit)}

                    sx={{

                      height: '48px',

                      fontSize: '1.2rem',

                      fontWeight: 'bold',

                      minWidth: 0,

                    }}

                  >

                    {digit}

                  </Button>

                </Grid>

              ))

            ))}

          </Grid>



          {/* Conference option - only when there's an active call */}
          {inCall && currentCallId && (
            <FormControlLabel
              control={
                <Switch
                  checked={addToConference}
                  onChange={(e) => setAddToConference(e.target.checked)}
                  size="small"
                  color="info"
                />
              }
              label="Agregar a conferencia"
              sx={{ mb: 1, ml: 0, '& .MuiFormControlLabel-label': { fontSize: '0.8rem' } }}
            />
          )}

          {/* Action Buttons */}

          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>

            <Tooltip title="Borrar último dígito">

              <IconButton

                onClick={handleBackspace}

                disabled={!dialNumber}

                color="primary"

              >

                <Backspace />

              </IconButton>

            </Tooltip>

            <Tooltip title="Limpiar">

              <IconButton

                onClick={handleClearDial}

                disabled={!dialNumber}

                color="error"

              >

                <Clear />

              </IconButton>

            </Tooltip>

          </Box>

        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2 }}>

          <Button onClick={handleDialerClose} color="secondary">

            Cancelar

          </Button>

          <Button

            onClick={handleMakeCall}

            variant="contained"

            color="primary"

            disabled={
              !canMakeDialerCall
            }

            startIcon={<Phone />}

          >

            {dialerCalling ? 'Llamando...' : (addToConference ? 'Agregar' : 'Llamar')}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Softphone Configuration Dialog */}

      <Dialog

        open={configOpen}

        onClose={() => setConfigOpen(false)}

        maxWidth="sm"

        fullWidth

      >

        <DialogTitle>

          Configuración Softphone

        </DialogTitle>

        <DialogContent>

          <TextField

            fullWidth

            label="Servidor WebSocket"

            value={config.wsServer}

            onChange={(e) => setConfig({ wsServer: e.target.value })}

            placeholder="wss://dominio/ws-asterisk"

            size="small"

            sx={{ mb: 2, mt: 1 }}

          />



          <Grid container spacing={2} sx={{ mb: 2 }}>

            <Grid item xs={6}>

              <TextField

                fullWidth

                label="Dominio/IP"

                value={config.domain}

                onChange={(e) => setConfig({ domain: e.target.value })}

                size="small"

              />

            </Grid>

            <Grid item xs={6}>

              <TextField

                fullWidth

                label="Usuario"

                value={config.user}

                onChange={(e) => setConfig({ user: e.target.value })}

                size="small"

              />

            </Grid>

            <Grid item xs={6}>

              <TextField

                fullWidth

                label="Contraseña"

                type="password"

                value={config.password}

                onChange={(e) => setConfig({ password: e.target.value })}

                size="small"

              />

            </Grid>

            <Grid item xs={6}>

              <TextField

                fullWidth

                label="STUN Server"

                value={config.stun}

                size="small"

                disabled

              />

            </Grid>

          </Grid>



          {/* Auto Answer Configuration */}

          <FormControlLabel

            control={

              <Switch

                checked={config.autoAnswer}

                onChange={(e) => setConfig({ autoAnswer: e.target.checked })}

                color="primary"

              />

            }

            label="Contestar llamadas automáticamente"

            sx={{ mb: 2 }}

          />



          <Stack direction="row" spacing={2} sx={{ mb: 3 }}>

            <Button

              variant="contained"

              color="success"

              onClick={contextConnect}

              startIcon={<Phone />}

              disabled={!config.wsServer || !config.domain || !config.user || !config.password}

            >

              Conectar

            </Button>

            <Button

              variant="contained"

              color="error"

              onClick={contextDisconnect}

              startIcon={<PhoneDisabled />}

            >

              Desconectar

            </Button>

          </Stack>



          {/* Audio Levels */}

          <Typography variant="subtitle2" gutterBottom>

            Niveles de Audio

          </Typography>

          <Box sx={{ mb: 1 }}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>

              <Typography variant="caption">Audio local</Typography>

              <Typography variant="caption">{audioLevels.localLevel}%</Typography>

            </Box>

            <LinearProgress

              variant="determinate"

              value={audioLevels.localLevel}

              color="success"

              sx={{ height: 8, borderRadius: 1 }}

            />

          </Box>

          <Box sx={{ mb: 2 }}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>

              <Typography variant="caption">Audio remoto</Typography>

              <Typography variant="caption">{audioLevels.remoteLevel}%</Typography>

            </Box>

            <LinearProgress

              variant="determinate"

              value={audioLevels.remoteLevel}

              color="primary"

              sx={{ height: 8, borderRadius: 1 }}

            />

          </Box>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setConfigOpen(false)}>

            Cerrar

          </Button>

        </DialogActions>

      </Dialog>



      <Dialog

        open={preSessionConflict}

        maxWidth="xs"

        fullWidth

        disableEscapeKeyDown

        PaperProps={{

          sx: {

            borderRadius: 3,

            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',

            backdropFilter: 'blur(16px)',

          }

        }}

        BackdropProps={{

          sx: {

            backgroundColor: 'rgba(0, 0, 0, 0.75)',

            backdropFilter: 'blur(8px)',

          }

        }}

      >

        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>

          Sesión activa detectada

        </DialogTitle>

        <DialogContent sx={{ textAlign: 'center' }}>

          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>

            El agente ya está logueado en otra sesión. ¿Qué deseas hacer?

          </Typography>

          {preSessionInfo?.lastHeartbeat && (

            <Typography variant="caption" color="text.secondary">

              Última conexión: {new Date(preSessionInfo.lastHeartbeat).toLocaleString()}

            </Typography>

          )}

        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>

          <Button
            onClick={handlePreSessionCancel}
            color="error"
            variant="outlined"
            size="large"
            disabled={agentLoading}
          >
            Cancelar
          </Button>

          <Button

            onClick={handlePreSessionForce}

            color="primary"

            variant="contained"

            size="large"

            disabled={agentLoading}

          >

            {agentLoading ? 'Procesando...' : 'Forzar logueo'}

          </Button>

      </DialogActions>

    </Dialog>



    <Dialog

        open={false}

        maxWidth="xs"

        fullWidth

        disableEscapeKeyDown

        PaperProps={{

          sx: {

            borderRadius: 3,

            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',

            backdropFilter: 'blur(16px)',

          }

        }}

        BackdropProps={{

          sx: {

            backgroundColor: 'rgba(0, 0, 0, 0.75)', // Más oscuro

            backdropFilter: 'blur(8px)', // Efecto de desenfoque

          }

        }}

      >

        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>

          Sesión en otro lugar

        </DialogTitle>

        <DialogContent sx={{ textAlign: 'center' }}>

          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>

            Tu sesión ha sido desconectada.

          </Typography>

        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>

          <Button

            onClick={handleGoToLogin}

            color="error"

            variant="outlined"

            size="large"

          >

            Ir al login

          </Button>

        </DialogActions>

      </Dialog>



      {/* Session Timeout Modal */}

      <Dialog

        open={sessionTimeout}

        maxWidth="xs"

        fullWidth

        disableEscapeKeyDown

        PaperProps={{

          sx: {

            borderRadius: 3,

            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',

            backdropFilter: 'blur(16px)',

          }

        }}

        BackdropProps={{

          sx: {

            backgroundColor: 'rgba(0, 0, 0, 0.75)',

            backdropFilter: 'blur(8px)',

          }

        }}

      >

        <DialogTitle sx={{ textAlign: 'center', pb: 1, color: 'warning.main' }}>

          ⏰ Sesión cerrada por inactividad

        </DialogTitle>

        <DialogContent sx={{ textAlign: 'center' }}>

          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>

            Tu sesión se cerró automáticamente debido a inactividad.

          </Typography>

          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>

            Esto puede suceder cuando la ventana del navegador está minimizada o en segundo plano por mucho tiempo.

          </Typography>

          {conflictInfo?.timestamp && (

            <Typography variant="caption" color="text.secondary">

              Desconectado: {new Date(conflictInfo.timestamp).toLocaleString()}

            </Typography>

          )}

        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>

          <Button

            onClick={handleRecoverFromTimeout}

            color="primary"

            variant="contained"

            size="large"

            sx={{ mr: 2 }}

          >

            Recargar y continuar

          </Button>

          <Button

            onClick={handleLogoutFromTimeout}

            color="error"

            variant="outlined"

            size="large"

          >

            Cerrar sesión

          </Button>

        </DialogActions>

      </Dialog>

      <ChatBubbles />

    </Box>
    </ChatProvider>
    </DialerProvider>
  );

};



export default DashboardLayout;
